var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _g2, _g3, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _g4, _g5, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _ellipse, _ellipse2, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _ellipse3, _ellipse4, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _g6, _g7, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _ellipse5, _ellipse6, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _ellipse7, _ellipse8, _path440, _path441, _path442, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 605,
    height: 551,
    viewBox: "0 0 605 551",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 245.129H45.1984L603.374 244.922L561.484 210.856L527.187 202.391L493.676 160.478L465.139 143.961L444.456 155.11L414.61 135.496L337.115 32.8835L291.036 109.069L239.198 135.496L190.24 111.34L152.016 156.349L118.767 148.71L28.1808 232.328L2 245.129Z",
    fill: "url(#paint0_linear_210_10376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 245.129H45.1984L603.374 244.922M2 245.129L88.6585 217.463L251.241 209.411L385.287 210.856L548.656 222.005L603.374 244.922M2 245.129L28.1808 232.328L118.767 148.71L152.016 156.349L190.24 111.34L239.198 135.496L291.036 109.069L337.115 32.8835L414.61 135.496L444.456 155.11L465.139 143.961L493.676 160.478L527.187 202.391L561.484 210.856L603.374 244.922",
    stroke: "url(#paint1_radial_210_10376)",
    strokeWidth: 1.09872
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 245.129H45.1984L603.374 244.922L548.656 222.005L385.287 210.856L251.242 209.411L88.6585 217.463L2 245.129Z",
    fill: "url(#paint2_linear_210_10376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.609 214.573L152.013 156.35L190.237 111.341L239.195 135.497L205.16 211.683L148.609 214.573Z",
    fill: "url(#paint3_linear_210_10376)",
    stroke: "url(#paint4_radial_210_10376)",
    strokeWidth: 1.09872
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.164 211.682L239.199 135.496L290.775 109.275L227.418 210.649L205.164 211.682Z",
    fill: "url(#paint5_linear_210_10376)",
    stroke: "url(#paint6_radial_210_10376)",
    strokeWidth: 1.09872
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.609 135.495L337.113 32.8824L363.556 130.54L410.42 165.433L444.455 155.109L414.609 135.495Z",
    fill: "url(#paint7_linear_210_10376)",
    stroke: "url(#paint8_radial_210_10376)",
    strokeWidth: 1.09872
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.847 210.373L250.801 208.928L226.977 210.108L290.596 108.586L336.674 32.4007L384.847 210.373Z",
    fill: "url(#paint9_linear_210_10376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.758 135.014L290.596 108.586M290.596 108.586L336.674 32.4007L384.847 210.373L250.801 208.928L226.977 210.108L290.596 108.586Z",
    stroke: "url(#paint10_radial_210_10376)",
    strokeWidth: 1.09872
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.418 165.432L385.285 210.854L363.555 130.54L410.418 165.432Z",
    fill: "url(#paint11_linear_210_10376)",
    stroke: "url(#paint12_radial_210_10376)",
    strokeWidth: 1.09872
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.239 214.982L410.419 165.431L385.285 210.853L445.239 214.982Z",
    fill: "url(#paint13_linear_210_10376)",
    stroke: "url(#paint14_radial_210_10376)",
    strokeWidth: 1.09872
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.732 190.621L465.14 143.961L444.457 155.11L410.422 165.433L445.242 214.984L459.904 216.017L472.732 190.621Z",
    fill: "url(#paint15_linear_210_10376)",
    stroke: "url(#paint16_radial_210_10376)",
    strokeWidth: 1.09872
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6585 217.463L2 245.129L88.6585 212.629L251.242 201.59L385.287 202.391L548.656 217.463L603.374 244.922L548.656 222.005L385.287 210.856L251.242 209.411L88.6585 217.463Z",
    fill: "url(#paint17_linear_210_10376)",
    stroke: "url(#paint18_radial_210_10376)",
    strokeWidth: 1.09872
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 244.133H45.1984L603.374 244.428L561.484 293.209L527.187 305.331L493.676 365.346L465.139 388.997L444.456 373.033L414.61 401.118L337.115 548.052L291.036 438.961L239.198 401.118L190.24 435.709L152.016 371.259L118.767 382.197L28.1808 262.463L2 244.133Z",
    fill: "url(#paint19_linear_210_10376)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 244.133H45.1984L603.374 244.428M2 244.133L88.6585 283.749L251.241 295.279L385.287 293.209L548.656 277.245L603.374 244.428M2 244.133L28.1808 262.463L118.767 382.197L152.016 371.259L190.24 435.709L239.198 401.118L291.036 438.961L337.115 548.052L414.61 401.118L444.456 373.033L465.139 388.997L493.676 365.346L527.187 305.331L561.484 293.209L603.374 244.428",
    stroke: "url(#paint20_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 244.133H45.1984L603.374 244.428L548.656 277.245L385.287 293.209L251.242 295.279L88.6585 283.749L2 244.133Z",
    fill: "url(#paint21_linear_210_10376)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.609 287.887L152.013 371.258L190.237 435.708L239.195 401.117L205.16 292.026L148.609 287.887Z",
    fill: "url(#paint22_linear_210_10376)",
    stroke: "url(#paint23_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.164 292.025L239.199 401.117L290.775 438.664L227.418 293.504L205.164 292.025Z",
    fill: "url(#paint24_linear_210_10376)",
    stroke: "url(#paint25_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M414.609 401.118L337.113 548.052L363.556 408.213L410.42 358.25L444.455 373.032L414.609 401.118Z",
    fill: "url(#paint26_linear_210_10376)",
    stroke: "url(#paint27_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M384.847 293.899L250.801 295.969L226.977 294.279L290.596 439.651L336.674 548.742L384.847 293.899Z",
    fill: "url(#paint28_linear_210_10376)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M238.758 401.809L290.596 439.651M290.596 439.651L336.674 548.742L384.847 293.899L250.801 295.969L226.977 294.279L290.596 439.651Z",
    stroke: "url(#paint29_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M410.418 358.25L385.285 293.209L363.555 408.214L410.418 358.25Z",
    fill: "url(#paint30_linear_210_10376)",
    stroke: "url(#paint31_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M445.239 287.297L410.419 358.251L385.285 293.21L445.239 287.297Z",
    fill: "url(#paint32_linear_210_10376)",
    stroke: "url(#paint33_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M472.732 322.181L465.14 388.996L444.457 373.032L410.422 358.25L445.242 287.296L459.904 285.817L472.732 322.181Z",
    fill: "url(#paint34_linear_210_10376)",
    stroke: "url(#paint35_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6585 283.749L2 244.133L88.6585 290.67L251.242 306.478L385.287 305.331L548.656 283.749L603.374 244.428L548.656 277.245L385.287 293.209L251.242 295.279L88.6585 283.749Z",
    fill: "url(#paint36_linear_210_10376)",
    stroke: "url(#paint37_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M466.253 200.131C466.656 199.528 467.664 198.723 467.865 198.321C468.067 197.919 468.067 196.109 468.47 195.505C468.873 194.902 470.485 192.287 470.888 191.684C471.291 191.08 471.493 188.667 470.485 188.465C469.478 188.264 467.865 192.086 467.059 192.086C466.253 192.086 466.455 191.281 466.656 191.08C466.858 190.879 470.082 186.253 469.478 184.644C468.873 183.035 468.873 180.219 466.656 180.219C464.439 180.219 463.633 182.23 463.633 183.236V187.862C463.633 188.667 462.626 189.27 461.416 189.27C460.207 189.27 459.401 188.465 459.401 187.862V182.029C459.401 182.029 459.401 179.816 457.789 180.219C456.177 180.621 454.363 183.638 454.363 185.247C454.363 186.856 455.37 188.465 455.572 189.471C455.774 190.477 455.169 191.684 454.766 191.684C454.363 191.684 454.363 190.074 454.363 189.471C454.363 188.868 453.557 186.856 452.751 186.856C451.944 186.856 452.348 189.069 451.944 190.074C451.541 191.08 453.154 193.695 453.154 193.695C453.154 193.695 452.952 195.505 452.751 195.907C452.549 196.31 453.758 197.114 453.758 197.114V204.355C453.758 205.361 452.348 207.573 451.541 207.775C450.735 207.976 445.496 202.344 445.496 202.344C445.496 202.344 434.411 190.074 436.225 177.805C438.039 165.536 455.774 144.416 455.774 144.416C455.774 144.416 466.656 109.016 455.774 60.9445C444.891 12.8728 433.807 0 433.807 0C433.807 0 429.373 16.2921 428.567 22.5273C427.761 28.7626 420.304 37.0092 420.304 37.0092C420.304 37.0092 413.251 19.9126 397.531 1.20682C397.531 1.20682 395.516 26.9524 394.307 31.9808C393.098 37.0092 389.47 42.8422 379.797 47.6695C378.789 70.3979 367.907 79.248 367.907 79.248C367.907 79.248 371.534 95.3389 371.333 101.775C371.131 108.212 371.333 116.056 365.488 126.314C377.58 142.606 375.162 164.128 375.162 164.128C375.162 164.128 387.656 178.811 389.672 187.661C391.687 196.511 386.649 208.579 386.649 208.579C384.23 207.372 370.728 208.981 370.728 208.981C370.728 208.981 372.743 211.395 371.937 210.792C371.131 210.188 368.108 211.395 368.108 211.395C368.108 211.395 370.728 214.814 370.728 217.831C370.728 220.848 370.123 223.061 368.914 223.463C367.705 223.865 349.97 231.106 343.32 233.721C336.669 236.336 324.981 236.939 320.748 235.129C316.516 233.319 313.292 230.905 312.687 231.106C312.083 231.308 313.292 233.118 313.292 233.118C313.292 233.118 305.029 225.475 303.82 221.854C302.611 218.234 299.386 207.573 298.58 208.981C297.774 210.389 299.991 221.854 299.991 221.854C299.991 221.854 297.774 216.222 296.968 214.211C296.162 212.2 293.945 212.401 292.937 208.981C291.93 205.562 287.698 215.015 288.907 218.234C290.116 221.452 293.139 228.089 297.371 229.698C301.603 231.308 310.47 234.325 310.672 235.531C310.874 236.738 307.246 236.939 307.246 236.939C307.246 236.939 310.47 238.951 314.098 238.347C317.726 237.744 330.422 238.75 335.057 238.347C339.692 237.945 349.567 236.336 353.598 234.727C357.628 233.118 404.182 218.636 406.802 224.67C406.802 224.67 407.205 227.687 406.197 228.894C405.19 230.101 403.376 229.698 402.368 230.905C401.36 232.112 399.95 235.33 399.748 236.738C399.547 238.146 397.934 242.772 396.927 243.175C395.919 243.577 394.912 241.163 393.904 241.364C392.896 241.566 392.09 242.772 392.09 244.583C392.09 246.393 393.702 252.829 393.904 254.841C394.105 256.852 391.687 257.455 393.098 258.059C394.508 258.662 399.748 258.059 400.957 258.059C402.167 258.059 400.151 256.651 399.345 256.249C398.539 255.846 397.934 253.231 397.733 252.025C397.531 250.818 397.733 248.203 397.934 246.795C398.136 245.387 401.36 242.169 402.57 240.359C403.779 238.548 412.042 230.905 413.654 230.503C415.266 230.101 417.483 225.475 417.483 225.475L422.723 227.486C422.723 227.486 420.304 228.492 420.304 229.296C420.304 230.101 418.491 235.531 417.483 236.939C416.475 238.347 411.235 237.543 411.034 238.548C410.832 239.554 410.631 241.767 412.646 242.571C414.661 243.376 420.103 248.605 420.506 248.605C420.909 248.605 421.513 250.013 421.312 250.617L421.312 250.617C421.11 251.221 419.901 254.841 420.103 255.645C420.304 256.45 421.312 257.254 422.723 257.053C424.133 256.852 423.932 255.243 424.335 254.237C424.738 253.231 424.335 250.214 423.932 248.605C423.529 246.996 419.095 243.175 419.297 240.359C419.498 237.543 429.575 228.29 429.575 228.29C429.575 228.29 432.195 229.698 433.605 230.503C435.016 231.308 438.039 231.71 438.039 231.71C438.039 231.71 437.837 234.928 438.442 235.934C439.047 236.939 441.263 238.951 442.473 239.755C443.682 240.56 447.108 242.973 447.914 244.18C448.72 245.387 448.518 246.393 448.518 248.404C448.518 250.416 445.697 252.226 445.899 253.634C446.1 255.042 450.937 256.249 451.34 256.249C451.743 256.249 451.743 258.26 452.549 258.26C453.355 258.26 455.572 258.662 456.378 258.662C457.184 258.662 456.781 258.26 456.781 258.26L460.207 257.858C460.207 256.45 456.378 256.45 455.37 255.846C454.363 255.243 453.758 252.829 453.557 252.226C453.355 251.622 453.355 251.019 453.355 250.416C453.355 249.812 453.154 247.398 453.355 245.588C453.557 243.778 455.169 237.543 455.37 235.934C455.572 234.325 454.564 233.319 454.766 231.71C454.967 230.101 460.61 223.262 460.812 221.854C461.013 220.446 461.215 217.63 461.215 216.423C461.215 215.217 463.23 211.797 463.633 210.188C464.036 208.579 464.439 204.959 464.439 203.953C464.439 202.947 465.85 200.735 466.253 200.131Z",
    fill: "url(#paint38_linear_210_10376)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M455.778 144.416C455.778 144.416 466.661 109.016 455.778 60.9445C449.151 31.6716 442.45 15.4508 438.222 7.24093C438.222 7.24093 444.492 21.9239 446.306 29.1649C448.12 36.4058 453.158 52.899 455.375 64.3638C457.592 75.8286 458.801 88.7014 458.6 104.39C458.398 120.079 453.763 137.779 453.763 137.779C453.763 137.779 451.748 119.878 451.748 114.648C451.748 109.419 435.222 75.4264 435.222 75.4264L436.431 81.2593C436.431 81.2593 449.934 109.419 449.934 115.654C449.934 121.889 451.748 138.785 451.748 138.785L441.671 118.872V121.286C441.671 121.286 450.135 136.572 450.337 137.779C450.538 138.986 451.143 140.192 450.74 140.394C450.337 140.595 445.735 136.418 442.276 135.164V136.371C445.747 138.077 450.941 141.6 450.337 142.204C449.732 142.807 440.865 141.6 440.865 141.6L440.26 143.411C440.26 143.411 451.344 143.008 451.143 144.416C450.941 145.824 442.88 156.283 440.865 159.703C438.85 163.122 429.579 173.179 428.975 175.19C428.37 177.202 428.773 179.213 429.579 182.431C430.385 185.649 431.191 188.465 432.602 190.074C434.013 191.684 444.694 201.74 445.097 202.746C445.5 203.752 449.732 208.78 449.732 208.78L451.546 207.775C450.74 207.976 445.5 202.344 445.5 202.344C445.5 202.344 434.416 190.074 436.23 177.805C438.044 165.536 455.778 144.416 455.778 144.416Z",
    fill: "url(#paint39_linear_210_10376)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M440.862 195.862C438.074 191.162 435.24 184.484 436.227 177.805C436.888 173.334 439.663 167.688 442.923 162.317C442.923 162.317 435.018 171.57 434.212 172.978C433.406 174.386 431.426 175.391 431.592 181.023C431.758 186.655 440.862 195.862 440.862 195.862Z",
    fill: "url(#paint40_linear_210_10376)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M353.598 234.727C357.628 233.118 404.182 218.637 406.802 224.671C406.802 224.671 405.996 218.838 407.406 216.223C408.817 213.608 412.042 212.602 412.042 212.602C412.042 212.602 407.406 213.809 404.585 213.608C401.763 213.407 386.649 208.58 386.649 208.58C384.23 207.373 370.728 208.982 370.728 208.982C370.728 208.982 372.743 211.396 371.937 210.792C371.131 210.189 368.108 211.396 368.108 211.396C368.108 211.396 370.728 214.815 370.728 217.832C370.728 220.849 370.123 223.062 368.914 223.464C367.705 223.866 349.97 231.107 343.32 233.722C336.669 236.337 324.981 236.94 320.748 235.13C316.516 233.32 313.292 230.906 312.687 231.107C312.083 231.308 313.292 233.118 313.292 233.118C313.292 233.118 305.029 225.475 303.82 221.855C302.611 218.234 299.386 207.574 298.58 208.982C297.774 210.39 299.991 221.855 299.991 221.855C299.991 221.855 297.774 216.223 296.968 214.212C296.162 212.2 293.945 212.401 292.937 208.982C291.93 205.563 287.698 215.016 288.907 218.234C290.116 221.452 293.139 228.09 297.371 229.699C301.603 231.308 310.47 234.325 310.672 235.532C310.874 236.739 307.246 236.94 307.246 236.94C307.246 236.94 310.47 238.951 314.098 238.348C317.726 237.745 330.422 238.75 335.057 238.348C339.692 237.946 349.567 236.337 353.598 234.727Z",
    fill: "url(#paint41_linear_210_10376)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M353.599 234.727C357.63 233.118 404.183 218.637 406.803 224.671C406.803 224.671 405.997 218.838 407.408 216.223C408.818 213.608 412.043 212.602 412.043 212.602C412.043 212.602 407.408 213.809 404.586 213.608C401.765 213.407 386.65 208.58 386.65 208.58C384.232 207.373 370.729 208.982 370.729 208.982C370.729 208.982 372.744 211.396 371.938 210.792C371.132 210.189 368.109 211.396 368.109 211.396C368.109 211.396 370.729 214.815 370.729 217.832C370.729 220.849 370.125 223.062 368.915 223.464C367.706 223.866 349.972 231.107 343.321 233.722C336.671 236.337 324.982 236.94 320.75 235.13C320.75 235.13 319.944 235.532 313.898 233.923C307.852 232.314 299.992 221.855 299.992 221.855C299.992 221.855 303.418 230.906 309.867 233.722C316.316 236.538 322.564 238.225 322.564 238.225C327.241 238.353 332.438 238.575 335.058 238.348C339.694 237.946 349.569 236.337 353.599 234.727Z",
    fill: "url(#paint42_linear_210_10376)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M370.729 217.832C370.729 220.849 370.125 223.061 368.915 223.464C368.915 223.464 395.92 217.228 397.734 215.418C399.548 213.608 371.938 210.792 371.938 210.792C371.132 210.189 368.109 211.395 368.109 211.395C368.109 211.395 370.729 214.815 370.729 217.832Z",
    fill: "url(#paint43_linear_210_10376)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M389.668 187.661C391.683 196.511 386.645 208.579 386.645 208.579C386.645 208.579 402.969 213.809 406.193 213.608C409.418 213.407 410.829 212.803 410.829 212.803C410.829 212.803 416.471 210.591 422.719 210.792C428.966 210.993 433.198 212.803 433.198 212.803C433.198 212.803 438.64 215.217 440.252 214.412C441.864 213.608 444.887 210.188 446.499 209.786C448.112 209.384 449.522 208.78 449.522 208.78C449.522 208.78 445.492 203.752 444.887 202.344C444.283 200.936 435.214 192.891 431.989 190.075C428.765 187.259 424.13 182.029 424.13 179.616C424.13 177.202 424.734 175.794 425.339 173.783C425.943 171.771 440.655 142.606 441.663 139.79C442.67 136.974 442.267 128.929 442.066 125.309C441.864 121.688 440.655 105.597 440.05 99.9653C439.446 94.3335 436.221 79.8516 435.214 75.4266C434.206 71.0016 420.301 37.0094 420.301 37.0094C420.301 37.0094 413.247 19.9128 397.528 1.20703C397.528 1.20703 395.512 26.9526 394.303 31.981C393.094 37.0094 389.466 42.8424 379.793 47.6697C378.785 70.3981 367.903 79.2482 367.903 79.2482C367.903 79.2482 371.53 95.3391 371.329 101.776C371.127 108.212 371.329 116.056 365.484 126.314C377.576 142.606 375.158 164.128 375.158 164.128C375.158 164.128 387.653 178.811 389.668 187.661Z",
    fill: "url(#paint44_linear_210_10376)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M394.307 31.981C393.098 37.0094 389.47 42.8424 379.797 47.6697C379.797 47.6697 399.95 59.1345 411.437 75.6277C422.924 92.1209 432.195 105.597 433.404 110.827C434.613 116.056 439.651 133.555 439.651 133.555C439.651 133.555 438.845 116.66 437.233 100.368C435.621 84.0755 420.304 37.0094 420.304 37.0094C420.304 37.0094 413.251 19.9128 397.532 1.20703C397.532 1.20703 395.516 26.9526 394.307 31.981Z",
    fill: "url(#paint45_linear_210_10376)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M379.793 47.6689C378.785 70.3974 367.902 79.2474 367.902 79.2474C367.902 79.2474 389.869 87.2929 398.333 94.5339C406.798 101.775 421.912 114.849 424.532 117.665C427.152 120.481 438.035 135.365 438.035 135.365C438.035 135.365 434.609 121.687 431.787 113.441C428.966 105.194 421.308 92.5225 410.828 77.6384C400.349 62.7542 379.793 47.6689 379.793 47.6689Z",
    fill: "url(#paint46_linear_210_10376)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M371.33 101.775C371.128 108.2 371.329 116.028 365.517 126.259C368.35 125.9 384.28 123.937 390.878 124.303C398.133 124.705 415.061 128.728 418.286 129.331C421.51 129.935 437.028 137.176 437.028 137.176C437.028 137.176 429.169 124.906 423.929 118.872C418.689 112.838 406.396 102.58 396.521 94.5345C386.646 86.489 367.903 79.248 367.903 79.248C367.903 79.248 371.531 95.339 371.33 101.775Z",
    fill: "url(#paint47_linear_210_10376)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M389.67 187.661C391.686 196.511 386.647 208.579 386.647 208.579C386.647 208.579 399.948 213.004 404.583 213.608C409.219 214.211 415.265 210.792 421.714 210.792C428.162 210.792 430.782 212.602 434.208 212.803C437.634 213.004 440.657 208.981 439.247 204.355C437.836 199.729 418.691 184.644 418.892 181.023C419.094 177.403 433.805 153.065 437.634 140.997C437.634 140.997 422.117 140.997 416.474 143.612C410.831 146.227 399.747 149.445 394.305 151.456C388.864 153.468 375.16 164.128 375.16 164.128C375.16 164.128 387.655 178.811 389.67 187.661Z",
    fill: "url(#paint48_linear_210_10376)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M393.699 150.451C387.653 153.065 374.956 164.128 374.956 164.128C377.173 139.992 365.484 126.314 365.484 126.314C365.484 126.314 380.398 124.303 391.885 125.51C403.372 126.716 413.65 129.331 418.89 130.94C424.13 132.549 436.624 138.986 436.624 138.986C436.624 138.986 425.742 140.595 419.897 141.399C414.053 142.204 399.744 147.836 393.699 150.451Z",
    fill: "url(#paint49_linear_210_10376)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M466.253 200.132C466.656 199.529 467.664 198.724 467.865 198.322C468.067 197.92 468.067 196.11 468.47 195.506C468.873 194.903 470.485 192.288 470.888 191.685C471.291 191.081 471.493 188.668 470.485 188.466C469.477 188.265 467.865 192.087 467.059 192.087C466.253 192.087 466.454 191.282 466.656 191.081C466.857 190.88 470.082 186.254 469.477 184.645C468.873 183.036 468.873 180.22 466.656 180.22C464.439 180.22 463.633 182.231 463.633 183.237V187.863C463.633 188.668 462.625 189.271 461.416 189.271C460.207 189.271 459.401 188.466 459.401 187.863V182.03C459.401 182.03 459.401 179.818 457.789 180.22C456.176 180.622 454.363 183.639 454.363 185.248C454.363 186.857 455.37 188.466 455.572 189.472C455.773 190.478 455.169 191.685 454.766 191.685C454.363 191.685 454.363 190.075 454.363 189.472C454.363 188.869 453.556 186.857 452.75 186.857C451.944 186.857 452.347 189.07 451.944 190.075C451.541 191.081 453.153 193.696 453.153 193.696C453.153 193.696 452.952 195.506 452.75 195.908C452.549 196.311 453.758 197.115 453.758 197.115V204.356C453.758 205.362 452.347 207.574 451.541 207.776C451.541 207.776 449.929 208.781 447.107 209.586C444.286 210.39 441.666 214.614 439.248 214.614C436.829 214.614 433.403 212.804 433.403 212.804C433.403 212.804 428.164 210.994 422.924 210.793C417.684 210.591 408.212 212.603 407.003 217.028C405.794 221.453 406.802 224.671 406.802 224.671C406.802 224.671 407.205 227.688 406.197 228.895C405.189 230.102 403.376 229.699 402.368 230.906C401.36 232.113 399.95 235.331 399.748 236.739C399.546 238.147 397.934 242.773 396.927 243.176C395.919 243.578 394.911 241.164 393.904 241.365C392.896 241.567 392.09 242.773 392.09 244.584C392.09 246.394 393.702 252.83 393.904 254.842C394.105 256.853 391.687 257.456 393.097 258.06C394.508 258.663 399.748 258.06 400.957 258.06C402.166 258.06 400.151 256.652 399.345 256.25C398.539 255.847 397.934 253.232 397.733 252.026C397.531 250.819 397.733 248.204 397.934 246.796C398.136 245.388 401.36 242.17 402.569 240.36C403.779 238.55 412.041 230.906 413.654 230.504C415.266 230.102 417.483 225.476 417.483 225.476L422.722 227.487C422.722 227.487 420.304 228.493 420.304 229.297C420.304 230.102 418.49 235.532 417.483 236.94C416.475 238.348 411.235 237.544 411.034 238.55C410.832 239.555 410.631 241.768 412.646 242.572C414.661 243.377 420.103 248.606 420.506 248.606C420.909 248.606 421.513 250.014 421.312 250.618C421.11 251.221 419.901 254.842 420.103 255.646C420.304 256.451 421.312 257.255 422.722 257.054C424.133 256.853 423.932 255.244 424.335 254.238C424.738 253.232 424.335 250.215 423.932 248.606C423.529 246.997 419.095 243.176 419.296 240.36C419.498 237.544 429.574 228.292 429.574 228.292C429.574 228.292 432.194 229.699 433.605 230.504C435.016 231.309 438.039 231.711 438.039 231.711C438.039 231.711 437.837 234.929 438.442 235.935C439.046 236.94 441.263 238.952 442.472 239.756C443.682 240.561 447.108 242.975 447.914 244.181C448.72 245.388 448.518 246.394 448.518 248.405C448.518 250.417 445.697 252.227 445.898 253.635C446.1 255.043 450.937 256.25 451.34 256.25C451.743 256.25 451.743 258.261 452.549 258.261C453.355 258.261 455.572 258.663 456.378 258.663C457.184 258.663 456.781 258.261 456.781 258.261L460.207 257.859C460.207 256.451 456.378 256.451 455.37 255.847C454.363 255.244 453.758 252.83 453.556 252.227C453.355 251.623 453.355 251.02 453.355 250.417C453.355 249.813 453.153 247.4 453.355 245.589C453.556 243.779 455.169 237.544 455.37 235.935C455.572 234.326 454.564 233.32 454.766 231.711C454.967 230.102 460.61 223.263 460.812 221.855C461.013 220.447 461.215 217.631 461.215 216.424C461.215 215.218 463.23 211.798 463.633 210.189C464.036 208.58 464.439 204.96 464.439 203.954C464.439 202.948 465.85 200.736 466.253 200.132Z",
    fill: "url(#paint50_linear_210_10376)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M392.09 244.584C392.09 246.394 393.702 252.83 393.904 254.842C393.904 254.842 394.508 246.595 394.911 245.388C395.314 244.181 396.927 243.176 396.927 243.176C395.919 243.578 394.911 241.164 393.904 241.365C392.896 241.567 392.09 242.773 392.09 244.584Z",
    fill: "#33123A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M420.507 248.606C420.104 248.606 414.663 243.377 412.648 242.572C410.633 241.768 410.834 239.555 411.036 238.55C411.231 237.573 416.177 238.303 417.386 237.057C417.451 236.981 417.485 236.94 417.485 236.94C417.455 236.981 417.423 237.02 417.386 237.057C417.101 237.397 416.218 238.443 415.066 239.756C413.655 241.365 420.507 248.606 420.507 248.606Z",
    fill: "#4F2758"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M442.47 239.756C443.679 240.561 447.105 242.975 447.911 244.181C447.911 244.181 442.873 235.331 442.873 232.314C442.873 229.297 447.105 225.476 443.679 220.246C443.679 220.246 445.694 224.872 444.082 227.487C442.47 230.102 438.036 231.711 438.036 231.711C438.036 231.711 437.835 234.929 438.439 235.935C439.044 236.94 441.261 238.952 442.47 239.756Z",
    fill: "url(#paint51_linear_210_10376)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M464.439 203.954C464.439 202.948 465.85 200.736 466.253 200.132C466.253 200.132 464.238 201.943 463.029 202.948C461.819 203.954 461.618 204.758 460.207 204.356C458.796 203.954 455.572 201.339 455.572 199.73C455.572 198.121 453.758 197.115 453.758 197.115V204.356C453.758 204.356 457.386 207.172 457.386 211.798C457.386 216.424 457.789 219.24 457.386 220.246C456.983 221.252 454.766 220.246 454.766 220.246C455.37 221.855 451.34 229.297 451.34 229.297C451.34 229.297 456.378 226.079 457.789 224.47C459.2 222.861 458.796 221.453 458.998 220.246C459.2 219.039 461.215 216.424 461.215 216.424C461.215 215.218 463.23 211.798 463.633 210.189C464.036 208.58 464.439 204.96 464.439 203.954Z",
    fill: "url(#paint52_linear_210_10376)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M424.536 225.878C426.552 226.683 429.575 228.292 429.575 228.292C429.575 228.292 421.312 222.258 422.521 219.844C422.319 218.637 417.281 225.275 417.281 225.275C417.281 225.275 422.521 225.073 424.536 225.878Z",
    fill: "url(#paint53_linear_210_10376)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M465.249 194.903C463.435 195.306 462.629 198.524 462.629 198.524C462.629 198.524 465.047 197.518 466.055 197.518C467.063 197.518 467.063 195.708 467.063 195.708C467.063 195.708 467.063 194.501 465.249 194.903Z",
    fill: "#896778"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M457.388 194.903C458.396 195.507 458.597 198.323 458.597 198.323C458.597 198.323 456.582 197.518 455.373 196.915C454.164 196.311 454.249 195.063 454.567 194.501C454.567 194.501 456.38 194.3 457.388 194.903Z",
    fill: "#896778"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M461.214 200.938C460.811 201.139 460.609 202.144 460.609 202.144C460.609 202.144 461.617 201.742 461.818 201.742C462.019 201.742 462.221 201.139 462.221 201.139C462.221 201.139 461.617 200.737 461.214 200.938Z",
    fill: "#6B466A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M459.388 200.965C459.751 201.225 459.779 202.206 459.779 202.206C459.779 202.206 458.856 201.651 458.657 201.615C458.459 201.58 458.363 200.977 458.363 200.977C458.363 200.977 459.025 200.705 459.388 200.965Z",
    fill: "#6B466A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M452.147 253.232C451.945 253.836 452.348 258.059 452.348 258.059C452.348 258.059 451.139 254.439 451.542 253.634C451.945 252.83 451.945 246.394 451.945 244.784C451.945 243.175 450.938 229.498 450.938 229.498C450.938 229.498 451.744 233.521 451.945 235.13C452.147 236.739 452.348 252.629 452.147 253.232Z",
    fill: "url(#paint54_linear_210_10376)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M466.253 200.131C466.656 199.528 467.664 198.723 467.865 198.321C468.067 197.919 468.067 196.109 468.47 195.505C468.873 194.902 470.485 192.287 470.888 191.684C471.291 191.08 471.493 188.667 470.485 188.465C469.478 188.264 467.865 192.086 467.059 192.086C466.253 192.086 466.455 191.281 466.656 191.08C466.858 190.879 470.082 186.253 469.478 184.644C468.873 183.035 468.873 180.219 466.656 180.219C464.439 180.219 463.633 182.23 463.633 183.236V187.862C463.633 188.667 462.626 189.27 461.416 189.27C460.207 189.27 459.401 188.465 459.401 187.862V182.029C459.401 182.029 459.401 179.816 457.789 180.219C456.177 180.621 454.363 183.638 454.363 185.247C454.363 186.856 455.37 188.465 455.572 189.471C455.774 190.477 455.169 191.684 454.766 191.684C454.363 191.684 454.363 190.074 454.363 189.471C454.363 188.868 453.557 186.856 452.751 186.856C451.944 186.856 452.348 189.069 451.944 190.074C451.541 191.08 453.154 193.695 453.154 193.695C453.154 193.695 452.952 195.505 452.751 195.907C452.549 196.31 453.758 197.114 453.758 197.114V204.355C453.758 205.361 452.348 207.573 451.541 207.775C450.735 207.976 445.496 202.344 445.496 202.344C445.496 202.344 434.411 190.074 436.225 177.805C438.039 165.536 455.774 144.416 455.774 144.416C455.774 144.416 466.656 109.016 455.774 60.9445C444.891 12.8728 433.807 0 433.807 0C433.807 0 429.373 16.2921 428.567 22.5273C427.761 28.7626 420.304 37.0092 420.304 37.0092C420.304 37.0092 413.251 19.9126 397.531 1.20682C397.531 1.20682 395.516 26.9524 394.307 31.9808C393.098 37.0092 389.47 42.8422 379.797 47.6695C378.789 70.3979 367.907 79.248 367.907 79.248C367.907 79.248 371.534 95.3389 371.333 101.775C371.131 108.212 371.333 116.056 365.488 126.314C377.58 142.606 375.162 164.128 375.162 164.128C375.162 164.128 387.656 178.811 389.672 187.661C391.687 196.511 386.649 208.579 386.649 208.579C384.23 207.372 370.728 208.981 370.728 208.981C370.728 208.981 372.743 211.395 371.937 210.792C371.131 210.188 368.108 211.395 368.108 211.395C368.108 211.395 370.728 214.814 370.728 217.831C370.728 220.848 370.123 223.061 368.914 223.463C367.705 223.865 349.97 231.106 343.32 233.721C336.669 236.336 324.981 236.939 320.748 235.129C316.516 233.319 313.292 230.905 312.687 231.106C312.083 231.308 313.292 233.118 313.292 233.118C313.292 233.118 305.029 225.475 303.82 221.854C302.611 218.234 299.386 207.573 298.58 208.981C297.774 210.389 299.991 221.854 299.991 221.854C299.991 221.854 297.774 216.222 296.968 214.211C296.162 212.2 293.945 212.401 292.937 208.981C291.93 205.562 287.698 215.015 288.907 218.234C290.116 221.452 293.139 228.089 297.371 229.698C301.603 231.308 310.47 234.325 310.672 235.531C310.874 236.738 307.246 236.939 307.246 236.939C307.246 236.939 310.47 238.951 314.098 238.347C317.726 237.744 330.422 238.75 335.057 238.347C339.692 237.945 349.567 236.336 353.598 234.727C357.628 233.118 404.182 218.636 406.802 224.67C406.802 224.67 407.205 227.687 406.197 228.894C405.19 230.101 403.376 229.698 402.368 230.905C401.36 232.112 399.95 235.33 399.748 236.738C399.547 238.146 397.934 242.772 396.927 243.175C395.919 243.577 394.912 241.163 393.904 241.364C392.896 241.566 392.09 242.772 392.09 244.583C392.09 246.393 393.702 252.829 393.904 254.841C394.105 256.852 391.687 257.455 393.098 258.059C394.508 258.662 399.748 258.059 400.957 258.059C402.167 258.059 400.151 256.651 399.345 256.249C398.539 255.846 397.934 253.231 397.733 252.025C397.531 250.818 397.733 248.203 397.934 246.795C398.136 245.387 401.36 242.169 402.57 240.359C403.779 238.548 412.042 230.905 413.654 230.503C415.266 230.101 417.483 225.475 417.483 225.475L422.723 227.486C422.723 227.486 420.304 228.492 420.304 229.296C420.304 230.101 418.491 235.531 417.483 236.939C416.475 238.347 411.235 237.543 411.034 238.548C410.832 239.554 410.631 241.767 412.646 242.571C414.661 243.376 420.103 248.605 420.506 248.605C420.909 248.605 421.513 250.013 421.312 250.617L421.312 250.617C421.11 251.221 419.901 254.841 420.103 255.645C420.304 256.45 421.312 257.254 422.723 257.053C424.133 256.852 423.932 255.243 424.335 254.237C424.738 253.231 424.335 250.214 423.932 248.605C423.529 246.996 419.095 243.175 419.297 240.359C419.498 237.543 429.575 228.29 429.575 228.29C429.575 228.29 432.195 229.698 433.605 230.503C435.016 231.308 438.039 231.71 438.039 231.71C438.039 231.71 437.837 234.928 438.442 235.934C439.047 236.939 441.263 238.951 442.473 239.755C443.682 240.56 447.108 242.973 447.914 244.18C448.72 245.387 448.518 246.393 448.518 248.404C448.518 250.416 445.697 252.226 445.899 253.634C446.1 255.042 450.937 256.249 451.34 256.249C451.743 256.249 451.743 258.26 452.549 258.26C453.355 258.26 455.572 258.662 456.378 258.662C457.184 258.662 456.781 258.26 456.781 258.26L460.207 257.858C460.207 256.45 456.378 256.45 455.37 255.846C454.363 255.243 453.758 252.829 453.557 252.226C453.355 251.622 453.355 251.019 453.355 250.416C453.355 249.812 453.154 247.398 453.355 245.588C453.557 243.778 455.169 237.543 455.37 235.934C455.572 234.325 454.564 233.319 454.766 231.71C454.967 230.101 460.61 223.262 460.812 221.854C461.013 220.446 461.215 217.63 461.215 216.423C461.215 215.217 463.23 211.797 463.633 210.188C464.036 208.579 464.439 204.959 464.439 203.953C464.439 202.947 465.85 200.735 466.253 200.131Z",
    fill: "url(#paint55_linear_210_10376)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M455.778 144.416C455.778 144.416 466.661 109.016 455.778 60.9445C449.151 31.6716 442.45 15.4508 438.222 7.24093C438.222 7.24093 444.492 21.9239 446.306 29.1649C448.12 36.4058 453.158 52.899 455.375 64.3638C457.592 75.8286 458.801 88.7014 458.6 104.39C458.398 120.079 453.763 137.779 453.763 137.779C453.763 137.779 451.748 119.878 451.748 114.648C451.748 109.419 435.222 75.4264 435.222 75.4264L436.431 81.2593C436.431 81.2593 449.934 109.419 449.934 115.654C449.934 121.889 451.748 138.785 451.748 138.785L441.671 118.872V121.286C441.671 121.286 450.135 136.572 450.337 137.779C450.538 138.986 451.143 140.192 450.74 140.394C450.337 140.595 445.735 136.418 442.276 135.164V136.371C445.747 138.077 450.941 141.6 450.337 142.204C449.732 142.807 440.865 141.6 440.865 141.6L440.26 143.411C440.26 143.411 451.344 143.008 451.143 144.416C450.941 145.824 442.88 156.283 440.865 159.703C438.85 163.122 429.579 173.179 428.975 175.19C428.37 177.202 428.773 179.213 429.579 182.431C430.385 185.649 431.191 188.465 432.602 190.074C434.013 191.684 444.694 201.74 445.097 202.746C445.5 203.752 449.732 208.78 449.732 208.78L451.546 207.775C450.74 207.976 445.5 202.344 445.5 202.344C445.5 202.344 434.416 190.074 436.23 177.805C438.044 165.536 455.778 144.416 455.778 144.416Z",
    fill: "url(#paint56_linear_210_10376)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M440.862 195.862C438.074 191.162 435.24 184.484 436.227 177.805C436.888 173.334 439.663 167.688 442.923 162.317C442.923 162.317 435.018 171.57 434.212 172.978C433.406 174.386 431.426 175.391 431.592 181.023C431.758 186.655 440.862 195.862 440.862 195.862Z",
    fill: "url(#paint57_linear_210_10376)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M353.598 234.727C357.628 233.118 404.182 218.637 406.802 224.671C406.802 224.671 405.996 218.838 407.406 216.223C408.817 213.608 412.042 212.602 412.042 212.602C412.042 212.602 407.406 213.809 404.585 213.608C401.763 213.407 386.649 208.58 386.649 208.58C384.23 207.373 370.728 208.982 370.728 208.982C370.728 208.982 372.743 211.396 371.937 210.792C371.131 210.189 368.108 211.396 368.108 211.396C368.108 211.396 370.728 214.815 370.728 217.832C370.728 220.849 370.123 223.062 368.914 223.464C367.705 223.866 349.97 231.107 343.32 233.722C336.669 236.337 324.981 236.94 320.748 235.13C316.516 233.32 313.292 230.906 312.687 231.107C312.083 231.308 313.292 233.118 313.292 233.118C313.292 233.118 305.029 225.475 303.82 221.855C302.611 218.234 299.386 207.574 298.58 208.982C297.774 210.39 299.991 221.855 299.991 221.855C299.991 221.855 297.774 216.223 296.968 214.212C296.162 212.2 293.945 212.401 292.937 208.982C291.93 205.563 287.698 215.016 288.907 218.234C290.116 221.452 293.139 228.09 297.371 229.699C301.603 231.308 310.47 234.325 310.672 235.532C310.874 236.739 307.246 236.94 307.246 236.94C307.246 236.94 310.47 238.951 314.098 238.348C317.726 237.745 330.422 238.75 335.057 238.348C339.692 237.946 349.567 236.337 353.598 234.727Z",
    fill: "url(#paint58_linear_210_10376)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M353.599 234.727C357.63 233.118 404.183 218.637 406.803 224.671C406.803 224.671 405.997 218.838 407.408 216.223C408.818 213.608 412.043 212.602 412.043 212.602C412.043 212.602 407.408 213.809 404.586 213.608C401.765 213.407 386.65 208.58 386.65 208.58C384.232 207.373 370.729 208.982 370.729 208.982C370.729 208.982 372.744 211.396 371.938 210.792C371.132 210.189 368.109 211.396 368.109 211.396C368.109 211.396 370.729 214.815 370.729 217.832C370.729 220.849 370.125 223.062 368.915 223.464C367.706 223.866 349.972 231.107 343.321 233.722C336.671 236.337 324.982 236.94 320.75 235.13C320.75 235.13 319.944 235.532 313.898 233.923C307.852 232.314 299.992 221.855 299.992 221.855C299.992 221.855 303.418 230.906 309.867 233.722C316.316 236.538 322.564 238.225 322.564 238.225C327.241 238.353 332.438 238.575 335.058 238.348C339.694 237.946 349.569 236.337 353.599 234.727Z",
    fill: "url(#paint59_linear_210_10376)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M370.729 217.832C370.729 220.849 370.125 223.061 368.915 223.464C368.915 223.464 395.92 217.228 397.734 215.418C399.548 213.608 371.938 210.792 371.938 210.792C371.132 210.189 368.109 211.395 368.109 211.395C368.109 211.395 370.729 214.815 370.729 217.832Z",
    fill: "url(#paint60_linear_210_10376)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M389.668 187.661C391.683 196.511 386.645 208.579 386.645 208.579C386.645 208.579 402.969 213.809 406.193 213.608C409.418 213.407 410.829 212.803 410.829 212.803C410.829 212.803 416.471 210.591 422.719 210.792C428.966 210.993 433.198 212.803 433.198 212.803C433.198 212.803 438.64 215.217 440.252 214.412C441.864 213.608 444.887 210.188 446.499 209.786C448.112 209.384 449.522 208.78 449.522 208.78C449.522 208.78 445.492 203.752 444.887 202.344C444.283 200.936 435.214 192.891 431.989 190.075C428.765 187.259 424.13 182.029 424.13 179.616C424.13 177.202 424.734 175.794 425.339 173.783C425.943 171.771 440.655 142.606 441.663 139.79C442.67 136.974 442.267 128.929 442.066 125.309C441.864 121.688 440.655 105.597 440.05 99.9653C439.446 94.3335 436.221 79.8516 435.214 75.4266C434.206 71.0016 420.301 37.0094 420.301 37.0094C420.301 37.0094 413.247 19.9128 397.528 1.20703C397.528 1.20703 395.512 26.9526 394.303 31.981C393.094 37.0094 389.466 42.8424 379.793 47.6697C378.785 70.3981 367.903 79.2482 367.903 79.2482C367.903 79.2482 371.53 95.3391 371.329 101.776C371.127 108.212 371.329 116.056 365.484 126.314C377.576 142.606 375.158 164.128 375.158 164.128C375.158 164.128 387.653 178.811 389.668 187.661Z",
    fill: "url(#paint61_linear_210_10376)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M394.307 31.981C393.098 37.0094 389.47 42.8424 379.797 47.6697C379.797 47.6697 399.95 59.1345 411.437 75.6277C422.924 92.1209 432.195 105.597 433.404 110.827C434.613 116.056 439.651 133.555 439.651 133.555C439.651 133.555 438.845 116.66 437.233 100.368C435.621 84.0755 420.304 37.0094 420.304 37.0094C420.304 37.0094 413.251 19.9128 397.532 1.20703C397.532 1.20703 395.516 26.9526 394.307 31.981Z",
    fill: "url(#paint62_linear_210_10376)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M379.793 47.6689C378.785 70.3974 367.902 79.2474 367.902 79.2474C367.902 79.2474 389.869 87.2929 398.333 94.5339C406.798 101.775 421.912 114.849 424.532 117.665C427.152 120.481 438.035 135.365 438.035 135.365C438.035 135.365 434.609 121.687 431.787 113.441C428.966 105.194 421.308 92.5225 410.828 77.6384C400.349 62.7542 379.793 47.6689 379.793 47.6689Z",
    fill: "url(#paint63_linear_210_10376)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M371.33 101.775C371.128 108.2 371.329 116.028 365.517 126.259C368.35 125.9 384.28 123.937 390.878 124.303C398.133 124.705 415.061 128.728 418.286 129.331C421.51 129.935 437.028 137.176 437.028 137.176C437.028 137.176 429.169 124.906 423.929 118.872C418.689 112.838 406.396 102.58 396.521 94.5345C386.646 86.489 367.903 79.248 367.903 79.248C367.903 79.248 371.531 95.339 371.33 101.775Z",
    fill: "url(#paint64_linear_210_10376)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M389.67 187.661C391.686 196.511 386.647 208.579 386.647 208.579C386.647 208.579 399.948 213.004 404.583 213.608C409.219 214.211 415.265 210.792 421.714 210.792C428.162 210.792 430.782 212.602 434.208 212.803C437.634 213.004 440.657 208.981 439.247 204.355C437.836 199.729 418.691 184.644 418.892 181.023C419.094 177.403 433.805 153.065 437.634 140.997C437.634 140.997 422.117 140.997 416.474 143.612C410.831 146.227 399.747 149.445 394.305 151.456C388.864 153.468 375.16 164.128 375.16 164.128C375.16 164.128 387.655 178.811 389.67 187.661Z",
    fill: "url(#paint65_linear_210_10376)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M393.699 150.451C387.653 153.065 374.956 164.128 374.956 164.128C377.173 139.992 365.484 126.314 365.484 126.314C365.484 126.314 380.398 124.303 391.885 125.51C403.372 126.716 413.65 129.331 418.89 130.94C424.13 132.549 436.624 138.986 436.624 138.986C436.624 138.986 425.742 140.595 419.897 141.399C414.053 142.204 399.744 147.836 393.699 150.451Z",
    fill: "url(#paint66_linear_210_10376)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M466.253 200.132C466.656 199.529 467.664 198.724 467.865 198.322C468.067 197.92 468.067 196.11 468.47 195.506C468.873 194.903 470.485 192.288 470.888 191.685C471.291 191.081 471.493 188.668 470.485 188.466C469.477 188.265 467.865 192.087 467.059 192.087C466.253 192.087 466.454 191.282 466.656 191.081C466.857 190.88 470.082 186.254 469.477 184.645C468.873 183.036 468.873 180.22 466.656 180.22C464.439 180.22 463.633 182.231 463.633 183.237V187.863C463.633 188.668 462.625 189.271 461.416 189.271C460.207 189.271 459.401 188.466 459.401 187.863V182.03C459.401 182.03 459.401 179.818 457.789 180.22C456.176 180.622 454.363 183.639 454.363 185.248C454.363 186.857 455.37 188.466 455.572 189.472C455.773 190.478 455.169 191.685 454.766 191.685C454.363 191.685 454.363 190.075 454.363 189.472C454.363 188.869 453.556 186.857 452.75 186.857C451.944 186.857 452.347 189.07 451.944 190.075C451.541 191.081 453.153 193.696 453.153 193.696C453.153 193.696 452.952 195.506 452.75 195.908C452.549 196.311 453.758 197.115 453.758 197.115V204.356C453.758 205.362 452.347 207.574 451.541 207.776C451.541 207.776 449.929 208.781 447.107 209.586C444.286 210.39 441.666 214.614 439.248 214.614C436.829 214.614 433.403 212.804 433.403 212.804C433.403 212.804 428.164 210.994 422.924 210.793C417.684 210.591 408.212 212.603 407.003 217.028C405.794 221.453 406.802 224.671 406.802 224.671C406.802 224.671 407.205 227.688 406.197 228.895C405.189 230.102 403.376 229.699 402.368 230.906C401.36 232.113 399.95 235.331 399.748 236.739C399.546 238.147 397.934 242.773 396.927 243.176C395.919 243.578 394.911 241.164 393.904 241.365C392.896 241.567 392.09 242.773 392.09 244.584C392.09 246.394 393.702 252.83 393.904 254.842C394.105 256.853 391.687 257.456 393.097 258.06C394.508 258.663 399.748 258.06 400.957 258.06C402.166 258.06 400.151 256.652 399.345 256.25C398.539 255.847 397.934 253.232 397.733 252.026C397.531 250.819 397.733 248.204 397.934 246.796C398.136 245.388 401.36 242.17 402.569 240.36C403.779 238.55 412.041 230.906 413.654 230.504C415.266 230.102 417.483 225.476 417.483 225.476L422.722 227.487C422.722 227.487 420.304 228.493 420.304 229.297C420.304 230.102 418.49 235.532 417.483 236.94C416.475 238.348 411.235 237.544 411.034 238.55C410.832 239.555 410.631 241.768 412.646 242.572C414.661 243.377 420.103 248.606 420.506 248.606C420.909 248.606 421.513 250.014 421.312 250.618C421.11 251.221 419.901 254.842 420.103 255.646C420.304 256.451 421.312 257.255 422.722 257.054C424.133 256.853 423.932 255.244 424.335 254.238C424.738 253.232 424.335 250.215 423.932 248.606C423.529 246.997 419.095 243.176 419.296 240.36C419.498 237.544 429.574 228.292 429.574 228.292C429.574 228.292 432.194 229.699 433.605 230.504C435.016 231.309 438.039 231.711 438.039 231.711C438.039 231.711 437.837 234.929 438.442 235.935C439.046 236.94 441.263 238.952 442.472 239.756C443.682 240.561 447.108 242.975 447.914 244.181C448.72 245.388 448.518 246.394 448.518 248.405C448.518 250.417 445.697 252.227 445.898 253.635C446.1 255.043 450.937 256.25 451.34 256.25C451.743 256.25 451.743 258.261 452.549 258.261C453.355 258.261 455.572 258.663 456.378 258.663C457.184 258.663 456.781 258.261 456.781 258.261L460.207 257.859C460.207 256.451 456.378 256.451 455.37 255.847C454.363 255.244 453.758 252.83 453.556 252.227C453.355 251.623 453.355 251.02 453.355 250.417C453.355 249.813 453.153 247.4 453.355 245.589C453.556 243.779 455.169 237.544 455.37 235.935C455.572 234.326 454.564 233.32 454.766 231.711C454.967 230.102 460.61 223.263 460.812 221.855C461.013 220.447 461.215 217.631 461.215 216.424C461.215 215.218 463.23 211.798 463.633 210.189C464.036 208.58 464.439 204.96 464.439 203.954C464.439 202.948 465.85 200.736 466.253 200.132Z",
    fill: "url(#paint67_linear_210_10376)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M392.09 244.584C392.09 246.394 393.702 252.83 393.904 254.842C393.904 254.842 394.508 246.595 394.911 245.388C395.314 244.181 396.927 243.176 396.927 243.176C395.919 243.578 394.911 241.164 393.904 241.365C392.896 241.567 392.09 242.773 392.09 244.584Z",
    fill: "#33123A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M420.507 248.606C420.104 248.606 414.663 243.377 412.648 242.572C410.633 241.768 410.834 239.555 411.036 238.55C411.231 237.573 416.177 238.303 417.386 237.057C417.451 236.981 417.485 236.94 417.485 236.94C417.455 236.981 417.423 237.02 417.386 237.057C417.101 237.397 416.218 238.443 415.066 239.756C413.655 241.365 420.507 248.606 420.507 248.606Z",
    fill: "#4F2758"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M442.47 239.756C443.679 240.561 447.105 242.975 447.911 244.181C447.911 244.181 442.873 235.331 442.873 232.314C442.873 229.297 447.105 225.476 443.679 220.246C443.679 220.246 445.694 224.872 444.082 227.487C442.47 230.102 438.036 231.711 438.036 231.711C438.036 231.711 437.835 234.929 438.439 235.935C439.044 236.94 441.261 238.952 442.47 239.756Z",
    fill: "url(#paint68_linear_210_10376)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M464.439 203.954C464.439 202.948 465.85 200.736 466.253 200.132C466.253 200.132 464.238 201.943 463.029 202.948C461.819 203.954 461.618 204.758 460.207 204.356C458.796 203.954 455.572 201.339 455.572 199.73C455.572 198.121 453.758 197.115 453.758 197.115V204.356C453.758 204.356 457.386 207.172 457.386 211.798C457.386 216.424 457.789 219.24 457.386 220.246C456.983 221.252 454.766 220.246 454.766 220.246C455.37 221.855 451.34 229.297 451.34 229.297C451.34 229.297 456.378 226.079 457.789 224.47C459.2 222.861 458.796 221.453 458.998 220.246C459.2 219.039 461.215 216.424 461.215 216.424C461.215 215.218 463.23 211.798 463.633 210.189C464.036 208.58 464.439 204.96 464.439 203.954Z",
    fill: "url(#paint69_linear_210_10376)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M424.536 225.878C426.552 226.683 429.575 228.292 429.575 228.292C429.575 228.292 421.312 222.258 422.521 219.844C422.319 218.637 417.281 225.275 417.281 225.275C417.281 225.275 422.521 225.073 424.536 225.878Z",
    fill: "url(#paint70_linear_210_10376)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M465.249 194.903C463.435 195.306 462.629 198.524 462.629 198.524C462.629 198.524 465.047 197.518 466.055 197.518C467.063 197.518 467.063 195.708 467.063 195.708C467.063 195.708 467.063 194.501 465.249 194.903Z",
    fill: "#896778"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M457.388 194.903C458.396 195.507 458.597 198.323 458.597 198.323C458.597 198.323 456.582 197.518 455.373 196.915C454.164 196.311 454.249 195.063 454.567 194.501C454.567 194.501 456.38 194.3 457.388 194.903Z",
    fill: "#896778"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M461.214 200.938C460.811 201.139 460.609 202.144 460.609 202.144C460.609 202.144 461.617 201.742 461.818 201.742C462.019 201.742 462.221 201.139 462.221 201.139C462.221 201.139 461.617 200.737 461.214 200.938Z",
    fill: "#6B466A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M459.388 200.965C459.751 201.225 459.779 202.206 459.779 202.206C459.779 202.206 458.856 201.651 458.657 201.615C458.459 201.58 458.363 200.977 458.363 200.977C458.363 200.977 459.025 200.705 459.388 200.965Z",
    fill: "#6B466A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M452.147 253.232C451.945 253.836 452.348 258.059 452.348 258.059C452.348 258.059 451.139 254.439 451.542 253.634C451.945 252.83 451.945 246.394 451.945 244.784C451.945 243.175 450.938 229.498 450.938 229.498C450.938 229.498 451.744 233.521 451.945 235.13C452.147 236.739 452.348 252.629 452.147 253.232Z",
    fill: "url(#paint71_linear_210_10376)"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M295.66 215.04C295.861 210.011 296.264 205.184 296.264 205.184C296.264 205.184 307.751 202.569 309.364 203.172C310.976 203.776 309.162 214.436 309.364 218.258C309.565 222.079 306.542 226.303 306.341 232.136C306.139 237.969 305.333 248.428 305.333 248.428C305.333 248.428 301.302 243.4 300.295 243.601C299.287 243.802 298.481 244.406 298.481 244.406C298.481 244.406 298.806 236.917 298.481 232.136C298.023 225.385 295.458 220.068 295.66 215.04Z",
    fill: "#6771C7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M295.66 215.04C295.862 210.011 296.265 205.184 296.265 205.184C296.265 205.184 307.752 202.569 309.364 203.172C310.976 203.776 309.163 214.436 309.364 218.258C309.566 222.079 306.543 226.303 306.341 232.136C306.14 237.969 305.334 248.428 305.334 248.428C305.334 248.428 305.334 233.745 303.923 226.303C302.512 218.861 295.66 215.04 295.66 215.04Z",
    fill: "url(#paint72_linear_210_10376)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M300.293 243.601C299.285 243.802 298.479 244.405 298.479 244.405C298.479 244.405 296.061 250.037 295.053 251.445C294.045 252.853 295.859 255.669 296.867 256.272C297.875 256.876 300.897 255.468 302.107 254.864C303.316 254.261 303.316 263.915 304.323 264.117C305.331 264.318 304.323 256.473 304.525 256.071C304.727 255.669 306.339 254.462 306.742 253.255C307.145 252.048 305.331 248.428 305.331 248.428C305.331 248.428 301.3 243.399 300.293 243.601Z",
    fill: "#27195D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M309.961 206.592C310.365 203.977 309.558 203.172 309.558 203.172C309.558 203.172 323.665 202.167 322.255 206.592C320.844 211.017 315.604 217.855 316.209 222.079C316.813 226.303 319.232 227.912 319.232 227.912C319.232 227.912 315.917 233.25 315.201 237.366L315.191 237.423C314.469 241.571 312.785 251.251 313.186 252.652C313.589 254.06 316.007 256.474 315.201 257.882C314.395 259.29 310.365 259.893 308.752 259.29C307.14 258.686 306.737 252.049 306.939 251.244L306.939 251.244C307.14 250.44 307.745 248.026 307.543 246.015C307.342 244.003 307.543 240.182 307.342 236.963C307.14 233.745 309.558 221.677 309.558 219.062C309.558 216.447 309.558 209.207 309.961 206.592Z",
    fill: "#6771C7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M309.96 206.592C310.363 203.977 309.557 203.172 309.557 203.172C309.557 203.172 323.664 202.167 322.253 206.592C320.842 211.017 315.602 217.855 316.207 222.079C316.812 226.303 319.23 227.912 319.23 227.912C319.23 227.912 315.916 233.25 315.199 237.366L315.189 237.423C314.467 241.571 312.783 251.251 313.184 252.652V255.267C313.184 255.267 309.96 250.641 309.758 248.227C309.556 245.813 311.975 242.998 311.975 241.187C311.975 239.377 313.789 233.142 313.99 229.924C314.192 226.705 309.098 223.085 309.098 223.085C309.367 221.27 309.557 219.795 309.557 219.062C309.557 216.447 309.557 209.207 309.96 206.592Z",
    fill: "url(#paint73_linear_210_10376)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M307.542 246.014C307.744 248.025 307.139 250.439 306.938 251.243C306.938 251.243 306.944 251.672 306.892 252.225C306.929 254.313 307.44 258.798 308.752 259.289C310.364 259.892 314.394 259.289 315.201 257.881C316.007 256.473 313.588 254.059 313.185 252.651C313.01 252.039 313.233 249.844 313.6 247.221C313.6 247.221 314.395 250.64 315.201 253.255C316.007 255.87 316.611 258.484 316.611 259.892C316.611 261.3 316.208 262.909 315.201 263.714C314.193 264.519 308.752 264.519 307.341 263.714C305.93 262.909 306.132 254.462 306.132 254.462C306.626 254.039 306.818 253.007 306.892 252.225C306.884 251.746 306.9 251.393 306.938 251.243C306.938 251.243 305.93 250.238 305.729 249.232C305.527 248.226 306.132 244.405 306.132 243.6C306.132 242.796 307.442 241.79 307.442 241.79C307.442 243.459 307.439 244.977 307.542 246.014Z",
    fill: "#27195D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    fill: "url(#paint74_linear_210_10376)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint75_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint76_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint77_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M282.554 93.3509C281.949 97.5747 282.554 110.045 282.554 110.045C282.554 110.045 284.972 97.5747 288.398 99.1838C291.824 100.793 294.243 106.425 294.243 106.425C297.638 105.911 299.396 105.652 306.334 104.413C310.991 95.3177 312.099 94.1614 307.947 94.7588C303.794 95.3562 299.079 103.207 297.266 103.005C295.452 102.804 293.839 101.195 292.832 99.1838C291.824 97.1724 292.026 86.3111 288.801 85.3054C285.577 84.2997 283.158 89.127 282.554 93.3509Z",
    fill: "url(#paint78_linear_210_10376)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    fill: "url(#paint79_linear_210_10376)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    stroke: "url(#paint80_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    stroke: "url(#paint81_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M275.101 164.351C278.124 163.547 294.448 152.686 294.448 152.686C294.448 152.686 294.246 158.519 291.828 159.323C289.41 160.128 283.767 174.609 283.767 174.609C283.767 174.609 272.078 165.156 275.101 164.351Z",
    fill: "#291F63"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M275.101 164.352C278.124 163.547 294.448 152.686 294.448 152.686L287.394 133.578C287.394 133.578 291.425 135.589 296.463 134.583C301.501 133.578 316.817 125.331 316.817 125.331L297.874 120.705C307.473 112.556 311.512 108.6 314.197 103.608C314.197 103.608 297.068 105.419 294.448 106.424C291.828 107.43 292.836 121.51 291.828 125.733C290.82 129.957 277.116 142.428 275.705 145.847C274.294 149.266 289.409 141.02 289.208 144.238C289.006 147.456 285.782 150.071 282.759 154.898C279.736 159.726 275.705 159.122 275.101 160.53C274.496 161.938 275.101 164.352 275.101 164.352Z",
    fill: "url(#paint82_linear_210_10376)",
    stroke: "url(#paint83_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M296.665 81.2812C292.433 80.4766 292.634 77.4596 292.634 77.4596C292.634 77.4596 299.688 77.0573 301.3 73.638C302.912 70.2187 303.114 65.9948 302.308 65.5925C301.502 65.1902 300.494 61.5698 300.293 60.7652C300.091 59.9606 298.68 59.9608 298.479 57.7482C298.277 55.5357 299.688 54.1277 299.688 54.1277V48.4959C299.688 46.8868 302.912 42.4618 308.354 42.6629C313.795 42.864 316.616 46.2834 316.616 48.4959V54.1277C316.616 54.1277 317.826 56.1391 317.624 57.7482C317.423 59.3573 316.012 60.7652 316.012 60.7652C316.012 60.7652 315.004 64.9891 314.4 65.5925C313.795 66.196 314.4 69.8164 315.206 72.6323C316.012 75.4482 322.662 77.4596 322.662 77.4596C320.042 77.4596 315.81 79.0687 312.384 79.0687C308.958 79.0687 300.897 82.0857 296.665 81.2812Z",
    fill: "#959ACF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M296.665 81.2812C292.433 80.4766 292.634 77.4596 292.634 77.4596C292.634 77.4596 299.688 77.0573 301.3 73.638C302.912 70.2187 303.114 65.9948 302.308 65.5925C301.502 65.1902 300.494 61.5698 300.293 60.7652C300.091 59.9606 298.68 59.9608 298.479 57.7482C298.277 55.5357 299.688 54.1277 299.688 54.1277V48.4959C299.688 46.8868 302.912 42.4618 308.354 42.6629C313.795 42.864 316.616 46.2834 316.616 48.4959V54.1277C316.616 54.1277 317.826 56.1391 317.624 57.7482C317.423 59.3573 316.012 60.7652 316.012 60.7652C316.012 60.7652 315.004 64.9891 314.4 65.5925C313.795 66.196 314.4 69.8164 315.206 72.6323C316.012 75.4482 322.662 77.4596 322.662 77.4596C320.042 77.4596 315.81 79.0687 312.384 79.0687C308.958 79.0687 300.897 82.0857 296.665 81.2812Z",
    fill: "url(#paint84_radial_210_10376)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M308.756 63.7822C307.95 63.7822 306.539 63.5811 306.539 63.5811C306.539 63.5811 307.345 64.3856 308.353 64.3856C309.36 64.3856 310.855 63.5811 310.855 63.5811C310.855 63.5811 309.562 63.7822 308.756 63.7822Z",
    fill: "#505699"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M308.354 62.2868C307.469 62.2868 306.462 62.3474 305.734 62.4021C305.734 62.4021 306.943 61.568 307.346 61.568C307.749 61.568 307.951 61.7692 308.354 61.7692C308.757 61.7692 308.959 61.3669 309.563 61.568C310.168 61.7692 310.571 62.3403 310.571 62.3403C309.995 62.2516 309.074 62.2868 308.354 62.2868Z",
    fill: "#505699"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M308.551 58.5536C307.947 58.5537 307.543 58.1513 307.14 58.1514C306.737 58.1514 306.334 59.5593 306.737 59.9616C307.14 60.3639 307.745 59.9616 308.551 59.9616C309.357 59.9616 309.559 60.1628 310.163 59.9616C310.768 59.7604 310.365 58.7548 309.962 58.3525C309.559 57.9502 309.156 58.5536 308.551 58.5536Z",
    fill: "#505699"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M311.982 53.1227C310.571 53.3239 310.168 54.7318 310.168 54.7318C310.168 54.7318 311.377 56.1398 312.788 55.9386C314.199 55.7375 315.206 53.3239 315.206 53.3239C315.206 53.3239 313.392 52.9216 311.982 53.1227Z",
    fill: "#505699"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M304.997 53.1769C306.351 53.3728 306.738 54.7437 306.738 54.7437C306.738 54.7437 305.577 56.1147 304.223 55.9188C302.869 55.7229 301.902 53.3728 301.902 53.3728C301.902 53.3728 303.643 52.9811 304.997 53.1769Z",
    fill: "#505699"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M307.547 67.0008C304.322 66.7996 303.113 65.7939 303.113 65.7939C303.113 65.7939 306.136 70.0178 306.942 70.8224C307.748 71.6269 307.748 72.6326 306.942 73.236C306.136 73.8394 306.942 77.8622 306.942 77.8622C306.942 77.8622 306.716 76.4542 306.942 75.2474C307.169 74.0406 307.748 74.0406 308.152 72.6326C308.555 71.2246 307.345 71.0235 307.547 70.0178C307.748 69.0121 312.787 65.9951 312.787 65.9951C312.787 65.9951 310.771 67.2019 307.547 67.0008Z",
    fill: "url(#paint85_linear_210_10376)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M335.96 75.4502C332.736 75.0479 332.131 79.0706 331.123 79.0706C331.123 79.0706 316.412 97.7764 314.397 103.408C312.381 109.04 297.871 120.706 297.871 120.706L317.42 125.332C317.42 125.332 326.69 115.879 329.31 116.482C331.93 117.086 337.371 113.867 339.789 111.253C342.208 108.638 341.603 87.3172 345.432 83.8979C349.261 80.4786 353.09 79.0706 353.09 79.0706C349.06 76.8581 339.185 75.8524 335.96 75.4502Z",
    fill: "url(#paint86_linear_210_10376)",
    stroke: "url(#paint87_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M329.308 116.481C326.688 115.877 317.418 125.331 317.418 125.331C317.418 125.331 319.433 125.934 320.441 127.141C321.449 128.348 324.875 126.739 327.091 127.946C329.308 129.152 329.711 133.376 331.727 134.784C333.742 136.192 338.579 135.991 341.602 135.187C344.625 134.382 347.849 130.963 347.849 130.963L329.308 116.481Z",
    fill: "url(#paint88_linear_210_10376)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M263.209 137.198C266.433 137.601 266.836 139.009 267.643 140.819C267.643 140.819 274.293 134.986 270.061 128.952C265.829 122.918 242.176 114.909 239.63 118.694C238.622 122.314 241.041 128.348 247.691 132.773C254.342 137.198 259.984 136.796 263.209 137.198Z",
    fill: "url(#paint89_linear_210_10376)",
    stroke: "url(#paint90_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M316.415 222.68C318.028 230.726 330.925 235.553 330.925 235.553C330.925 235.553 332.739 226.1 337.374 221.474C337.374 221.474 331.127 209.204 331.127 195.929C331.127 182.654 333.418 175.135 331.127 162.138C329.126 150.787 320.043 141.823 321.655 134.18C323.267 126.537 317.625 125.531 317.625 125.531C317.625 125.531 314.602 133.778 313.795 134.985C312.989 136.192 316.818 164.954 316.415 169.781C316.012 174.609 321.655 204.779 321.655 204.779C324.275 208.4 314.803 214.635 316.415 222.68Z",
    fill: "url(#paint91_linear_210_10376)",
    stroke: "url(#paint92_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M321.652 204.78C319.032 201.16 294.043 203.573 293.035 207.194C292.69 208.434 292.888 209.745 293.299 210.932C293.414 211.246 293.481 211.418 293.481 211.418C293.417 211.259 293.356 211.097 293.299 210.932C292.424 208.555 288.719 198.043 289.609 192.712C290.617 186.678 296.663 168.978 295.655 159.524C294.647 150.071 287.594 133.578 287.594 133.578C287.594 133.578 290.214 134.583 295.655 134.583C301.096 134.583 315.606 125.331 317.219 125.331C318.831 125.331 315.203 131.969 313.994 134.583C312.785 137.198 316.412 163.346 316.412 168.978C316.412 174.61 321.652 204.78 321.652 204.78Z",
    fill: "url(#paint93_linear_210_10376)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M316.412 222.681C314.8 214.636 324.272 208.401 321.652 204.78M321.652 204.78C319.032 201.16 294.043 203.573 293.035 207.194C292.642 208.605 292.954 210.109 293.481 211.418C293.481 211.418 288.601 198.746 289.609 192.712C290.617 186.678 296.663 168.978 295.655 159.524C294.647 150.071 287.594 133.578 287.594 133.578C287.594 133.578 290.214 134.583 295.655 134.583C301.096 134.583 315.606 125.331 317.219 125.331C318.831 125.331 315.203 131.969 313.994 134.583C312.785 137.198 316.412 163.346 316.412 168.978C316.412 174.61 321.652 204.78 321.652 204.78Z",
    stroke: "url(#paint94_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M274.493 195.931C269.455 192.109 274.493 177.024 274.493 177.024C274.493 177.024 275.098 196.735 281.144 186.276C287.189 175.817 292.026 168.979 292.026 168.979C292.026 168.979 287.391 192.713 284.57 195.931C281.748 199.149 279.531 199.752 274.493 195.931Z",
    fill: "url(#paint95_linear_210_10376)",
    stroke: "url(#paint96_radial_210_10376)",
    strokeWidth: 1.09872
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_i_210_10376)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.76,
    cy: 50.3075,
    rx: 22.9744,
    ry: 22.9296,
    fill: "url(#paint97_linear_210_10376)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.76,
    cy: 50.3075,
    rx: 22.9744,
    ry: 22.9296,
    fill: "url(#paint98_linear_210_10376)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_210_10376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.236 45.6817C290.624 45.8829 292.236 42.6647 292.236 42.6647C292.236 42.6647 294.251 36.8317 297.476 36.4294C300.7 36.0271 302.716 32.0044 304.328 32.2055C305.94 32.4067 315.815 35.4238 313.397 36.0271C310.978 36.6305 301.763 37.4428 299.088 39.2453C296.413 41.0479 293.848 45.4806 292.236 45.6817Z",
    fill: "url(#paint99_linear_210_10376)"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M260.588 146.854C261.192 144.44 267.037 126.137 267.037 126.137C267.037 126.137 269.455 127.947 270.261 129.154C271.067 130.361 271.269 131.165 271.269 131.165L267.641 140.417C267.641 140.417 268.044 143.434 267.843 145.245L267.843 145.245C267.641 147.055 266.835 154.296 266.634 155.503C266.432 156.71 266.835 158.118 266.634 158.52C266.432 158.922 265.626 158.52 265.626 158.52C265.626 158.52 266.634 159.727 266.432 160.33C266.23 160.933 265.424 160.732 265.021 160.33C264.618 159.928 260.185 154.899 260.185 153.692C260.185 152.486 259.983 149.267 260.588 146.854Z",
    fill: "url(#paint100_linear_210_10376)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M265.626 158.52C265.626 158.52 266.634 159.727 266.432 160.33C266.23 160.933 265.424 160.732 265.021 160.33C264.618 159.928 260.185 154.899 260.185 153.692C260.185 152.486 259.983 149.267 260.588 146.854C261.192 144.44 267.037 126.137 267.037 126.137C267.037 126.137 269.455 127.947 270.261 129.154C271.067 130.361 271.269 131.165 271.269 131.165L267.641 140.417C267.641 140.417 268.044 143.435 267.843 145.245C267.641 147.055 266.835 154.296 266.634 155.503C266.432 156.71 266.835 158.118 266.634 158.52C266.432 158.922 265.626 158.52 265.626 158.52ZM265.626 158.52C265.626 158.52 264.82 157.715 264.517 157.112M264.517 157.112C264.517 157.112 263.409 156.71 263.409 155.704C263.409 154.698 264.618 151.078 264.618 151.078L264.517 157.112Z",
    stroke: "url(#paint101_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M348.254 108.639C346.642 103.409 342.007 98.7832 342.007 98.7832L342.003 98.8327C341.631 103.347 341.421 105.896 340.395 110.248C340.395 110.248 342.007 110.248 343.619 113.064C345.231 115.88 347.851 123.523 347.851 123.523C347.851 123.523 349.06 127.747 349.262 128.551C349.463 129.356 348.859 131.77 349.06 132.373C349.262 132.976 349.262 134.988 350.471 134.988C351.68 134.988 350.874 131.77 351.68 131.77C352.486 131.77 353.074 133.224 353.292 133.982C353.511 134.74 353.091 135.792 352.486 136.798C351.882 137.804 350.976 138.005 351.126 138.809C351.277 139.614 353.494 138.596 353.494 138.596C353.494 138.596 352.385 140.594 352.032 141.009C351.68 141.424 351.893 142.103 353.091 141.827C354.289 141.55 357.268 135.881 357.323 135.792C357.378 135.704 357.122 137.402 357.122 138.005C357.122 138.608 356.114 139.413 356.114 139.815C356.114 140.217 356.517 140.62 357.122 140.217C357.726 139.815 358.623 138.206 358.734 137.402C358.844 136.597 358.734 135.189 358.331 133.982C357.928 132.775 354.099 129.557 353.494 127.546C352.889 125.534 349.866 113.868 348.254 108.639Z",
    fill: "url(#paint102_linear_210_10376)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M353.494 138.596C353.494 138.596 352.385 140.594 352.032 141.009C351.68 141.424 351.893 142.103 353.091 141.827C354.289 141.55 357.268 135.881 357.323 135.792C357.378 135.704 357.122 137.402 357.122 138.005C357.122 138.608 356.114 139.413 356.114 139.815C356.114 140.217 356.517 140.62 357.122 140.217C357.726 139.815 358.623 138.206 358.734 137.402C358.844 136.597 358.734 135.189 358.331 133.982C357.928 132.775 354.099 129.557 353.494 127.546C352.889 125.534 349.866 113.868 348.254 108.639C346.642 103.409 342.007 98.7832 342.007 98.7832C341.632 103.329 341.425 105.88 340.395 110.248C340.395 110.248 342.007 110.248 343.619 113.064C345.231 115.88 347.851 123.523 347.851 123.523C347.851 123.523 349.06 127.747 349.262 128.551C349.463 129.356 348.859 131.77 349.06 132.373C349.262 132.976 349.262 134.988 350.471 134.988C351.68 134.988 350.874 131.77 351.68 131.77C352.486 131.77 353.074 133.224 353.292 133.982C353.511 134.74 353.091 135.792 352.486 136.798C351.882 137.804 350.976 138.005 351.126 138.809C351.277 139.614 353.494 138.596 353.494 138.596ZM353.494 138.596C353.897 138.596 354.912 136.983 355.308 135.189",
    stroke: "url(#paint103_radial_210_10376)",
    strokeWidth: 1.09872
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M295.66 215.039C295.861 210.01 296.264 205.183 296.264 205.183C296.264 205.183 307.751 202.568 309.364 203.171C310.976 203.775 309.162 214.435 309.364 218.257C309.565 222.078 306.542 226.302 306.341 232.135C306.139 237.968 305.333 248.427 305.333 248.427C305.333 248.427 301.302 243.399 300.295 243.6C299.287 243.801 298.481 244.405 298.481 244.405C298.481 244.405 298.806 236.916 298.481 232.135C298.023 225.384 295.458 220.067 295.66 215.039Z",
    fill: "#6771C7"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M295.66 215.039C295.862 210.01 296.265 205.183 296.265 205.183C296.265 205.183 307.752 202.568 309.364 203.171C310.976 203.775 309.163 214.435 309.364 218.257C309.566 222.078 306.543 226.302 306.341 232.135C306.14 237.968 305.334 248.427 305.334 248.427C305.334 248.427 305.334 233.744 303.923 226.302C302.512 218.86 295.66 215.039 295.66 215.039Z",
    fill: "url(#paint104_linear_210_10376)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M300.293 243.6C299.285 243.801 298.479 244.404 298.479 244.404C298.479 244.404 296.061 250.036 295.053 251.444C294.045 252.852 295.859 255.668 296.867 256.271C297.875 256.875 300.897 255.467 302.107 254.863C303.316 254.26 303.316 263.914 304.323 264.116C305.331 264.317 304.323 256.472 304.525 256.07C304.727 255.668 306.339 254.461 306.742 253.254C307.145 252.047 305.331 248.427 305.331 248.427C305.331 248.427 301.3 243.398 300.293 243.6Z",
    fill: "#27195D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M309.961 206.592C310.365 203.977 309.558 203.172 309.558 203.172C309.558 203.172 323.665 202.167 322.255 206.592C320.844 211.017 315.604 217.855 316.209 222.079C316.813 226.303 319.232 227.912 319.232 227.912C319.232 227.912 315.917 233.25 315.201 237.366L315.191 237.423C314.469 241.571 312.785 251.251 313.186 252.652C313.589 254.06 316.007 256.474 315.201 257.882C314.395 259.29 310.365 259.893 308.752 259.29C307.14 258.686 306.737 252.049 306.939 251.244L306.939 251.244C307.14 250.44 307.745 248.026 307.543 246.015C307.342 244.003 307.543 240.182 307.342 236.963C307.14 233.745 309.558 221.677 309.558 219.062C309.558 216.447 309.558 209.207 309.961 206.592Z",
    fill: "#6771C7"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M309.96 206.592C310.363 203.977 309.557 203.172 309.557 203.172C309.557 203.172 323.664 202.167 322.253 206.592C320.842 211.017 315.602 217.855 316.207 222.079C316.812 226.303 319.23 227.912 319.23 227.912C319.23 227.912 315.916 233.25 315.199 237.366L315.189 237.423C314.467 241.571 312.783 251.251 313.184 252.652V255.267C313.184 255.267 309.96 250.641 309.758 248.227C309.556 245.813 311.975 242.998 311.975 241.187C311.975 239.377 313.789 233.142 313.99 229.924C314.192 226.705 309.098 223.085 309.098 223.085C309.367 221.27 309.557 219.795 309.557 219.062C309.557 216.447 309.557 209.207 309.96 206.592Z",
    fill: "url(#paint105_linear_210_10376)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M307.542 246.014C307.744 248.025 307.139 250.439 306.938 251.243C306.938 251.243 306.944 251.672 306.892 252.225C306.929 254.313 307.44 258.798 308.752 259.289C310.364 259.892 314.394 259.289 315.201 257.881C316.007 256.473 313.588 254.059 313.185 252.651C313.01 252.039 313.233 249.844 313.6 247.221C313.6 247.221 314.395 250.64 315.201 253.255C316.007 255.87 316.611 258.484 316.611 259.892C316.611 261.3 316.208 262.909 315.201 263.714C314.193 264.519 308.752 264.519 307.341 263.714C305.93 262.909 306.132 254.462 306.132 254.462C306.626 254.039 306.818 253.007 306.892 252.225C306.884 251.746 306.9 251.393 306.938 251.243C306.938 251.243 305.93 250.238 305.729 249.232C305.527 248.226 306.132 244.405 306.132 243.6C306.132 242.796 307.442 241.79 307.442 241.79C307.442 243.459 307.439 244.977 307.542 246.014Z",
    fill: "#27195D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    fill: "url(#paint106_linear_210_10376)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint107_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint108_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint109_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M282.554 93.3509C281.949 97.5747 282.554 110.045 282.554 110.045C282.554 110.045 284.972 97.5747 288.398 99.1838C291.824 100.793 294.243 106.425 294.243 106.425C297.638 105.911 299.396 105.652 306.334 104.413C310.991 95.3177 312.099 94.1614 307.947 94.7588C303.794 95.3562 299.079 103.207 297.266 103.005C295.452 102.804 293.839 101.195 292.832 99.1838C291.824 97.1724 292.026 86.3111 288.801 85.3054C285.577 84.2997 283.158 89.127 282.554 93.3509Z",
    fill: "url(#paint110_linear_210_10376)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    fill: "url(#paint111_linear_210_10376)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    stroke: "url(#paint112_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    stroke: "url(#paint113_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M275.101 164.351C278.124 163.547 294.448 152.686 294.448 152.686C294.448 152.686 294.246 158.519 291.828 159.323C289.41 160.128 283.767 174.609 283.767 174.609C283.767 174.609 272.078 165.156 275.101 164.351Z",
    fill: "#291F63"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M275.101 164.352C278.124 163.547 294.448 152.686 294.448 152.686L287.394 133.578C287.394 133.578 291.425 135.589 296.463 134.583C301.501 133.578 316.817 125.331 316.817 125.331L297.874 120.705C307.473 112.556 311.512 108.6 314.197 103.608C314.197 103.608 297.068 105.419 294.448 106.424C291.828 107.43 292.836 121.51 291.828 125.733C290.82 129.957 277.116 142.428 275.705 145.847C274.294 149.266 289.409 141.02 289.208 144.238C289.006 147.456 285.782 150.071 282.759 154.898C279.736 159.726 275.705 159.122 275.101 160.53C274.496 161.938 275.101 164.352 275.101 164.352Z",
    fill: "url(#paint114_linear_210_10376)",
    stroke: "url(#paint115_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M296.665 81.2812C292.433 80.4766 292.634 77.4596 292.634 77.4596C292.634 77.4596 299.688 77.0573 301.3 73.638C302.912 70.2187 303.114 65.9948 302.308 65.5925C301.502 65.1902 300.494 61.5698 300.293 60.7652C300.091 59.9606 298.68 59.9608 298.479 57.7482C298.277 55.5357 299.688 54.1277 299.688 54.1277V48.4959C299.688 46.8868 302.912 42.4618 308.354 42.6629C313.795 42.864 316.616 46.2834 316.616 48.4959V54.1277C316.616 54.1277 317.826 56.1391 317.624 57.7482C317.423 59.3573 316.012 60.7652 316.012 60.7652C316.012 60.7652 315.004 64.9891 314.4 65.5925C313.795 66.196 314.4 69.8164 315.206 72.6323C316.012 75.4482 322.662 77.4596 322.662 77.4596C320.042 77.4596 315.81 79.0687 312.384 79.0687C308.958 79.0687 300.897 82.0857 296.665 81.2812Z",
    fill: "#959ACF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M296.665 81.2812C292.433 80.4766 292.634 77.4596 292.634 77.4596C292.634 77.4596 299.688 77.0573 301.3 73.638C302.912 70.2187 303.114 65.9948 302.308 65.5925C301.502 65.1902 300.494 61.5698 300.293 60.7652C300.091 59.9606 298.68 59.9608 298.479 57.7482C298.277 55.5357 299.688 54.1277 299.688 54.1277V48.4959C299.688 46.8868 302.912 42.4618 308.354 42.6629C313.795 42.864 316.616 46.2834 316.616 48.4959V54.1277C316.616 54.1277 317.826 56.1391 317.624 57.7482C317.423 59.3573 316.012 60.7652 316.012 60.7652C316.012 60.7652 315.004 64.9891 314.4 65.5925C313.795 66.196 314.4 69.8164 315.206 72.6323C316.012 75.4482 322.662 77.4596 322.662 77.4596C320.042 77.4596 315.81 79.0687 312.384 79.0687C308.958 79.0687 300.897 82.0857 296.665 81.2812Z",
    fill: "url(#paint116_radial_210_10376)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M308.756 63.7822C307.95 63.7822 306.539 63.5811 306.539 63.5811C306.539 63.5811 307.345 64.3856 308.353 64.3856C309.36 64.3856 310.855 63.5811 310.855 63.5811C310.855 63.5811 309.562 63.7822 308.756 63.7822Z",
    fill: "#505699"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M308.354 62.2868C307.469 62.2868 306.462 62.3474 305.734 62.4021C305.734 62.4021 306.943 61.568 307.346 61.568C307.749 61.568 307.951 61.7692 308.354 61.7692C308.757 61.7692 308.959 61.3669 309.563 61.568C310.168 61.7692 310.571 62.3403 310.571 62.3403C309.995 62.2516 309.074 62.2868 308.354 62.2868Z",
    fill: "#505699"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M308.551 58.5536C307.947 58.5537 307.543 58.1513 307.14 58.1514C306.737 58.1514 306.334 59.5593 306.737 59.9616C307.14 60.3639 307.745 59.9616 308.551 59.9616C309.357 59.9616 309.559 60.1628 310.163 59.9616C310.768 59.7604 310.365 58.7548 309.962 58.3525C309.559 57.9502 309.156 58.5536 308.551 58.5536Z",
    fill: "#505699"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M311.982 53.1227C310.571 53.3239 310.168 54.7318 310.168 54.7318C310.168 54.7318 311.377 56.1398 312.788 55.9386C314.199 55.7375 315.206 53.3239 315.206 53.3239C315.206 53.3239 313.392 52.9216 311.982 53.1227Z",
    fill: "#505699"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M304.997 53.1769C306.351 53.3728 306.738 54.7437 306.738 54.7437C306.738 54.7437 305.577 56.1147 304.223 55.9188C302.869 55.7229 301.902 53.3728 301.902 53.3728C301.902 53.3728 303.643 52.9811 304.997 53.1769Z",
    fill: "#505699"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M307.547 67.0008C304.322 66.7996 303.113 65.7939 303.113 65.7939C303.113 65.7939 306.136 70.0178 306.942 70.8224C307.748 71.6269 307.748 72.6326 306.942 73.236C306.136 73.8394 306.942 77.8622 306.942 77.8622C306.942 77.8622 306.716 76.4542 306.942 75.2474C307.169 74.0406 307.748 74.0406 308.152 72.6326C308.555 71.2246 307.345 71.0235 307.547 70.0178C307.748 69.0121 312.787 65.9951 312.787 65.9951C312.787 65.9951 310.771 67.2019 307.547 67.0008Z",
    fill: "url(#paint117_linear_210_10376)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M335.96 75.4502C332.736 75.0479 332.131 79.0706 331.123 79.0706C331.123 79.0706 316.412 97.7764 314.397 103.408C312.381 109.04 297.871 120.706 297.871 120.706L317.42 125.332C317.42 125.332 326.69 115.879 329.31 116.482C331.93 117.086 337.371 113.867 339.789 111.253C342.208 108.638 341.603 87.3172 345.432 83.8979C349.261 80.4786 353.09 79.0706 353.09 79.0706C349.06 76.8581 339.185 75.8524 335.96 75.4502Z",
    fill: "url(#paint118_linear_210_10376)",
    stroke: "url(#paint119_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M329.308 116.481C326.688 115.877 317.418 125.331 317.418 125.331C317.418 125.331 319.433 125.934 320.441 127.141C321.449 128.348 324.875 126.739 327.091 127.946C329.308 129.152 329.711 133.376 331.727 134.784C333.742 136.192 338.579 135.991 341.602 135.187C344.625 134.382 347.849 130.963 347.849 130.963L329.308 116.481Z",
    fill: "url(#paint120_linear_210_10376)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M263.209 137.198C266.433 137.601 266.836 139.009 267.643 140.819C267.643 140.819 274.293 134.986 270.061 128.952C265.829 122.918 242.176 114.909 239.63 118.694C238.622 122.314 241.041 128.348 247.691 132.773C254.342 137.198 259.984 136.796 263.209 137.198Z",
    fill: "url(#paint121_linear_210_10376)",
    stroke: "url(#paint122_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M316.415 222.68C318.028 230.726 330.925 235.553 330.925 235.553C330.925 235.553 332.739 226.1 337.374 221.474C337.374 221.474 331.127 209.204 331.127 195.929C331.127 182.654 333.418 175.135 331.127 162.138C329.126 150.787 320.043 141.823 321.655 134.18C323.267 126.537 317.625 125.531 317.625 125.531C317.625 125.531 314.602 133.778 313.795 134.985C312.989 136.192 316.818 164.954 316.415 169.781C316.012 174.609 321.655 204.779 321.655 204.779C324.275 208.4 314.803 214.635 316.415 222.68Z",
    fill: "url(#paint123_linear_210_10376)",
    stroke: "url(#paint124_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M321.652 204.78C319.032 201.16 294.043 203.573 293.035 207.194C292.69 208.434 292.888 209.745 293.299 210.932C293.414 211.246 293.481 211.418 293.481 211.418C293.417 211.259 293.356 211.097 293.299 210.932C292.424 208.555 288.719 198.043 289.609 192.712C290.617 186.678 296.663 168.978 295.655 159.524C294.647 150.071 287.594 133.578 287.594 133.578C287.594 133.578 290.214 134.583 295.655 134.583C301.096 134.583 315.606 125.331 317.219 125.331C318.831 125.331 315.203 131.969 313.994 134.583C312.785 137.198 316.412 163.346 316.412 168.978C316.412 174.61 321.652 204.78 321.652 204.78Z",
    fill: "url(#paint125_linear_210_10376)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M316.412 222.681C314.8 214.636 324.272 208.401 321.652 204.78M321.652 204.78C319.032 201.16 294.043 203.573 293.035 207.194C292.642 208.605 292.954 210.109 293.481 211.418C293.481 211.418 288.601 198.746 289.609 192.712C290.617 186.678 296.663 168.978 295.655 159.524C294.647 150.071 287.594 133.578 287.594 133.578C287.594 133.578 290.214 134.583 295.655 134.583C301.096 134.583 315.606 125.331 317.219 125.331C318.831 125.331 315.203 131.969 313.994 134.583C312.785 137.198 316.412 163.346 316.412 168.978C316.412 174.61 321.652 204.78 321.652 204.78Z",
    stroke: "url(#paint126_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M274.493 195.931C269.455 192.109 274.493 177.024 274.493 177.024C274.493 177.024 275.098 196.735 281.144 186.276C287.189 175.817 292.026 168.979 292.026 168.979C292.026 168.979 287.391 192.713 284.57 195.931C281.748 199.149 279.531 199.752 274.493 195.931Z",
    fill: "url(#paint127_linear_210_10376)",
    stroke: "url(#paint128_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M260.588 146.855C261.192 144.441 267.037 126.138 267.037 126.138C267.037 126.138 269.455 127.948 270.261 129.155C271.067 130.362 271.269 131.166 271.269 131.166L267.641 140.418C267.641 140.418 268.044 143.435 267.843 145.246L267.843 145.246C267.641 147.056 266.835 154.297 266.634 155.504C266.432 156.711 266.835 158.118 266.634 158.521C266.432 158.923 265.626 158.521 265.626 158.521C265.626 158.521 266.634 159.728 266.432 160.331C266.23 160.934 265.424 160.733 265.021 160.331C264.618 159.929 260.185 154.9 260.185 153.693C260.185 152.487 259.983 149.268 260.588 146.855Z",
    fill: "url(#paint129_linear_210_10376)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M265.626 158.521C265.626 158.521 266.634 159.728 266.432 160.331C266.23 160.934 265.424 160.733 265.021 160.331C264.618 159.929 260.185 154.9 260.185 153.693C260.185 152.487 259.983 149.268 260.588 146.855C261.192 144.441 267.037 126.138 267.037 126.138C267.037 126.138 269.455 127.948 270.261 129.155C271.067 130.362 271.269 131.166 271.269 131.166L267.641 140.418C267.641 140.418 268.044 143.435 267.843 145.246C267.641 147.056 266.835 154.297 266.634 155.504C266.432 156.711 266.835 158.118 266.634 158.521C266.432 158.923 265.626 158.521 265.626 158.521ZM265.626 158.521C265.626 158.521 264.82 157.716 264.517 157.113M264.517 157.113C264.517 157.113 263.409 156.711 263.409 155.705C263.409 154.699 264.618 151.079 264.618 151.079L264.517 157.113Z",
    stroke: "url(#paint130_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M348.254 108.638C346.642 103.408 342.007 98.7822 342.007 98.7822L342.003 98.8317C341.631 103.346 341.421 105.895 340.395 110.247C340.395 110.247 342.007 110.247 343.619 113.063C345.231 115.879 347.851 123.522 347.851 123.522C347.851 123.522 349.06 127.746 349.262 128.551C349.463 129.355 348.859 131.769 349.06 132.372C349.262 132.976 349.262 134.987 350.471 134.987C351.68 134.987 350.874 131.769 351.68 131.769C352.486 131.769 353.074 133.223 353.292 133.981C353.511 134.739 353.091 135.791 352.486 136.797C351.882 137.803 350.976 138.004 351.126 138.808C351.277 139.613 353.494 138.595 353.494 138.595C353.494 138.595 352.385 140.593 352.032 141.008C351.68 141.423 351.893 142.102 353.091 141.826C354.289 141.549 357.268 135.88 357.323 135.791C357.378 135.703 357.122 137.401 357.122 138.004C357.122 138.607 356.114 139.412 356.114 139.814C356.114 140.216 356.517 140.619 357.122 140.216C357.726 139.814 358.623 138.205 358.734 137.401C358.844 136.596 358.734 135.188 358.331 133.981C357.928 132.774 354.099 129.556 353.494 127.545C352.889 125.533 349.866 113.868 348.254 108.638Z",
    fill: "url(#paint131_linear_210_10376)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M353.494 138.595C353.494 138.595 352.385 140.593 352.032 141.008C351.68 141.423 351.893 142.102 353.091 141.826C354.289 141.549 357.268 135.88 357.323 135.791C357.378 135.703 357.122 137.401 357.122 138.004C357.122 138.607 356.114 139.412 356.114 139.814C356.114 140.216 356.517 140.619 357.122 140.216C357.726 139.814 358.623 138.205 358.734 137.401C358.844 136.596 358.734 135.188 358.331 133.981C357.928 132.774 354.099 129.556 353.494 127.545C352.889 125.533 349.866 113.868 348.254 108.638C346.642 103.408 342.007 98.7822 342.007 98.7822C341.632 103.328 341.425 105.879 340.395 110.247C340.395 110.247 342.007 110.247 343.619 113.063C345.231 115.879 347.851 123.522 347.851 123.522C347.851 123.522 349.06 127.746 349.262 128.551C349.463 129.355 348.859 131.769 349.06 132.372C349.262 132.976 349.262 134.987 350.471 134.987C351.68 134.987 350.874 131.769 351.68 131.769C352.486 131.769 353.074 133.223 353.292 133.981C353.511 134.739 353.091 135.791 352.486 136.797C351.882 137.803 350.976 138.004 351.126 138.808C351.277 139.613 353.494 138.595 353.494 138.595ZM353.494 138.595C353.897 138.595 354.912 136.982 355.308 135.188",
    stroke: "url(#paint132_radial_210_10376)",
    strokeWidth: 1.09872
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M295.66 215.04C295.861 210.011 296.264 205.184 296.264 205.184C296.264 205.184 307.751 202.569 309.364 203.172C310.976 203.776 309.162 214.436 309.364 218.258C309.565 222.079 306.542 226.303 306.341 232.136C306.139 237.969 305.333 248.428 305.333 248.428C305.333 248.428 301.302 243.4 300.295 243.601C299.287 243.802 298.481 244.406 298.481 244.406C298.481 244.406 298.806 236.917 298.481 232.136C298.023 225.385 295.458 220.068 295.66 215.04Z",
    fill: "#6771C7"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M295.66 215.04C295.862 210.011 296.265 205.184 296.265 205.184C296.265 205.184 307.752 202.569 309.364 203.172C310.976 203.776 309.163 214.436 309.364 218.258C309.566 222.079 306.543 226.303 306.341 232.136C306.14 237.969 305.334 248.428 305.334 248.428C305.334 248.428 305.334 233.745 303.923 226.303C302.512 218.861 295.66 215.04 295.66 215.04Z",
    fill: "url(#paint133_linear_210_10376)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M300.293 243.601C299.285 243.802 298.479 244.405 298.479 244.405C298.479 244.405 296.061 250.037 295.053 251.445C294.045 252.853 295.859 255.669 296.867 256.272C297.875 256.876 300.897 255.468 302.107 254.864C303.316 254.261 303.316 263.915 304.323 264.117C305.331 264.318 304.323 256.473 304.525 256.071C304.727 255.669 306.339 254.462 306.742 253.255C307.145 252.048 305.331 248.428 305.331 248.428C305.331 248.428 301.3 243.399 300.293 243.601Z",
    fill: "#27195D"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M309.961 206.592C310.365 203.977 309.558 203.172 309.558 203.172C309.558 203.172 323.665 202.167 322.255 206.592C320.844 211.017 315.604 217.855 316.209 222.079C316.813 226.303 319.232 227.912 319.232 227.912C319.232 227.912 315.917 233.25 315.201 237.366L315.191 237.423C314.469 241.571 312.785 251.251 313.186 252.652C313.589 254.06 316.007 256.474 315.201 257.882C314.395 259.29 310.365 259.893 308.752 259.29C307.14 258.686 306.737 252.049 306.939 251.244L306.939 251.244C307.14 250.44 307.745 248.026 307.543 246.015C307.342 244.003 307.543 240.182 307.342 236.963C307.14 233.745 309.558 221.677 309.558 219.062C309.558 216.447 309.558 209.207 309.961 206.592Z",
    fill: "#6771C7"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M309.96 206.592C310.363 203.977 309.557 203.172 309.557 203.172C309.557 203.172 323.664 202.167 322.253 206.592C320.842 211.017 315.602 217.855 316.207 222.079C316.812 226.303 319.23 227.912 319.23 227.912C319.23 227.912 315.916 233.25 315.199 237.366L315.189 237.423C314.467 241.571 312.783 251.251 313.184 252.652V255.267C313.184 255.267 309.96 250.641 309.758 248.227C309.556 245.813 311.975 242.998 311.975 241.187C311.975 239.377 313.789 233.142 313.99 229.924C314.192 226.705 309.098 223.085 309.098 223.085C309.367 221.27 309.557 219.795 309.557 219.062C309.557 216.447 309.557 209.207 309.96 206.592Z",
    fill: "url(#paint134_linear_210_10376)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M307.542 246.014C307.744 248.025 307.139 250.439 306.938 251.243C306.938 251.243 306.944 251.672 306.892 252.225C306.929 254.313 307.44 258.798 308.752 259.289C310.364 259.892 314.394 259.289 315.201 257.881C316.007 256.473 313.588 254.059 313.185 252.651C313.01 252.039 313.233 249.844 313.6 247.221C313.6 247.221 314.395 250.64 315.201 253.255C316.007 255.87 316.611 258.484 316.611 259.892C316.611 261.3 316.208 262.909 315.201 263.714C314.193 264.519 308.752 264.519 307.341 263.714C305.93 262.909 306.132 254.462 306.132 254.462C306.626 254.039 306.818 253.007 306.892 252.225C306.884 251.746 306.9 251.393 306.938 251.243C306.938 251.243 305.93 250.238 305.729 249.232C305.527 248.226 306.132 244.405 306.132 243.6C306.132 242.796 307.442 241.79 307.442 241.79C307.442 243.459 307.439 244.977 307.542 246.014Z",
    fill: "#27195D"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    fill: "url(#paint135_linear_210_10376)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint136_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint137_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint138_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M282.554 93.3509C281.949 97.5747 282.554 110.045 282.554 110.045C282.554 110.045 284.972 97.5747 288.398 99.1838C291.824 100.793 294.243 106.425 294.243 106.425C297.638 105.911 299.396 105.652 306.334 104.413C310.991 95.3177 312.099 94.1614 307.947 94.7588C303.794 95.3562 299.079 103.207 297.266 103.005C295.452 102.804 293.839 101.195 292.832 99.1838C291.824 97.1724 292.026 86.3111 288.801 85.3054C285.577 84.2997 283.158 89.127 282.554 93.3509Z",
    fill: "url(#paint139_linear_210_10376)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    fill: "url(#paint140_linear_210_10376)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    stroke: "url(#paint141_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    stroke: "url(#paint142_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M275.101 164.351C278.124 163.547 294.448 152.686 294.448 152.686C294.448 152.686 294.246 158.519 291.828 159.323C289.41 160.128 283.767 174.609 283.767 174.609C283.767 174.609 272.078 165.156 275.101 164.351Z",
    fill: "#291F63"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M275.101 164.352C278.124 163.547 294.448 152.686 294.448 152.686L287.394 133.578C287.394 133.578 291.425 135.589 296.463 134.583C301.501 133.578 316.817 125.331 316.817 125.331L297.874 120.705C307.473 112.556 311.512 108.6 314.197 103.608C314.197 103.608 297.068 105.419 294.448 106.424C291.828 107.43 292.836 121.51 291.828 125.733C290.82 129.957 277.116 142.428 275.705 145.847C274.294 149.266 289.409 141.02 289.208 144.238C289.006 147.456 285.782 150.071 282.759 154.898C279.736 159.726 275.705 159.122 275.101 160.53C274.496 161.938 275.101 164.352 275.101 164.352Z",
    fill: "url(#paint143_linear_210_10376)",
    stroke: "url(#paint144_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M296.665 81.2812C292.433 80.4766 292.634 77.4596 292.634 77.4596C292.634 77.4596 299.688 77.0573 301.3 73.638C302.912 70.2187 303.114 65.9948 302.308 65.5925C301.502 65.1902 300.494 61.5698 300.293 60.7652C300.091 59.9606 298.68 59.9608 298.479 57.7482C298.277 55.5357 299.688 54.1277 299.688 54.1277V48.4959C299.688 46.8868 302.912 42.4618 308.354 42.6629C313.795 42.864 316.616 46.2834 316.616 48.4959V54.1277C316.616 54.1277 317.826 56.1391 317.624 57.7482C317.423 59.3573 316.012 60.7652 316.012 60.7652C316.012 60.7652 315.004 64.9891 314.4 65.5925C313.795 66.196 314.4 69.8164 315.206 72.6323C316.012 75.4482 322.662 77.4596 322.662 77.4596C320.042 77.4596 315.81 79.0687 312.384 79.0687C308.958 79.0687 300.897 82.0857 296.665 81.2812Z",
    fill: "#959ACF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M296.665 81.2812C292.433 80.4766 292.634 77.4596 292.634 77.4596C292.634 77.4596 299.688 77.0573 301.3 73.638C302.912 70.2187 303.114 65.9948 302.308 65.5925C301.502 65.1902 300.494 61.5698 300.293 60.7652C300.091 59.9606 298.68 59.9608 298.479 57.7482C298.277 55.5357 299.688 54.1277 299.688 54.1277V48.4959C299.688 46.8868 302.912 42.4618 308.354 42.6629C313.795 42.864 316.616 46.2834 316.616 48.4959V54.1277C316.616 54.1277 317.826 56.1391 317.624 57.7482C317.423 59.3573 316.012 60.7652 316.012 60.7652C316.012 60.7652 315.004 64.9891 314.4 65.5925C313.795 66.196 314.4 69.8164 315.206 72.6323C316.012 75.4482 322.662 77.4596 322.662 77.4596C320.042 77.4596 315.81 79.0687 312.384 79.0687C308.958 79.0687 300.897 82.0857 296.665 81.2812Z",
    fill: "url(#paint145_radial_210_10376)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M308.756 63.7822C307.95 63.7822 306.539 63.5811 306.539 63.5811C306.539 63.5811 307.345 64.3856 308.353 64.3856C309.36 64.3856 310.855 63.5811 310.855 63.5811C310.855 63.5811 309.562 63.7822 308.756 63.7822Z",
    fill: "#505699"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M308.354 62.2868C307.469 62.2868 306.462 62.3474 305.734 62.4021C305.734 62.4021 306.943 61.568 307.346 61.568C307.749 61.568 307.951 61.7692 308.354 61.7692C308.757 61.7692 308.959 61.3669 309.563 61.568C310.168 61.7692 310.571 62.3403 310.571 62.3403C309.995 62.2516 309.074 62.2868 308.354 62.2868Z",
    fill: "#505699"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M308.551 58.5536C307.947 58.5537 307.543 58.1513 307.14 58.1514C306.737 58.1514 306.334 59.5593 306.737 59.9616C307.14 60.3639 307.745 59.9616 308.551 59.9616C309.357 59.9616 309.559 60.1628 310.163 59.9616C310.768 59.7604 310.365 58.7548 309.962 58.3525C309.559 57.9502 309.156 58.5536 308.551 58.5536Z",
    fill: "#505699"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M311.982 53.1227C310.571 53.3239 310.168 54.7318 310.168 54.7318C310.168 54.7318 311.377 56.1398 312.788 55.9386C314.199 55.7375 315.206 53.3239 315.206 53.3239C315.206 53.3239 313.392 52.9216 311.982 53.1227Z",
    fill: "#505699"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M304.997 53.1769C306.351 53.3728 306.738 54.7437 306.738 54.7437C306.738 54.7437 305.577 56.1147 304.223 55.9188C302.869 55.7229 301.902 53.3728 301.902 53.3728C301.902 53.3728 303.643 52.9811 304.997 53.1769Z",
    fill: "#505699"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M307.547 67.0008C304.322 66.7996 303.113 65.7939 303.113 65.7939C303.113 65.7939 306.136 70.0178 306.942 70.8224C307.748 71.6269 307.748 72.6326 306.942 73.236C306.136 73.8394 306.942 77.8622 306.942 77.8622C306.942 77.8622 306.716 76.4542 306.942 75.2474C307.169 74.0406 307.748 74.0406 308.152 72.6326C308.555 71.2246 307.345 71.0235 307.547 70.0178C307.748 69.0121 312.787 65.9951 312.787 65.9951C312.787 65.9951 310.771 67.2019 307.547 67.0008Z",
    fill: "url(#paint146_linear_210_10376)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M335.96 75.4502C332.736 75.0479 332.131 79.0706 331.123 79.0706C331.123 79.0706 316.412 97.7764 314.397 103.408C312.381 109.04 297.871 120.706 297.871 120.706L317.42 125.332C317.42 125.332 326.69 115.879 329.31 116.482C331.93 117.086 337.371 113.867 339.789 111.253C342.208 108.638 341.603 87.3172 345.432 83.8979C349.261 80.4786 353.09 79.0706 353.09 79.0706C349.06 76.8581 339.185 75.8524 335.96 75.4502Z",
    fill: "url(#paint147_linear_210_10376)",
    stroke: "url(#paint148_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M329.308 116.481C326.688 115.877 317.418 125.331 317.418 125.331C317.418 125.331 319.433 125.934 320.441 127.141C321.449 128.348 324.875 126.739 327.091 127.946C329.308 129.152 329.711 133.376 331.727 134.784C333.742 136.192 338.579 135.991 341.602 135.187C344.625 134.382 347.849 130.963 347.849 130.963L329.308 116.481Z",
    fill: "url(#paint149_linear_210_10376)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M263.209 137.198C266.433 137.601 266.836 139.009 267.643 140.819C267.643 140.819 274.293 134.986 270.061 128.952C265.829 122.918 242.176 114.909 239.63 118.694C238.622 122.314 241.041 128.348 247.691 132.773C254.342 137.198 259.984 136.796 263.209 137.198Z",
    fill: "url(#paint150_linear_210_10376)",
    stroke: "url(#paint151_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M316.415 222.68C318.028 230.726 330.925 235.553 330.925 235.553C330.925 235.553 332.739 226.1 337.374 221.474C337.374 221.474 331.127 209.204 331.127 195.929C331.127 182.654 333.418 175.135 331.127 162.138C329.126 150.787 320.043 141.823 321.655 134.18C323.267 126.537 317.625 125.531 317.625 125.531C317.625 125.531 314.602 133.778 313.795 134.985C312.989 136.192 316.818 164.954 316.415 169.781C316.012 174.609 321.655 204.779 321.655 204.779C324.275 208.4 314.803 214.635 316.415 222.68Z",
    fill: "url(#paint152_linear_210_10376)",
    stroke: "url(#paint153_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M321.652 204.78C319.032 201.16 294.043 203.573 293.035 207.194C292.69 208.434 292.888 209.745 293.299 210.932C293.414 211.246 293.481 211.418 293.481 211.418C293.417 211.259 293.356 211.097 293.299 210.932C292.424 208.555 288.719 198.043 289.609 192.712C290.617 186.678 296.663 168.978 295.655 159.524C294.647 150.071 287.594 133.578 287.594 133.578C287.594 133.578 290.214 134.583 295.655 134.583C301.096 134.583 315.606 125.331 317.219 125.331C318.831 125.331 315.203 131.969 313.994 134.583C312.785 137.198 316.412 163.346 316.412 168.978C316.412 174.61 321.652 204.78 321.652 204.78Z",
    fill: "url(#paint154_linear_210_10376)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M316.412 222.681C314.8 214.636 324.272 208.401 321.652 204.78M321.652 204.78C319.032 201.16 294.043 203.573 293.035 207.194C292.642 208.605 292.954 210.109 293.481 211.418C293.481 211.418 288.601 198.746 289.609 192.712C290.617 186.678 296.663 168.978 295.655 159.524C294.647 150.071 287.594 133.578 287.594 133.578C287.594 133.578 290.214 134.583 295.655 134.583C301.096 134.583 315.606 125.331 317.219 125.331C318.831 125.331 315.203 131.969 313.994 134.583C312.785 137.198 316.412 163.346 316.412 168.978C316.412 174.61 321.652 204.78 321.652 204.78Z",
    stroke: "url(#paint155_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M274.493 195.931C269.455 192.109 274.493 177.024 274.493 177.024C274.493 177.024 275.098 196.735 281.144 186.276C287.189 175.817 292.026 168.979 292.026 168.979C292.026 168.979 287.391 192.713 284.57 195.931C281.748 199.149 279.531 199.752 274.493 195.931Z",
    fill: "url(#paint156_linear_210_10376)",
    stroke: "url(#paint157_radial_210_10376)",
    strokeWidth: 1.09872
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_i_210_10376)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.76,
    cy: 50.3075,
    rx: 22.9744,
    ry: 22.9296,
    fill: "url(#paint158_linear_210_10376)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.76,
    cy: 50.3075,
    rx: 22.9744,
    ry: 22.9296,
    fill: "url(#paint159_linear_210_10376)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_210_10376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.236 45.6817C290.624 45.8829 292.236 42.6647 292.236 42.6647C292.236 42.6647 294.251 36.8317 297.476 36.4294C300.7 36.0271 302.716 32.0044 304.328 32.2055C305.94 32.4067 315.815 35.4238 313.397 36.0271C310.978 36.6305 301.763 37.4428 299.088 39.2453C296.413 41.0479 293.848 45.4806 292.236 45.6817Z",
    fill: "url(#paint160_linear_210_10376)"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M260.588 146.854C261.192 144.44 267.037 126.137 267.037 126.137C267.037 126.137 269.455 127.947 270.261 129.154C271.067 130.361 271.269 131.165 271.269 131.165L267.641 140.417C267.641 140.417 268.044 143.434 267.843 145.245L267.843 145.245C267.641 147.055 266.835 154.296 266.634 155.503C266.432 156.71 266.835 158.118 266.634 158.52C266.432 158.922 265.626 158.52 265.626 158.52C265.626 158.52 266.634 159.727 266.432 160.33C266.23 160.933 265.424 160.732 265.021 160.33C264.618 159.928 260.185 154.899 260.185 153.692C260.185 152.486 259.983 149.267 260.588 146.854Z",
    fill: "url(#paint161_linear_210_10376)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M265.626 158.52C265.626 158.52 266.634 159.727 266.432 160.33C266.23 160.933 265.424 160.732 265.021 160.33C264.618 159.928 260.185 154.899 260.185 153.692C260.185 152.486 259.983 149.267 260.588 146.854C261.192 144.44 267.037 126.137 267.037 126.137C267.037 126.137 269.455 127.947 270.261 129.154C271.067 130.361 271.269 131.165 271.269 131.165L267.641 140.417C267.641 140.417 268.044 143.435 267.843 145.245C267.641 147.055 266.835 154.296 266.634 155.503C266.432 156.71 266.835 158.118 266.634 158.52C266.432 158.922 265.626 158.52 265.626 158.52ZM265.626 158.52C265.626 158.52 264.82 157.715 264.517 157.112M264.517 157.112C264.517 157.112 263.409 156.71 263.409 155.704C263.409 154.698 264.618 151.078 264.618 151.078L264.517 157.112Z",
    stroke: "url(#paint162_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M348.254 108.639C346.642 103.409 342.007 98.7832 342.007 98.7832L342.003 98.8327C341.631 103.347 341.421 105.896 340.395 110.248C340.395 110.248 342.007 110.248 343.619 113.064C345.231 115.88 347.851 123.523 347.851 123.523C347.851 123.523 349.06 127.747 349.262 128.551C349.463 129.356 348.859 131.77 349.06 132.373C349.262 132.976 349.262 134.988 350.471 134.988C351.68 134.988 350.874 131.77 351.68 131.77C352.486 131.77 353.074 133.224 353.292 133.982C353.511 134.74 353.091 135.792 352.486 136.798C351.882 137.804 350.976 138.005 351.126 138.809C351.277 139.614 353.494 138.596 353.494 138.596C353.494 138.596 352.385 140.594 352.032 141.009C351.68 141.424 351.893 142.103 353.091 141.827C354.289 141.55 357.268 135.881 357.323 135.792C357.378 135.704 357.122 137.402 357.122 138.005C357.122 138.608 356.114 139.413 356.114 139.815C356.114 140.217 356.517 140.62 357.122 140.217C357.726 139.815 358.623 138.206 358.734 137.402C358.844 136.597 358.734 135.189 358.331 133.982C357.928 132.775 354.099 129.557 353.494 127.546C352.889 125.534 349.866 113.868 348.254 108.639Z",
    fill: "url(#paint163_linear_210_10376)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M353.494 138.596C353.494 138.596 352.385 140.594 352.032 141.009C351.68 141.424 351.893 142.103 353.091 141.827C354.289 141.55 357.268 135.881 357.323 135.792C357.378 135.704 357.122 137.402 357.122 138.005C357.122 138.608 356.114 139.413 356.114 139.815C356.114 140.217 356.517 140.62 357.122 140.217C357.726 139.815 358.623 138.206 358.734 137.402C358.844 136.597 358.734 135.189 358.331 133.982C357.928 132.775 354.099 129.557 353.494 127.546C352.889 125.534 349.866 113.868 348.254 108.639C346.642 103.409 342.007 98.7832 342.007 98.7832C341.632 103.329 341.425 105.88 340.395 110.248C340.395 110.248 342.007 110.248 343.619 113.064C345.231 115.88 347.851 123.523 347.851 123.523C347.851 123.523 349.06 127.747 349.262 128.551C349.463 129.356 348.859 131.77 349.06 132.373C349.262 132.976 349.262 134.988 350.471 134.988C351.68 134.988 350.874 131.77 351.68 131.77C352.486 131.77 353.074 133.224 353.292 133.982C353.511 134.74 353.091 135.792 352.486 136.798C351.882 137.804 350.976 138.005 351.126 138.809C351.277 139.614 353.494 138.596 353.494 138.596ZM353.494 138.596C353.897 138.596 354.912 136.983 355.308 135.189",
    stroke: "url(#paint164_radial_210_10376)",
    strokeWidth: 1.09872
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M295.66 215.039C295.861 210.01 296.264 205.183 296.264 205.183C296.264 205.183 307.751 202.568 309.364 203.171C310.976 203.775 309.162 214.435 309.364 218.257C309.565 222.078 306.542 226.302 306.341 232.135C306.139 237.968 305.333 248.427 305.333 248.427C305.333 248.427 301.302 243.399 300.295 243.6C299.287 243.801 298.481 244.405 298.481 244.405C298.481 244.405 298.806 236.916 298.481 232.135C298.023 225.384 295.458 220.067 295.66 215.039Z",
    fill: "#6771C7"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M295.66 215.039C295.862 210.01 296.265 205.183 296.265 205.183C296.265 205.183 307.752 202.568 309.364 203.171C310.976 203.775 309.163 214.435 309.364 218.257C309.566 222.078 306.543 226.302 306.341 232.135C306.14 237.968 305.334 248.427 305.334 248.427C305.334 248.427 305.334 233.744 303.923 226.302C302.512 218.86 295.66 215.039 295.66 215.039Z",
    fill: "url(#paint165_linear_210_10376)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M300.293 243.6C299.285 243.801 298.479 244.404 298.479 244.404C298.479 244.404 296.061 250.036 295.053 251.444C294.045 252.852 295.859 255.668 296.867 256.271C297.875 256.875 300.897 255.467 302.107 254.863C303.316 254.26 303.316 263.914 304.323 264.116C305.331 264.317 304.323 256.472 304.525 256.07C304.727 255.668 306.339 254.461 306.742 253.254C307.145 252.047 305.331 248.427 305.331 248.427C305.331 248.427 301.3 243.398 300.293 243.6Z",
    fill: "#27195D"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M309.961 206.592C310.365 203.977 309.558 203.172 309.558 203.172C309.558 203.172 323.665 202.167 322.255 206.592C320.844 211.017 315.604 217.855 316.209 222.079C316.813 226.303 319.232 227.912 319.232 227.912C319.232 227.912 315.917 233.25 315.201 237.366L315.191 237.423C314.469 241.571 312.785 251.251 313.186 252.652C313.589 254.06 316.007 256.474 315.201 257.882C314.395 259.29 310.365 259.893 308.752 259.29C307.14 258.686 306.737 252.049 306.939 251.244L306.939 251.244C307.14 250.44 307.745 248.026 307.543 246.015C307.342 244.003 307.543 240.182 307.342 236.963C307.14 233.745 309.558 221.677 309.558 219.062C309.558 216.447 309.558 209.207 309.961 206.592Z",
    fill: "#6771C7"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M309.96 206.592C310.363 203.977 309.557 203.172 309.557 203.172C309.557 203.172 323.664 202.167 322.253 206.592C320.842 211.017 315.602 217.855 316.207 222.079C316.812 226.303 319.23 227.912 319.23 227.912C319.23 227.912 315.916 233.25 315.199 237.366L315.189 237.423C314.467 241.571 312.783 251.251 313.184 252.652V255.267C313.184 255.267 309.96 250.641 309.758 248.227C309.556 245.813 311.975 242.998 311.975 241.187C311.975 239.377 313.789 233.142 313.99 229.924C314.192 226.705 309.098 223.085 309.098 223.085C309.367 221.27 309.557 219.795 309.557 219.062C309.557 216.447 309.557 209.207 309.96 206.592Z",
    fill: "url(#paint166_linear_210_10376)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M307.542 246.014C307.744 248.025 307.139 250.439 306.938 251.243C306.938 251.243 306.944 251.672 306.892 252.225C306.929 254.313 307.44 258.798 308.752 259.289C310.364 259.892 314.394 259.289 315.201 257.881C316.007 256.473 313.588 254.059 313.185 252.651C313.01 252.039 313.233 249.844 313.6 247.221C313.6 247.221 314.395 250.64 315.201 253.255C316.007 255.87 316.611 258.484 316.611 259.892C316.611 261.3 316.208 262.909 315.201 263.714C314.193 264.519 308.752 264.519 307.341 263.714C305.93 262.909 306.132 254.462 306.132 254.462C306.626 254.039 306.818 253.007 306.892 252.225C306.884 251.746 306.9 251.393 306.938 251.243C306.938 251.243 305.93 250.238 305.729 249.232C305.527 248.226 306.132 244.405 306.132 243.6C306.132 242.796 307.442 241.79 307.442 241.79C307.442 243.459 307.439 244.977 307.542 246.014Z",
    fill: "#27195D"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    fill: "url(#paint167_linear_210_10376)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint168_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint169_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M316.413 222.682C318.025 230.728 330.923 235.555 330.923 235.555C330.923 235.555 332.737 226.102 337.372 221.476C342.007 216.849 339.186 205.184 340.798 203.373C342.41 201.563 344.829 177.024 345.635 170.99C346.441 164.956 348.456 154.095 349.061 149.267C349.665 144.44 347.65 128.751 347.247 125.332C346.844 121.913 355.308 116.08 357.122 113.063C358.936 110.046 361.153 97.7764 359.742 93.9548C358.331 90.1331 357.122 81.2831 353.091 79.0706C349.061 76.8581 339.186 75.8524 335.961 75.4502C332.737 75.0479 332.132 79.0706 331.125 79.0706C330.117 79.0706 325.28 77.4615 322.66 77.4615C320.04 77.4615 315.808 79.0706 312.382 79.0706C308.956 79.0706 300.895 82.0877 296.663 81.2831C292.431 80.4786 292.632 77.4615 292.632 77.4615C292.632 77.4615 278.928 78.2661 275.099 80.4786C271.27 82.6911 240.638 115.074 239.63 118.695C238.622 122.315 241.041 128.349 247.691 132.774C254.342 137.199 259.984 136.797 263.209 137.199C266.433 137.601 266.836 139.009 267.643 140.82C268.449 142.63 266.232 154.899 266.836 158.721C267.441 162.542 269.456 162.945 270.061 166.163C270.666 169.381 267.24 188.69 267.844 192.713C268.449 196.736 279.936 207.798 283.16 209.206C286.385 210.614 290.012 210.413 291.625 211.419C293.237 212.424 295.655 215.039 295.655 215.039C295.655 215.039 292.028 210.815 293.035 207.195C294.043 203.574 319.033 201.161 321.653 204.781C324.273 208.402 314.801 214.637 316.413 222.682Z",
    stroke: "url(#paint170_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M282.554 93.3509C281.949 97.5747 282.554 110.045 282.554 110.045C282.554 110.045 284.972 97.5747 288.398 99.1838C291.824 100.793 294.243 106.425 294.243 106.425C297.638 105.911 299.396 105.652 306.334 104.413C310.991 95.3177 312.099 94.1614 307.947 94.7588C303.794 95.3562 299.079 103.207 297.266 103.005C295.452 102.804 293.839 101.195 292.832 99.1838C291.824 97.1724 292.026 86.3111 288.801 85.3054C285.577 84.2997 283.158 89.127 282.554 93.3509Z",
    fill: "url(#paint171_linear_210_10376)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    fill: "url(#paint172_linear_210_10376)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    stroke: "url(#paint173_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 86.1095C280.739 81.4833 279.126 79.472 275.297 80.2765C271.468 81.0811 258.57 121.711 258.57 121.711C258.57 121.711 270.822 126.028 271.427 132.062C272.032 138.096 267.598 140.51 267.598 140.51C267.598 140.51 268.042 141.422 267.841 144.842C267.639 148.261 280.94 157.111 280.94 157.111C280.94 157.111 283.157 154.898 284.165 153.289C285.172 151.68 290.211 145.948 289.001 143.836C287.792 141.724 276.305 147.859 275.7 146.451C275.096 145.043 292.629 127.141 291.218 126.739C289.807 126.337 263.206 119.498 265.624 117.085C268.042 114.671 279.529 90.7356 280.134 86.1095Z",
    stroke: "url(#paint174_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M275.101 164.351C278.124 163.547 294.448 152.686 294.448 152.686C294.448 152.686 294.246 158.519 291.828 159.323C289.41 160.128 283.767 174.609 283.767 174.609C283.767 174.609 272.078 165.156 275.101 164.351Z",
    fill: "#291F63"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M275.101 164.352C278.124 163.547 294.448 152.686 294.448 152.686L287.394 133.578C287.394 133.578 291.425 135.589 296.463 134.583C301.501 133.578 316.817 125.331 316.817 125.331L297.874 120.705C307.473 112.556 311.512 108.6 314.197 103.608C314.197 103.608 297.068 105.419 294.448 106.424C291.828 107.43 292.836 121.51 291.828 125.733C290.82 129.957 277.116 142.428 275.705 145.847C274.294 149.266 289.409 141.02 289.208 144.238C289.006 147.456 285.782 150.071 282.759 154.898C279.736 159.726 275.705 159.122 275.101 160.53C274.496 161.938 275.101 164.352 275.101 164.352Z",
    fill: "url(#paint175_linear_210_10376)",
    stroke: "url(#paint176_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M296.665 81.2812C292.433 80.4766 292.634 77.4596 292.634 77.4596C292.634 77.4596 299.688 77.0573 301.3 73.638C302.912 70.2187 303.114 65.9948 302.308 65.5925C301.502 65.1902 300.494 61.5698 300.293 60.7652C300.091 59.9606 298.68 59.9608 298.479 57.7482C298.277 55.5357 299.688 54.1277 299.688 54.1277V48.4959C299.688 46.8868 302.912 42.4618 308.354 42.6629C313.795 42.864 316.616 46.2834 316.616 48.4959V54.1277C316.616 54.1277 317.826 56.1391 317.624 57.7482C317.423 59.3573 316.012 60.7652 316.012 60.7652C316.012 60.7652 315.004 64.9891 314.4 65.5925C313.795 66.196 314.4 69.8164 315.206 72.6323C316.012 75.4482 322.662 77.4596 322.662 77.4596C320.042 77.4596 315.81 79.0687 312.384 79.0687C308.958 79.0687 300.897 82.0857 296.665 81.2812Z",
    fill: "#959ACF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M296.665 81.2812C292.433 80.4766 292.634 77.4596 292.634 77.4596C292.634 77.4596 299.688 77.0573 301.3 73.638C302.912 70.2187 303.114 65.9948 302.308 65.5925C301.502 65.1902 300.494 61.5698 300.293 60.7652C300.091 59.9606 298.68 59.9608 298.479 57.7482C298.277 55.5357 299.688 54.1277 299.688 54.1277V48.4959C299.688 46.8868 302.912 42.4618 308.354 42.6629C313.795 42.864 316.616 46.2834 316.616 48.4959V54.1277C316.616 54.1277 317.826 56.1391 317.624 57.7482C317.423 59.3573 316.012 60.7652 316.012 60.7652C316.012 60.7652 315.004 64.9891 314.4 65.5925C313.795 66.196 314.4 69.8164 315.206 72.6323C316.012 75.4482 322.662 77.4596 322.662 77.4596C320.042 77.4596 315.81 79.0687 312.384 79.0687C308.958 79.0687 300.897 82.0857 296.665 81.2812Z",
    fill: "url(#paint177_radial_210_10376)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M308.756 63.7822C307.95 63.7822 306.539 63.5811 306.539 63.5811C306.539 63.5811 307.345 64.3856 308.353 64.3856C309.36 64.3856 310.855 63.5811 310.855 63.5811C310.855 63.5811 309.562 63.7822 308.756 63.7822Z",
    fill: "#505699"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M308.354 62.2868C307.469 62.2868 306.462 62.3474 305.734 62.4021C305.734 62.4021 306.943 61.568 307.346 61.568C307.749 61.568 307.951 61.7692 308.354 61.7692C308.757 61.7692 308.959 61.3669 309.563 61.568C310.168 61.7692 310.571 62.3403 310.571 62.3403C309.995 62.2516 309.074 62.2868 308.354 62.2868Z",
    fill: "#505699"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M308.551 58.5536C307.947 58.5537 307.543 58.1513 307.14 58.1514C306.737 58.1514 306.334 59.5593 306.737 59.9616C307.14 60.3639 307.745 59.9616 308.551 59.9616C309.357 59.9616 309.559 60.1628 310.163 59.9616C310.768 59.7604 310.365 58.7548 309.962 58.3525C309.559 57.9502 309.156 58.5536 308.551 58.5536Z",
    fill: "#505699"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M311.982 53.1227C310.571 53.3239 310.168 54.7318 310.168 54.7318C310.168 54.7318 311.377 56.1398 312.788 55.9386C314.199 55.7375 315.206 53.3239 315.206 53.3239C315.206 53.3239 313.392 52.9216 311.982 53.1227Z",
    fill: "#505699"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M304.997 53.1769C306.351 53.3728 306.738 54.7437 306.738 54.7437C306.738 54.7437 305.577 56.1147 304.223 55.9188C302.869 55.7229 301.902 53.3728 301.902 53.3728C301.902 53.3728 303.643 52.9811 304.997 53.1769Z",
    fill: "#505699"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M307.547 67.0008C304.322 66.7996 303.113 65.7939 303.113 65.7939C303.113 65.7939 306.136 70.0178 306.942 70.8224C307.748 71.6269 307.748 72.6326 306.942 73.236C306.136 73.8394 306.942 77.8622 306.942 77.8622C306.942 77.8622 306.716 76.4542 306.942 75.2474C307.169 74.0406 307.748 74.0406 308.152 72.6326C308.555 71.2246 307.345 71.0235 307.547 70.0178C307.748 69.0121 312.787 65.9951 312.787 65.9951C312.787 65.9951 310.771 67.2019 307.547 67.0008Z",
    fill: "url(#paint178_linear_210_10376)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M335.96 75.4502C332.736 75.0479 332.131 79.0706 331.123 79.0706C331.123 79.0706 316.412 97.7764 314.397 103.408C312.381 109.04 297.871 120.706 297.871 120.706L317.42 125.332C317.42 125.332 326.69 115.879 329.31 116.482C331.93 117.086 337.371 113.867 339.789 111.253C342.208 108.638 341.603 87.3172 345.432 83.8979C349.261 80.4786 353.09 79.0706 353.09 79.0706C349.06 76.8581 339.185 75.8524 335.96 75.4502Z",
    fill: "url(#paint179_linear_210_10376)",
    stroke: "url(#paint180_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M329.308 116.481C326.688 115.877 317.418 125.331 317.418 125.331C317.418 125.331 319.433 125.934 320.441 127.141C321.449 128.348 324.875 126.739 327.091 127.946C329.308 129.152 329.711 133.376 331.727 134.784C333.742 136.192 338.579 135.991 341.602 135.187C344.625 134.382 347.849 130.963 347.849 130.963L329.308 116.481Z",
    fill: "url(#paint181_linear_210_10376)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M263.209 137.198C266.433 137.601 266.836 139.009 267.643 140.819C267.643 140.819 274.293 134.986 270.061 128.952C265.829 122.918 242.176 114.909 239.63 118.694C238.622 122.314 241.041 128.348 247.691 132.773C254.342 137.198 259.984 136.796 263.209 137.198Z",
    fill: "url(#paint182_linear_210_10376)",
    stroke: "url(#paint183_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M316.415 222.68C318.028 230.726 330.925 235.553 330.925 235.553C330.925 235.553 332.739 226.1 337.374 221.474C337.374 221.474 331.127 209.204 331.127 195.929C331.127 182.654 333.418 175.135 331.127 162.138C329.126 150.787 320.043 141.823 321.655 134.18C323.267 126.537 317.625 125.531 317.625 125.531C317.625 125.531 314.602 133.778 313.795 134.985C312.989 136.192 316.818 164.954 316.415 169.781C316.012 174.609 321.655 204.779 321.655 204.779C324.275 208.4 314.803 214.635 316.415 222.68Z",
    fill: "url(#paint184_linear_210_10376)",
    stroke: "url(#paint185_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M321.652 204.78C319.032 201.16 294.043 203.573 293.035 207.194C292.69 208.434 292.888 209.745 293.299 210.932C293.414 211.246 293.481 211.418 293.481 211.418C293.417 211.259 293.356 211.097 293.299 210.932C292.424 208.555 288.719 198.043 289.609 192.712C290.617 186.678 296.663 168.978 295.655 159.524C294.647 150.071 287.594 133.578 287.594 133.578C287.594 133.578 290.214 134.583 295.655 134.583C301.096 134.583 315.606 125.331 317.219 125.331C318.831 125.331 315.203 131.969 313.994 134.583C312.785 137.198 316.412 163.346 316.412 168.978C316.412 174.61 321.652 204.78 321.652 204.78Z",
    fill: "url(#paint186_linear_210_10376)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M316.412 222.681C314.8 214.636 324.272 208.401 321.652 204.78M321.652 204.78C319.032 201.16 294.043 203.573 293.035 207.194C292.642 208.605 292.954 210.109 293.481 211.418C293.481 211.418 288.601 198.746 289.609 192.712C290.617 186.678 296.663 168.978 295.655 159.524C294.647 150.071 287.594 133.578 287.594 133.578C287.594 133.578 290.214 134.583 295.655 134.583C301.096 134.583 315.606 125.331 317.219 125.331C318.831 125.331 315.203 131.969 313.994 134.583C312.785 137.198 316.412 163.346 316.412 168.978C316.412 174.61 321.652 204.78 321.652 204.78Z",
    stroke: "url(#paint187_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M274.493 195.931C269.455 192.109 274.493 177.024 274.493 177.024C274.493 177.024 275.098 196.735 281.144 186.276C287.189 175.817 292.026 168.979 292.026 168.979C292.026 168.979 287.391 192.713 284.57 195.931C281.748 199.149 279.531 199.752 274.493 195.931Z",
    fill: "url(#paint188_linear_210_10376)",
    stroke: "url(#paint189_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M260.588 146.855C261.192 144.441 267.037 126.138 267.037 126.138C267.037 126.138 269.455 127.948 270.261 129.155C271.067 130.362 271.269 131.166 271.269 131.166L267.641 140.418C267.641 140.418 268.044 143.435 267.843 145.246L267.843 145.246C267.641 147.056 266.835 154.297 266.634 155.504C266.432 156.711 266.835 158.118 266.634 158.521C266.432 158.923 265.626 158.521 265.626 158.521C265.626 158.521 266.634 159.728 266.432 160.331C266.23 160.934 265.424 160.733 265.021 160.331C264.618 159.929 260.185 154.9 260.185 153.693C260.185 152.487 259.983 149.268 260.588 146.855Z",
    fill: "url(#paint190_linear_210_10376)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M265.626 158.521C265.626 158.521 266.634 159.728 266.432 160.331C266.23 160.934 265.424 160.733 265.021 160.331C264.618 159.929 260.185 154.9 260.185 153.693C260.185 152.487 259.983 149.268 260.588 146.855C261.192 144.441 267.037 126.138 267.037 126.138C267.037 126.138 269.455 127.948 270.261 129.155C271.067 130.362 271.269 131.166 271.269 131.166L267.641 140.418C267.641 140.418 268.044 143.435 267.843 145.246C267.641 147.056 266.835 154.297 266.634 155.504C266.432 156.711 266.835 158.118 266.634 158.521C266.432 158.923 265.626 158.521 265.626 158.521ZM265.626 158.521C265.626 158.521 264.82 157.716 264.517 157.113M264.517 157.113C264.517 157.113 263.409 156.711 263.409 155.705C263.409 154.699 264.618 151.079 264.618 151.079L264.517 157.113Z",
    stroke: "url(#paint191_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M348.254 108.638C346.642 103.408 342.007 98.7822 342.007 98.7822L342.003 98.8317C341.631 103.346 341.421 105.895 340.395 110.247C340.395 110.247 342.007 110.247 343.619 113.063C345.231 115.879 347.851 123.522 347.851 123.522C347.851 123.522 349.06 127.746 349.262 128.551C349.463 129.355 348.859 131.769 349.06 132.372C349.262 132.976 349.262 134.987 350.471 134.987C351.68 134.987 350.874 131.769 351.68 131.769C352.486 131.769 353.074 133.223 353.292 133.981C353.511 134.739 353.091 135.791 352.486 136.797C351.882 137.803 350.976 138.004 351.126 138.808C351.277 139.613 353.494 138.595 353.494 138.595C353.494 138.595 352.385 140.593 352.032 141.008C351.68 141.423 351.893 142.102 353.091 141.826C354.289 141.549 357.268 135.88 357.323 135.791C357.378 135.703 357.122 137.401 357.122 138.004C357.122 138.607 356.114 139.412 356.114 139.814C356.114 140.216 356.517 140.619 357.122 140.216C357.726 139.814 358.623 138.205 358.734 137.401C358.844 136.596 358.734 135.188 358.331 133.981C357.928 132.774 354.099 129.556 353.494 127.545C352.889 125.533 349.866 113.868 348.254 108.638Z",
    fill: "url(#paint192_linear_210_10376)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M353.494 138.595C353.494 138.595 352.385 140.593 352.032 141.008C351.68 141.423 351.893 142.102 353.091 141.826C354.289 141.549 357.268 135.88 357.323 135.791C357.378 135.703 357.122 137.401 357.122 138.004C357.122 138.607 356.114 139.412 356.114 139.814C356.114 140.216 356.517 140.619 357.122 140.216C357.726 139.814 358.623 138.205 358.734 137.401C358.844 136.596 358.734 135.188 358.331 133.981C357.928 132.774 354.099 129.556 353.494 127.545C352.889 125.533 349.866 113.868 348.254 108.638C346.642 103.408 342.007 98.7822 342.007 98.7822C341.632 103.328 341.425 105.879 340.395 110.247C340.395 110.247 342.007 110.247 343.619 113.063C345.231 115.879 347.851 123.522 347.851 123.522C347.851 123.522 349.06 127.746 349.262 128.551C349.463 129.355 348.859 131.769 349.06 132.372C349.262 132.976 349.262 134.987 350.471 134.987C351.68 134.987 350.874 131.769 351.68 131.769C352.486 131.769 353.074 133.223 353.292 133.981C353.511 134.739 353.091 135.791 352.486 136.797C351.882 137.803 350.976 138.004 351.126 138.808C351.277 139.613 353.494 138.595 353.494 138.595ZM353.494 138.595C353.897 138.595 354.912 136.982 355.308 135.188",
    stroke: "url(#paint193_radial_210_10376)",
    strokeWidth: 1.09872
  }))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M200.723 243.569C200.723 243.167 198.909 237.938 198.909 237.334C198.909 236.731 197.7 235.524 197.7 235.524H196.693C196.693 235.524 196.289 236.932 195.08 237.334C193.871 237.736 193.871 234.116 193.871 234.116L194.476 233.513L194.073 232.708C194.073 232.708 194.879 229.49 195.282 229.088C195.685 228.685 197.096 226.674 197.499 226.272C197.902 225.869 201.126 221.847 201.731 221.243C202.335 220.64 204.754 212.393 204.955 210.583C205.157 208.773 207.374 195.9 208.381 192.279C209.389 188.659 211.606 182.424 211.606 181.619V179.004C211.606 178.602 211.807 176.591 214.629 175.987C217.45 175.384 222.287 175.183 222.287 175.183C222.287 175.183 226.922 171.361 227.527 170.959C228.131 170.557 240.626 170.154 241.029 171.361C241.432 172.568 241.231 173.372 241.432 173.775C241.634 174.177 242.238 174.982 242.44 175.183C242.641 175.384 243.851 180.01 244.254 180.614C244.657 181.217 246.873 184.636 246.873 186.446C246.873 188.257 245.463 197.308 245.261 198.314C245.06 199.319 245.664 208.773 245.664 209.577C245.664 210.382 246.269 210.784 246.873 211.991C247.478 213.198 246.672 216.617 246.873 219.031C247.075 221.444 246.067 224.864 246.067 224.864C246.067 224.864 248.687 230.294 249.09 231.099C249.493 231.903 249.09 232.507 249.493 233.915C249.896 235.323 247.68 238.742 247.478 239.547C247.277 240.351 246.47 240.955 246.067 241.357C245.664 241.759 239.82 246.385 239.82 246.385V250.006C239.82 250.408 238.611 251.816 236.999 251.816C235.386 251.816 233.976 250.408 233.774 250.006C233.572 249.604 232.565 246.788 232.565 246.788C232.565 246.788 230.55 247.19 229.542 247.19C228.534 247.19 209.993 244.776 209.993 244.776C209.993 244.776 208.784 246.184 208.18 246.385C207.575 246.586 206.971 249 206.366 249H205.358C205.358 249 205.157 249.805 204.351 249.805C203.545 249.805 200.522 249.201 200.32 247.994C200.119 246.788 200.723 243.972 200.723 243.569Z",
    fill: "url(#paint194_linear_210_10376)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M214.625 175.987C217.446 175.384 222.283 175.183 222.283 175.183C222.283 175.183 228.127 175.987 228.53 176.188C228.933 176.389 229.538 177.596 230.142 177.596C230.747 177.596 230.344 176.993 230.948 176.993C231.553 176.993 232.561 177.194 232.964 177.194C233.367 177.194 235.181 176.993 235.584 177.194C235.987 177.395 237.196 178.2 237.8 178.2C238.405 178.2 239.614 177.797 239.816 177.797C240.017 177.797 240.219 178.2 240.622 178.401C241.025 178.602 241.428 178.401 241.831 178.401C242.234 178.401 243.242 178.803 243.242 178.803C243.242 178.803 243.04 180.01 243.04 180.412V183.429C243.04 184.033 242.637 187.452 242.637 187.653C242.637 187.854 242.839 189.664 242.839 190.268C242.839 190.871 242.637 191.877 242.436 192.48C242.234 193.084 242.637 193.713 242.637 194.203C242.637 194.693 242.033 201.532 242.033 202.336C242.033 203.141 243.04 206.359 243.04 207.364C243.04 208.37 242.033 209.979 241.226 210.18C240.42 210.382 236.994 209.778 236.39 209.175C235.785 208.571 235.785 206.359 235.785 205.957C235.785 205.554 233.971 203.744 233.367 203.744C232.762 203.744 228.732 203.945 227.925 203.543C227.119 203.141 226.313 200.124 226.112 199.922C225.91 199.721 225.709 198.514 225.709 197.911C225.709 197.308 227.321 194.291 227.321 193.084C227.321 191.877 226.112 190.67 225.91 189.866C225.709 189.061 226.112 186.849 225.507 186.849C224.903 186.849 225.104 187.452 224.903 187.452C224.701 187.452 225.104 189.061 224.499 189.061C223.895 189.061 222.283 187.854 222.181 187.452C222.078 187.05 222.686 181.82 221.88 181.418C221.073 181.016 219.864 181.217 217.446 181.217C215.028 181.217 214.221 183.429 213.818 183.429C213.415 183.429 213.012 183.228 213.012 182.826C213.012 182.424 214.02 180.814 213.617 180.412C213.214 180.01 211.602 180.412 211.602 180.412V179.004C211.602 178.602 211.803 176.591 214.625 175.987Z",
    fill: "url(#paint195_linear_210_10376)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M219.667 172.366C220.624 173.491 220.849 174.156 220.876 175.383C220.649 174.287 220.407 173.669 219.465 172.567C219.465 172.567 218.861 173.171 218.458 173.372C218.055 173.573 217.047 173.774 217.047 173.372C217.047 172.97 217.248 172.366 217.853 172.165C218.458 171.964 219.264 171.964 219.264 171.964C219.264 171.964 219.41 170.763 220.271 170.355C221.133 169.947 221.481 170.154 221.682 170.355C221.884 170.556 221.884 171.159 221.481 171.562C221.077 171.964 219.667 172.366 219.667 172.366Z",
    fill: "url(#paint196_linear_210_10376)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M245.462 180.814C245.664 180.814 245.059 181.82 245.059 181.82C245.059 181.82 245.664 181.015 245.865 181.015C246.067 181.015 246.268 181.82 246.873 181.619C247.478 181.418 247.276 181.015 246.873 180.814C246.47 180.613 246.067 180.613 246.067 180.613C246.067 180.613 246.067 180.211 245.865 180.01C245.664 179.809 244.656 179.607 244.656 180.01C244.656 180.412 245.261 180.814 245.462 180.814Z",
    fill: "url(#paint197_linear_210_10376)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M247.076 211.216C247.277 211.216 246.673 212.222 246.673 212.222C246.673 212.222 247.277 211.418 247.479 211.418C247.68 211.418 247.882 212.222 248.486 212.021C249.091 211.82 248.889 211.418 248.486 211.216C248.083 211.015 247.68 211.015 247.68 211.015C247.68 211.015 247.68 210.613 247.479 210.412C247.277 210.211 246.27 210.01 246.27 210.412C246.27 210.814 246.874 211.216 247.076 211.216Z",
    fill: "url(#paint198_linear_210_10376)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M199.719 223.65L199.718 223.655C199.725 222.63 199.644 222.138 198.912 221.845C198.912 221.845 198.307 222.448 197.904 222.247C197.501 222.046 197.501 221.644 197.904 221.242C198.307 220.839 198.912 221.04 198.912 221.04C198.912 221.04 198.912 220.437 199.315 220.035C199.718 219.632 200.121 219.23 200.524 219.632C200.927 220.035 200.927 220.437 200.524 220.839C200.121 221.241 199.315 221.443 199.315 221.443C199.963 222.309 199.875 222.792 199.719 223.65Z",
    fill: "url(#paint199_linear_210_10376)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M213.743 174.372C214.229 174.974 214.343 175.329 214.356 175.986C214.241 175.399 214.119 175.069 213.641 174.479C213.641 174.479 213.334 174.802 213.13 174.91C212.925 175.017 212.414 175.125 212.414 174.91C212.414 174.694 212.516 174.372 212.823 174.264C213.13 174.156 213.539 174.156 213.539 174.156C213.539 174.156 213.613 173.514 214.05 173.295C214.487 173.077 214.663 173.188 214.765 173.295C214.868 173.403 214.868 173.726 214.663 173.941C214.459 174.156 213.743 174.372 213.743 174.372Z",
    fill: "url(#paint200_linear_210_10376)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M239.817 222.649L240.22 222.046L233.167 222.85L230.748 225.666L226.113 232.706L225.71 234.919L225.105 237.936L226.516 234.315V233.31L231.151 225.465L233.368 223.253L239.817 222.649Z",
    fill: "url(#paint201_linear_210_10376)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M240.221 234.116C241.43 233.311 240.826 231.702 241.43 231.702C242.035 231.702 242.438 233.714 242.237 234.116C242.035 234.518 234.578 239.345 233.772 239.546C232.966 239.748 233.772 238.742 233.772 238.742C233.772 238.742 239.012 234.92 240.221 234.116Z",
    fill: "url(#paint202_linear_210_10376)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M216.237 214.807L211.199 227.277L217.648 216.617H216.237V214.807Z",
    fill: "url(#paint203_linear_210_10376)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M230.148 221.241H228.737L227.125 212.391L227.931 209.374L229.946 209.575L231.559 211.184L230.148 221.241Z",
    fill: "url(#paint204_linear_210_10376)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M210.797 241.166L212.611 239.758C212.611 239.758 221.679 236.942 221.679 237.143C221.679 237.344 220.672 238.35 220.672 238.35L210.797 241.166Z",
    fill: "url(#paint205_linear_210_10376)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M229.745 241.759L220.676 238.34L221.683 237.133L230.752 239.949L229.745 241.759Z",
    fill: "url(#paint206_linear_210_10376)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M212.414 189.061L214.429 189.866C214.429 189.866 214.429 187.251 213.422 187.251C212.414 187.251 212.414 189.061 212.414 189.061Z",
    fill: "url(#paint207_linear_210_10376)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M237.404 190.468C238.211 190.468 238.211 192.881 238.211 192.881H236.195C236.195 192.881 236.598 190.468 237.404 190.468Z",
    fill: "url(#paint208_linear_210_10376)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M235.179 191.876V192.881H233.769C233.769 192.881 233.568 192.077 233.769 191.876C233.971 191.675 234.172 191.474 234.374 191.474C234.575 191.474 235.179 191.675 235.179 191.876Z",
    fill: "url(#paint209_linear_210_10376)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M226.316 172.165C226.316 172.165 226.921 171.36 227.526 170.958C228.13 170.556 239.819 169.953 241.028 171.361C241.633 171.763 241.23 173.774 241.23 173.774C241.23 173.774 240.222 174.981 240.02 174.981C239.819 174.981 237.804 173.975 237.401 173.975H234.982C234.378 173.975 234.579 173.171 234.176 173.171H232.765C232.564 173.171 231.556 173.975 230.952 173.975C230.347 173.975 228.533 173.975 228.13 173.573C227.727 173.171 229.138 172.768 228.533 172.768C227.929 172.768 226.316 172.165 226.316 172.165Z",
    fill: "url(#paint210_linear_210_10376)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M247.481 239.545C247.28 240.35 246.473 240.953 246.07 241.356C246.07 241.356 245.264 240.551 244.861 240.35C244.458 240.149 242.644 236.528 242.846 235.523C243.047 234.517 242.241 226.27 242.443 225.667C242.644 225.064 243.853 223.857 244.055 223.253C244.257 222.65 244.458 219.432 244.458 219.03V212.794C244.458 212.191 243.047 208.168 243.047 208.168V202.737L243.652 198.916L245.405 197.508C245.34 197.897 245.291 198.177 245.264 198.312C245.063 199.318 245.667 208.772 245.667 209.576C245.667 210.381 246.272 210.783 246.876 211.99C247.481 213.197 246.675 216.616 246.876 219.03C247.078 221.443 246.07 224.862 246.07 224.862C246.07 224.862 248.69 230.293 249.093 231.098C249.496 231.902 249.093 232.506 249.496 233.914C249.899 235.322 247.683 238.741 247.481 239.545Z",
    fill: "url(#paint211_linear_210_10376)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M244.457 234.116V223.255L245.062 223.456C245.062 223.456 247.883 232.306 247.48 233.513C247.077 234.72 247.278 236.731 247.278 236.731H245.868C245.868 236.731 246.271 234.116 245.868 233.915C245.465 233.714 244.457 234.116 244.457 234.116Z",
    fill: "url(#paint212_linear_210_10376)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M245.865 233.914C245.462 233.713 244.455 234.115 244.455 234.115C244.455 234.115 243.648 236.73 243.648 237.132C243.648 237.534 244.858 238.138 244.858 238.138L245.88 236.631C245.948 236.154 246.221 234.091 245.865 233.914Z",
    fill: "url(#paint213_linear_210_10376)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M245.059 238.138L245.865 236.73H247.276C247.276 236.73 246.672 238.943 246.672 239.345V240.351L246.067 241.357L244.656 240.15L245.059 238.138Z",
    fill: "url(#paint214_linear_210_10376)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M193.871 234.115L194.476 233.512L196.289 233.914L196.693 235.523C196.693 235.523 196.289 236.931 195.08 237.333C193.871 237.736 193.871 234.115 193.871 234.115Z",
    fill: "url(#paint215_linear_210_10376)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M196.285 233.914L196.688 235.523H197.696L198.905 237.132L199.308 232.908C199.308 232.908 198.905 232.305 198.099 232.305C197.293 232.305 196.285 233.914 196.285 233.914Z",
    fill: "url(#paint216_linear_210_10376)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M200.724 243.568C200.724 243.166 198.91 237.936 198.91 237.333L199.112 236.931L201.329 239.344L205.158 240.551C205.158 240.551 213.622 242.16 215.839 242.361C218.056 242.562 229.341 241.557 231.356 241.557C233.372 241.557 244.254 238.942 244.254 238.942L244.657 240.149L246.068 241.356C245.665 241.758 239.821 246.384 239.821 246.384V250.005C239.821 250.407 238.612 251.815 236.999 251.815C235.387 251.815 233.976 250.407 233.775 250.005C233.573 249.602 232.566 246.786 232.566 246.786C232.566 246.786 230.55 247.189 229.543 247.189C228.535 247.189 209.994 244.775 209.994 244.775C209.994 244.775 208.785 246.183 208.181 246.384C207.576 246.585 206.971 248.999 206.367 248.999H205.359C205.359 248.999 205.158 249.803 204.351 249.803C203.545 249.803 200.522 249.2 200.321 247.993C200.119 246.786 200.724 243.971 200.724 243.568Z",
    fill: "url(#paint217_linear_210_10376)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M243.248 178.802C243.248 178.802 243.245 178.821 243.239 178.856C243.265 178.969 243.436 179.32 244.256 180.411C245.465 182.02 246.674 185.037 246.876 186.445C247.077 187.853 245.264 197.709 245.264 197.709C245.264 197.709 243.853 198.312 243.651 198.915C243.45 199.519 243.047 202.737 243.047 203.139V207.363C243.047 206.358 242.039 203.139 242.039 202.335C242.039 201.53 242.644 194.692 242.644 194.201C242.644 193.711 242.241 193.082 242.442 192.479C242.644 191.876 242.845 190.87 242.845 190.267C242.845 189.663 242.644 187.853 242.644 187.652C242.644 187.451 243.047 184.031 243.047 183.428V180.411C243.047 180.059 243.201 179.094 243.239 178.856C243.227 178.802 243.248 178.802 243.248 178.802Z",
    fill: "url(#paint218_linear_210_10376)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M200.322 247.994C200.121 246.787 200.725 243.971 200.725 243.569C200.725 243.569 200.725 241.155 201.532 241.155C202.338 241.155 203.748 243.569 203.748 243.569C203.748 243.569 204.555 243.167 204.555 242.764C204.555 242.362 205.562 241.96 205.965 242.161C206.368 242.362 207.779 243.569 207.779 243.569L209.996 244.776C209.996 244.776 208.787 246.184 208.182 246.385C207.577 246.586 206.973 249 206.368 249H205.361C205.361 249 205.159 249.804 204.353 249.804C203.547 249.804 200.524 249.201 200.322 247.994Z",
    fill: "url(#paint219_linear_210_10376)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M200.322 247.994C200.121 246.787 200.725 243.971 200.725 243.569C200.725 243.569 200.725 241.155 201.532 241.155C202.338 241.155 203.748 243.569 203.748 243.569C203.748 243.569 205.562 246.184 205.361 247.391C205.159 248.597 205.361 249 205.361 249C205.361 249 205.159 249.804 204.353 249.804C203.547 249.804 200.524 249.201 200.322 247.994Z",
    fill: "url(#paint220_linear_210_10376)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M233.776 250.005C233.574 249.603 232.566 246.787 232.566 246.787C232.566 246.787 233.776 244.775 234.582 244.574C235.388 244.373 236.194 244.373 236.597 244.373C237 244.373 238.209 242.362 238.612 242.563C239.015 242.764 239.821 246.385 239.821 246.385V250.005C239.821 250.407 238.612 251.815 237 251.815C235.388 251.815 233.977 250.407 233.776 250.005Z",
    fill: "url(#paint221_linear_210_10376)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M237.005 251.815C235.392 251.815 233.982 250.407 233.78 250.005C233.78 250.005 233.579 249.402 234.385 248.396C235.191 247.39 236.602 244.373 236.602 244.373C237.005 244.373 238.214 242.362 238.617 242.563C239.02 242.764 239.826 246.385 239.826 246.385V250.005C239.826 250.407 238.617 251.815 237.005 251.815Z",
    fill: "url(#paint222_linear_210_10376)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.037,
    cy: 185.641,
    rx: 1.20918,
    ry: 1.20682,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.592,
    cy: 187.652,
    rx: 1.20918,
    ry: 1.20682,
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M227.126 192.479L221.887 191.474C221.887 191.474 229.142 191.675 230.351 191.675C231.56 191.675 238.815 192.882 238.815 192.882L227.126 192.479Z",
    fill: "url(#paint223_linear_210_10376)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M214.428 189.865L211.809 188.859C211.809 188.859 218.056 191.675 219.668 191.876C221.281 192.078 225.311 192.882 227.125 193.083C228.939 193.284 238.814 192.882 238.814 192.882L227.125 192.48L221.885 191.474L214.428 189.865Z",
    fill: "url(#paint224_linear_210_10376)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M211.809 188.859L214.428 189.865L221.885 191.474L227.125 192.48L238.814 192.882",
    stroke: "url(#paint225_linear_210_10376)",
    strokeWidth: 1.09872
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M200.723 243.569C200.723 243.167 198.909 237.938 198.909 237.334C198.909 236.731 197.7 235.524 197.7 235.524H196.693C196.693 235.524 196.289 236.932 195.08 237.334C193.871 237.736 193.871 234.116 193.871 234.116L194.476 233.513L194.073 232.708C194.073 232.708 194.879 229.49 195.282 229.088C195.685 228.685 197.096 226.674 197.499 226.272C197.902 225.869 201.126 221.847 201.731 221.243C202.335 220.64 204.754 212.393 204.955 210.583C205.157 208.773 207.374 195.9 208.381 192.279C209.389 188.659 211.606 182.424 211.606 181.619V179.004C211.606 178.602 211.807 176.591 214.629 175.987C217.45 175.384 222.287 175.183 222.287 175.183C222.287 175.183 226.922 171.361 227.527 170.959C228.131 170.557 240.626 170.154 241.029 171.361C241.432 172.568 241.231 173.372 241.432 173.775C241.634 174.177 242.238 174.982 242.44 175.183C242.641 175.384 243.851 180.01 244.254 180.614C244.657 181.217 246.873 184.636 246.873 186.446C246.873 188.257 245.463 197.308 245.261 198.314C245.06 199.319 245.664 208.773 245.664 209.577C245.664 210.382 246.269 210.784 246.873 211.991C247.478 213.198 246.672 216.617 246.873 219.031C247.075 221.444 246.067 224.864 246.067 224.864C246.067 224.864 248.687 230.294 249.09 231.099C249.493 231.903 249.09 232.507 249.493 233.915C249.896 235.323 247.68 238.742 247.478 239.547C247.277 240.351 246.47 240.955 246.067 241.357C245.664 241.759 239.82 246.385 239.82 246.385V250.006C239.82 250.408 238.611 251.816 236.999 251.816C235.386 251.816 233.976 250.408 233.774 250.006C233.572 249.604 232.565 246.788 232.565 246.788C232.565 246.788 230.55 247.19 229.542 247.19C228.534 247.19 209.993 244.776 209.993 244.776C209.993 244.776 208.784 246.184 208.18 246.385C207.575 246.586 206.971 249 206.366 249H205.358C205.358 249 205.157 249.805 204.351 249.805C203.545 249.805 200.522 249.201 200.32 247.994C200.119 246.788 200.723 243.972 200.723 243.569Z",
    fill: "url(#paint226_linear_210_10376)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M214.625 175.987C217.446 175.384 222.283 175.183 222.283 175.183C222.283 175.183 228.127 175.987 228.53 176.188C228.933 176.389 229.538 177.596 230.142 177.596C230.747 177.596 230.344 176.993 230.948 176.993C231.553 176.993 232.561 177.194 232.964 177.194C233.367 177.194 235.181 176.993 235.584 177.194C235.987 177.395 237.196 178.2 237.8 178.2C238.405 178.2 239.614 177.797 239.816 177.797C240.017 177.797 240.219 178.2 240.622 178.401C241.025 178.602 241.428 178.401 241.831 178.401C242.234 178.401 243.242 178.803 243.242 178.803C243.242 178.803 243.04 180.01 243.04 180.412V183.429C243.04 184.033 242.637 187.452 242.637 187.653C242.637 187.854 242.839 189.664 242.839 190.268C242.839 190.871 242.637 191.877 242.436 192.48C242.234 193.084 242.637 193.713 242.637 194.203C242.637 194.693 242.033 201.532 242.033 202.336C242.033 203.141 243.04 206.359 243.04 207.364C243.04 208.37 242.033 209.979 241.226 210.18C240.42 210.382 236.994 209.778 236.39 209.175C235.785 208.571 235.785 206.359 235.785 205.957C235.785 205.554 233.971 203.744 233.367 203.744C232.762 203.744 228.732 203.945 227.925 203.543C227.119 203.141 226.313 200.124 226.112 199.922C225.91 199.721 225.709 198.514 225.709 197.911C225.709 197.308 227.321 194.291 227.321 193.084C227.321 191.877 226.112 190.67 225.91 189.866C225.709 189.061 226.112 186.849 225.507 186.849C224.903 186.849 225.104 187.452 224.903 187.452C224.701 187.452 225.104 189.061 224.499 189.061C223.895 189.061 222.283 187.854 222.181 187.452C222.078 187.05 222.686 181.82 221.88 181.418C221.073 181.016 219.864 181.217 217.446 181.217C215.028 181.217 214.221 183.429 213.818 183.429C213.415 183.429 213.012 183.228 213.012 182.826C213.012 182.424 214.02 180.814 213.617 180.412C213.214 180.01 211.602 180.412 211.602 180.412V179.004C211.602 178.602 211.803 176.591 214.625 175.987Z",
    fill: "url(#paint227_linear_210_10376)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M219.667 172.366C220.624 173.491 220.849 174.156 220.876 175.383C220.649 174.287 220.407 173.669 219.465 172.567C219.465 172.567 218.861 173.171 218.458 173.372C218.055 173.573 217.047 173.774 217.047 173.372C217.047 172.97 217.248 172.366 217.853 172.165C218.458 171.964 219.264 171.964 219.264 171.964C219.264 171.964 219.41 170.763 220.271 170.355C221.133 169.947 221.481 170.154 221.682 170.355C221.884 170.556 221.884 171.159 221.481 171.562C221.077 171.964 219.667 172.366 219.667 172.366Z",
    fill: "url(#paint228_linear_210_10376)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M245.462 180.814C245.664 180.814 245.059 181.82 245.059 181.82C245.059 181.82 245.664 181.015 245.865 181.015C246.067 181.015 246.268 181.82 246.873 181.619C247.478 181.418 247.276 181.015 246.873 180.814C246.47 180.613 246.067 180.613 246.067 180.613C246.067 180.613 246.067 180.211 245.865 180.01C245.664 179.809 244.656 179.607 244.656 180.01C244.656 180.412 245.261 180.814 245.462 180.814Z",
    fill: "url(#paint229_linear_210_10376)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M247.076 211.216C247.277 211.216 246.673 212.222 246.673 212.222C246.673 212.222 247.277 211.418 247.479 211.418C247.68 211.418 247.882 212.222 248.486 212.021C249.091 211.82 248.889 211.418 248.486 211.216C248.083 211.015 247.68 211.015 247.68 211.015C247.68 211.015 247.68 210.613 247.479 210.412C247.277 210.211 246.27 210.01 246.27 210.412C246.27 210.814 246.874 211.216 247.076 211.216Z",
    fill: "url(#paint230_linear_210_10376)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M199.719 223.65L199.718 223.655C199.725 222.63 199.644 222.138 198.912 221.845C198.912 221.845 198.307 222.448 197.904 222.247C197.501 222.046 197.501 221.644 197.904 221.242C198.307 220.839 198.912 221.04 198.912 221.04C198.912 221.04 198.912 220.437 199.315 220.035C199.718 219.632 200.121 219.23 200.524 219.632C200.927 220.035 200.927 220.437 200.524 220.839C200.121 221.241 199.315 221.443 199.315 221.443C199.963 222.309 199.875 222.792 199.719 223.65Z",
    fill: "url(#paint231_linear_210_10376)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M213.743 174.372C214.229 174.974 214.343 175.329 214.356 175.986C214.241 175.399 214.119 175.069 213.641 174.479C213.641 174.479 213.334 174.802 213.13 174.91C212.925 175.017 212.414 175.125 212.414 174.91C212.414 174.694 212.516 174.372 212.823 174.264C213.13 174.156 213.539 174.156 213.539 174.156C213.539 174.156 213.613 173.514 214.05 173.295C214.487 173.077 214.663 173.188 214.765 173.295C214.868 173.403 214.868 173.726 214.663 173.941C214.459 174.156 213.743 174.372 213.743 174.372Z",
    fill: "url(#paint232_linear_210_10376)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M239.817 222.649L240.22 222.046L233.167 222.85L230.748 225.666L226.113 232.706L225.71 234.919L225.105 237.936L226.516 234.315V233.31L231.151 225.465L233.368 223.253L239.817 222.649Z",
    fill: "url(#paint233_linear_210_10376)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M240.221 234.116C241.43 233.311 240.826 231.702 241.43 231.702C242.035 231.702 242.438 233.714 242.237 234.116C242.035 234.518 234.578 239.345 233.772 239.546C232.966 239.748 233.772 238.742 233.772 238.742C233.772 238.742 239.012 234.92 240.221 234.116Z",
    fill: "url(#paint234_linear_210_10376)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M216.237 214.807L211.199 227.277L217.648 216.617H216.237V214.807Z",
    fill: "url(#paint235_linear_210_10376)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M230.148 221.241H228.737L227.125 212.391L227.931 209.374L229.946 209.575L231.559 211.184L230.148 221.241Z",
    fill: "url(#paint236_linear_210_10376)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M210.797 241.166L212.611 239.758C212.611 239.758 221.679 236.942 221.679 237.143C221.679 237.344 220.672 238.35 220.672 238.35L210.797 241.166Z",
    fill: "url(#paint237_linear_210_10376)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M229.745 241.759L220.676 238.34L221.683 237.133L230.752 239.949L229.745 241.759Z",
    fill: "url(#paint238_linear_210_10376)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M212.414 189.061L214.429 189.866C214.429 189.866 214.429 187.251 213.422 187.251C212.414 187.251 212.414 189.061 212.414 189.061Z",
    fill: "url(#paint239_linear_210_10376)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M237.404 190.468C238.211 190.468 238.211 192.881 238.211 192.881H236.195C236.195 192.881 236.598 190.468 237.404 190.468Z",
    fill: "url(#paint240_linear_210_10376)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M235.179 191.876V192.881H233.769C233.769 192.881 233.568 192.077 233.769 191.876C233.971 191.675 234.172 191.474 234.374 191.474C234.575 191.474 235.179 191.675 235.179 191.876Z",
    fill: "url(#paint241_linear_210_10376)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M226.316 172.165C226.316 172.165 226.921 171.36 227.526 170.958C228.13 170.556 239.819 169.953 241.028 171.361C241.633 171.763 241.23 173.774 241.23 173.774C241.23 173.774 240.222 174.981 240.02 174.981C239.819 174.981 237.804 173.975 237.401 173.975H234.982C234.378 173.975 234.579 173.171 234.176 173.171H232.765C232.564 173.171 231.556 173.975 230.952 173.975C230.347 173.975 228.533 173.975 228.13 173.573C227.727 173.171 229.138 172.768 228.533 172.768C227.929 172.768 226.316 172.165 226.316 172.165Z",
    fill: "url(#paint242_linear_210_10376)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M247.481 239.545C247.28 240.35 246.473 240.953 246.07 241.356C246.07 241.356 245.264 240.551 244.861 240.35C244.458 240.149 242.644 236.528 242.846 235.523C243.047 234.517 242.241 226.27 242.443 225.667C242.644 225.064 243.853 223.857 244.055 223.253C244.257 222.65 244.458 219.432 244.458 219.03V212.794C244.458 212.191 243.047 208.168 243.047 208.168V202.737L243.652 198.916L245.405 197.508C245.34 197.897 245.291 198.177 245.264 198.312C245.063 199.318 245.667 208.772 245.667 209.576C245.667 210.381 246.272 210.783 246.876 211.99C247.481 213.197 246.675 216.616 246.876 219.03C247.078 221.443 246.07 224.862 246.07 224.862C246.07 224.862 248.69 230.293 249.093 231.098C249.496 231.902 249.093 232.506 249.496 233.914C249.899 235.322 247.683 238.741 247.481 239.545Z",
    fill: "url(#paint243_linear_210_10376)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M244.457 234.116V223.255L245.062 223.456C245.062 223.456 247.883 232.306 247.48 233.513C247.077 234.72 247.278 236.731 247.278 236.731H245.868C245.868 236.731 246.271 234.116 245.868 233.915C245.465 233.714 244.457 234.116 244.457 234.116Z",
    fill: "url(#paint244_linear_210_10376)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M245.865 233.914C245.462 233.713 244.455 234.115 244.455 234.115C244.455 234.115 243.648 236.73 243.648 237.132C243.648 237.534 244.858 238.138 244.858 238.138L245.88 236.631C245.948 236.154 246.221 234.091 245.865 233.914Z",
    fill: "url(#paint245_linear_210_10376)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M245.059 238.138L245.865 236.73H247.276C247.276 236.73 246.672 238.943 246.672 239.345V240.351L246.067 241.357L244.656 240.15L245.059 238.138Z",
    fill: "url(#paint246_linear_210_10376)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M193.871 234.115L194.476 233.512L196.289 233.914L196.693 235.523C196.693 235.523 196.289 236.931 195.08 237.333C193.871 237.736 193.871 234.115 193.871 234.115Z",
    fill: "url(#paint247_linear_210_10376)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M196.285 233.914L196.688 235.523H197.696L198.905 237.132L199.308 232.908C199.308 232.908 198.905 232.305 198.099 232.305C197.293 232.305 196.285 233.914 196.285 233.914Z",
    fill: "url(#paint248_linear_210_10376)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M200.724 243.568C200.724 243.166 198.91 237.936 198.91 237.333L199.112 236.931L201.329 239.344L205.158 240.551C205.158 240.551 213.622 242.16 215.839 242.361C218.056 242.562 229.341 241.557 231.356 241.557C233.372 241.557 244.254 238.942 244.254 238.942L244.657 240.149L246.068 241.356C245.665 241.758 239.821 246.384 239.821 246.384V250.005C239.821 250.407 238.612 251.815 236.999 251.815C235.387 251.815 233.976 250.407 233.775 250.005C233.573 249.602 232.566 246.786 232.566 246.786C232.566 246.786 230.55 247.189 229.543 247.189C228.535 247.189 209.994 244.775 209.994 244.775C209.994 244.775 208.785 246.183 208.181 246.384C207.576 246.585 206.971 248.999 206.367 248.999H205.359C205.359 248.999 205.158 249.803 204.351 249.803C203.545 249.803 200.522 249.2 200.321 247.993C200.119 246.786 200.724 243.971 200.724 243.568Z",
    fill: "url(#paint249_linear_210_10376)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M243.248 178.802C243.248 178.802 243.245 178.821 243.239 178.856C243.265 178.969 243.436 179.32 244.256 180.411C245.465 182.02 246.674 185.037 246.876 186.445C247.077 187.853 245.264 197.709 245.264 197.709C245.264 197.709 243.853 198.312 243.651 198.915C243.45 199.519 243.047 202.737 243.047 203.139V207.363C243.047 206.358 242.039 203.139 242.039 202.335C242.039 201.53 242.644 194.692 242.644 194.201C242.644 193.711 242.241 193.082 242.442 192.479C242.644 191.876 242.845 190.87 242.845 190.267C242.845 189.663 242.644 187.853 242.644 187.652C242.644 187.451 243.047 184.031 243.047 183.428V180.411C243.047 180.059 243.201 179.094 243.239 178.856C243.227 178.802 243.248 178.802 243.248 178.802Z",
    fill: "url(#paint250_linear_210_10376)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M200.322 247.994C200.121 246.787 200.725 243.971 200.725 243.569C200.725 243.569 200.725 241.155 201.532 241.155C202.338 241.155 203.748 243.569 203.748 243.569C203.748 243.569 204.555 243.167 204.555 242.764C204.555 242.362 205.562 241.96 205.965 242.161C206.368 242.362 207.779 243.569 207.779 243.569L209.996 244.776C209.996 244.776 208.787 246.184 208.182 246.385C207.577 246.586 206.973 249 206.368 249H205.361C205.361 249 205.159 249.804 204.353 249.804C203.547 249.804 200.524 249.201 200.322 247.994Z",
    fill: "url(#paint251_linear_210_10376)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M200.322 247.994C200.121 246.787 200.725 243.971 200.725 243.569C200.725 243.569 200.725 241.155 201.532 241.155C202.338 241.155 203.748 243.569 203.748 243.569C203.748 243.569 205.562 246.184 205.361 247.391C205.159 248.597 205.361 249 205.361 249C205.361 249 205.159 249.804 204.353 249.804C203.547 249.804 200.524 249.201 200.322 247.994Z",
    fill: "url(#paint252_linear_210_10376)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M233.776 250.005C233.574 249.603 232.566 246.787 232.566 246.787C232.566 246.787 233.776 244.775 234.582 244.574C235.388 244.373 236.194 244.373 236.597 244.373C237 244.373 238.209 242.362 238.612 242.563C239.015 242.764 239.821 246.385 239.821 246.385V250.005C239.821 250.407 238.612 251.815 237 251.815C235.388 251.815 233.977 250.407 233.776 250.005Z",
    fill: "url(#paint253_linear_210_10376)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M237.005 251.815C235.392 251.815 233.982 250.407 233.78 250.005C233.78 250.005 233.579 249.402 234.385 248.396C235.191 247.39 236.602 244.373 236.602 244.373C237.005 244.373 238.214 242.362 238.617 242.563C239.02 242.764 239.826 246.385 239.826 246.385V250.005C239.826 250.407 238.617 251.815 237.005 251.815Z",
    fill: "url(#paint254_linear_210_10376)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.037,
    cy: 185.641,
    rx: 1.20918,
    ry: 1.20682,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.592,
    cy: 187.652,
    rx: 1.20918,
    ry: 1.20682,
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M227.126 192.479L221.887 191.474C221.887 191.474 229.142 191.675 230.351 191.675C231.56 191.675 238.815 192.882 238.815 192.882L227.126 192.479Z",
    fill: "url(#paint255_linear_210_10376)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M214.428 189.865L211.809 188.859C211.809 188.859 218.056 191.675 219.668 191.876C221.281 192.078 225.311 192.882 227.125 193.083C228.939 193.284 238.814 192.882 238.814 192.882L227.125 192.48L221.885 191.474L214.428 189.865Z",
    fill: "url(#paint256_linear_210_10376)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M211.809 188.859L214.428 189.865L221.885 191.474L227.125 192.48L238.814 192.882",
    stroke: "url(#paint257_linear_210_10376)",
    strokeWidth: 1.09872
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.1,
    filter: "url(#filter4_f_210_10376)"
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M467.591 264.546C467.991 264.71 468.989 264.928 469.188 265.037C469.388 265.146 469.388 265.638 469.787 265.802C470.186 265.965 471.783 266.675 472.183 266.839C472.582 267.003 472.781 267.658 471.783 267.712C470.785 267.767 469.188 266.73 468.39 266.73C467.591 266.73 467.791 266.948 467.991 267.003C468.19 267.057 471.384 268.313 470.785 268.75C470.186 269.186 470.186 269.951 467.991 269.951C465.795 269.951 464.997 269.405 464.997 269.132V267.876C464.997 267.658 463.998 267.494 462.801 267.494C461.603 267.494 460.805 267.712 460.805 267.876V269.459C460.805 269.459 460.805 270.06 459.208 269.951C457.611 269.842 455.814 269.023 455.814 268.586C455.814 268.149 456.812 267.712 457.012 267.439C457.212 267.166 456.613 266.839 456.214 266.839C455.814 266.839 455.814 267.276 455.814 267.439C455.814 267.603 455.016 268.149 454.217 268.149C453.419 268.149 453.818 267.549 453.419 267.276C453.02 267.003 454.617 266.293 454.617 266.293C454.617 266.293 454.417 265.802 454.217 265.692C454.018 265.583 455.215 265.365 455.215 265.365V263.399C455.215 263.126 453.818 262.526 453.02 262.471C452.221 262.417 447.031 263.945 447.031 263.945C447.031 263.945 436.053 267.276 437.849 270.606C439.646 273.936 457.212 279.669 457.212 279.669C457.212 279.669 467.991 289.278 457.212 302.326C446.433 315.374 435.454 318.868 435.454 318.868C435.454 318.868 431.062 314.446 430.264 312.753C429.465 311.061 422.08 308.823 422.08 308.823C422.08 308.823 415.093 313.463 399.523 318.541C399.523 318.541 397.527 311.552 396.33 310.188C395.132 308.823 391.539 307.239 381.958 305.929C380.959 299.76 370.18 297.358 370.18 297.358C370.18 297.358 373.773 292.99 373.574 291.243C373.374 289.496 373.574 287.367 367.785 284.582C379.762 280.16 377.366 274.318 377.366 274.318C377.366 274.318 389.742 270.333 391.739 267.931C393.735 265.529 388.744 262.253 388.744 262.253C386.349 262.58 372.975 262.144 372.975 262.144C372.975 262.144 374.971 261.489 374.173 261.652C373.374 261.816 370.38 261.489 370.38 261.489C370.38 261.489 372.975 260.56 372.975 259.741C372.975 258.923 372.376 258.322 371.178 258.213C369.981 258.104 352.415 256.138 345.828 255.428C339.24 254.719 327.663 254.555 323.471 255.046C319.279 255.538 316.085 256.193 315.486 256.138C314.888 256.084 316.085 255.592 316.085 255.592C316.085 255.592 307.901 257.667 306.703 258.65C305.506 259.632 302.312 262.526 301.513 262.144C300.715 261.762 302.911 258.65 302.911 258.65C302.911 258.65 300.715 260.178 299.917 260.724C299.118 261.27 296.922 261.216 295.924 262.144C294.926 263.072 290.734 260.506 291.932 259.632C293.13 258.759 296.124 256.957 300.316 256.52C304.508 256.084 313.291 255.265 313.49 254.937C313.69 254.61 310.097 254.555 310.097 254.555C310.097 254.555 313.291 254.009 316.884 254.173C320.477 254.337 333.052 254.064 337.643 254.173C342.235 254.282 352.016 254.719 356.008 255.155C360 255.592 406.111 259.523 408.706 257.885C408.706 257.885 409.105 257.066 408.107 256.739C407.109 256.411 405.312 256.52 404.314 256.193C403.316 255.865 401.919 254.992 401.719 254.61C401.52 254.227 399.923 252.972 398.925 252.862C397.927 252.753 396.928 253.408 395.93 253.354C394.932 253.299 394.134 252.972 394.134 252.48C394.134 251.989 395.731 250.242 395.93 249.696C396.13 249.15 393.735 248.986 395.132 248.822C396.529 248.659 401.719 248.822 402.917 248.822C404.115 248.822 402.118 249.205 401.32 249.314C400.522 249.423 399.923 250.133 399.723 250.46C399.523 250.788 399.723 251.498 399.923 251.88C400.122 252.262 403.316 253.135 404.514 253.627C405.711 254.118 413.896 256.193 415.492 256.302C417.089 256.411 419.285 257.667 419.285 257.667L424.475 257.121C424.475 257.121 422.08 256.848 422.08 256.63C422.08 256.411 420.283 254.937 419.285 254.555C418.287 254.173 413.097 254.391 412.898 254.118C412.698 253.845 412.498 253.245 414.494 253.026C416.491 252.808 421.88 251.388 422.279 251.388C422.679 251.388 423.277 251.006 423.078 250.842C422.878 250.679 421.68 249.696 421.88 249.478C422.08 249.259 423.078 249.041 424.475 249.095C425.872 249.15 425.673 249.587 426.072 249.86C426.471 250.133 426.072 250.952 425.673 251.388C425.274 251.825 420.882 252.862 421.082 253.627C421.281 254.391 431.262 256.903 431.262 256.903C431.262 256.903 433.857 256.52 435.254 256.302C436.651 256.084 439.646 255.974 439.646 255.974C439.646 255.974 439.446 255.101 440.045 254.828C440.644 254.555 442.839 254.009 444.037 253.791C445.235 253.572 448.628 252.917 449.427 252.59C450.225 252.262 450.026 251.989 450.026 251.443C450.026 250.897 447.231 250.406 447.431 250.024C447.63 249.641 452.421 249.314 452.82 249.314C453.219 249.314 453.219 248.768 454.018 248.768C454.816 248.768 457.012 248.659 457.81 248.659C458.609 248.659 458.21 248.768 458.21 248.768L461.603 248.877C461.603 249.259 457.81 249.259 456.812 249.423C455.814 249.587 455.215 250.242 455.016 250.406C454.816 250.569 454.816 250.733 454.816 250.897C454.816 251.061 454.617 251.716 454.816 252.207C455.016 252.699 456.613 254.391 456.812 254.828C457.012 255.265 456.014 255.538 456.214 255.974C456.413 256.411 462.002 258.267 462.202 258.65C462.402 259.032 462.601 259.796 462.601 260.124C462.601 260.451 464.597 261.379 464.997 261.816C465.396 262.253 465.795 263.236 465.795 263.509C465.795 263.782 467.192 264.382 467.591 264.546Z",
    fill: "url(#paint258_linear_210_10376)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M457.212 279.669C457.212 279.669 467.991 289.278 457.212 302.326C450.648 310.271 444.01 314.674 439.822 316.903C439.822 316.903 446.033 312.917 447.83 310.952C449.627 308.986 454.617 304.51 456.813 301.398C459.008 298.286 460.206 294.792 460.006 290.533C459.807 286.275 455.216 281.47 455.216 281.47C455.216 281.47 453.22 286.329 453.22 287.749C453.22 289.168 436.851 298.395 436.851 298.395L438.049 296.812C438.049 296.812 451.423 289.168 451.423 287.476C451.423 285.783 453.22 281.197 453.22 281.197L443.239 286.602V285.947C443.239 285.947 451.623 281.798 451.822 281.47C452.022 281.143 452.621 280.815 452.221 280.761C451.822 280.706 447.264 281.84 443.838 282.18V281.853C447.276 281.389 452.421 280.433 451.822 280.269C451.223 280.106 442.44 280.433 442.44 280.433L441.842 279.942C441.842 279.942 452.82 280.051 452.621 279.669C452.421 279.287 444.437 276.448 442.44 275.52C440.444 274.591 431.262 271.862 430.663 271.316C430.065 270.77 430.464 270.224 431.262 269.35C432.061 268.477 432.859 267.712 434.256 267.276C435.654 266.839 446.233 264.109 446.632 263.836C447.032 263.563 451.223 262.198 451.223 262.198L453.02 262.471C452.222 262.417 447.032 263.945 447.032 263.945C447.032 263.945 436.053 267.276 437.849 270.606C439.646 273.936 457.212 279.669 457.212 279.669Z",
    fill: "url(#paint259_linear_210_10376)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M442.442 265.703C439.68 266.979 436.873 268.792 437.851 270.605C438.505 271.818 441.254 273.351 444.483 274.809C444.483 274.809 436.653 272.297 435.855 271.915C435.056 271.533 433.095 271.26 433.26 269.731C433.424 268.203 442.442 265.703 442.442 265.703Z",
    fill: "url(#paint260_linear_210_10376)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M356.008 255.156C360 255.593 406.111 259.523 408.706 257.886C408.706 257.886 407.907 259.469 409.304 260.179C410.702 260.888 413.896 261.161 413.896 261.161C413.896 261.161 409.304 260.834 406.51 260.888C403.715 260.943 388.744 262.253 388.744 262.253C386.349 262.581 372.975 262.144 372.975 262.144C372.975 262.144 374.971 261.489 374.173 261.653C373.374 261.816 370.38 261.489 370.38 261.489C370.38 261.489 372.975 260.561 372.975 259.742C372.975 258.923 372.376 258.322 371.178 258.213C369.981 258.104 352.415 256.139 345.828 255.429C339.24 254.719 327.663 254.555 323.471 255.047C319.279 255.538 316.085 256.193 315.486 256.139C314.888 256.084 316.085 255.593 316.085 255.593C316.085 255.593 307.901 257.667 306.703 258.65C305.506 259.633 302.312 262.526 301.513 262.144C300.715 261.762 302.911 258.65 302.911 258.65C302.911 258.65 300.715 260.179 299.917 260.725C299.118 261.27 296.922 261.216 295.924 262.144C294.926 263.072 290.734 260.506 291.932 259.633C293.13 258.759 296.124 256.957 300.316 256.521C304.508 256.084 313.291 255.265 313.49 254.937C313.69 254.61 310.097 254.555 310.097 254.555C310.097 254.555 313.291 254.009 316.884 254.173C320.477 254.337 333.052 254.064 337.643 254.173C342.235 254.282 352.016 254.719 356.008 255.156Z",
    fill: "url(#paint261_linear_210_10376)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M356.011 255.156C360.003 255.593 406.114 259.523 408.709 257.886C408.709 257.886 407.91 259.469 409.308 260.179C410.705 260.888 413.899 261.161 413.899 261.161C413.899 261.161 409.308 260.834 406.513 260.888C403.719 260.943 388.748 262.253 388.748 262.253C386.352 262.581 372.978 262.144 372.978 262.144C372.978 262.144 374.974 261.489 374.176 261.653C373.378 261.816 370.383 261.489 370.383 261.489C370.383 261.489 372.978 260.561 372.978 259.742C372.978 258.923 372.379 258.322 371.182 258.213C369.984 258.104 352.418 256.139 345.831 255.429C339.244 254.719 327.666 254.555 323.474 255.047C323.474 255.047 322.676 254.937 316.687 255.374C310.699 255.811 302.914 258.65 302.914 258.65C302.914 258.65 306.307 256.193 312.695 255.429C319.083 254.664 325.271 254.206 325.271 254.206C329.904 254.172 335.051 254.111 337.647 254.173C342.238 254.282 352.019 254.719 356.011 255.156Z",
    fill: "url(#paint262_linear_210_10376)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 259.742C372.974 258.923 372.375 258.322 371.177 258.213C371.177 258.213 397.925 259.905 399.722 260.397C401.518 260.888 374.172 261.652 374.172 261.652C373.373 261.816 370.379 261.489 370.379 261.489C370.379 261.489 372.974 260.56 372.974 259.742Z",
    fill: "url(#paint263_linear_210_10376)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M391.739 267.932C393.735 265.53 388.745 262.254 388.745 262.254C388.745 262.254 404.913 260.835 408.107 260.889C411.301 260.944 412.698 261.108 412.698 261.108C412.698 261.108 418.287 261.708 424.475 261.654C430.663 261.599 434.855 261.108 434.855 261.108C434.855 261.108 440.245 260.453 441.842 260.671C443.438 260.889 446.433 261.818 448.03 261.927C449.626 262.036 451.024 262.2 451.024 262.2C451.024 262.2 447.032 263.565 446.433 263.947C445.834 264.329 436.851 266.513 433.657 267.277C430.464 268.041 425.872 269.461 425.872 270.116C425.872 270.771 426.471 271.153 427.07 271.699C427.669 272.245 442.241 280.162 443.239 280.926C444.237 281.69 443.838 283.874 443.638 284.857C443.438 285.839 442.241 290.207 441.642 291.736C441.043 293.264 437.849 297.195 436.851 298.396C435.853 299.597 422.08 308.824 422.08 308.824C422.08 308.824 415.093 313.465 399.524 318.542C399.524 318.542 397.528 311.554 396.33 310.189C395.132 308.824 391.539 307.241 381.958 305.93C380.96 299.761 370.181 297.359 370.181 297.359C370.181 297.359 373.774 292.991 373.574 291.244C373.374 289.497 373.574 287.368 367.785 284.584C379.762 280.162 377.367 274.32 377.367 274.32C377.367 274.32 389.743 270.334 391.739 267.932Z",
    fill: "url(#paint264_linear_210_10376)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M396.333 310.189C395.135 308.824 391.542 307.241 381.961 305.93C381.961 305.93 401.922 302.819 413.3 298.342C424.678 293.865 433.86 290.207 435.058 288.788C436.256 287.368 441.246 282.618 441.246 282.618C441.246 282.618 440.447 287.204 438.851 291.627C437.254 296.049 422.083 308.824 422.083 308.824C422.083 308.824 415.097 313.465 399.527 318.542C399.527 318.542 397.531 311.554 396.333 310.189Z",
    fill: "url(#paint265_linear_210_10376)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M381.961 305.93C380.963 299.76 370.184 297.358 370.184 297.358C370.184 297.358 391.941 295.174 400.325 293.209C408.709 291.244 423.68 287.695 426.275 286.931C428.87 286.166 439.649 282.126 439.649 282.126C439.649 282.126 436.255 285.839 433.461 288.077C430.666 290.315 423.081 293.755 412.701 297.795C402.321 301.835 381.961 305.93 381.961 305.93Z",
    fill: "url(#paint266_linear_210_10376)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M373.575 291.245C373.375 289.501 373.574 287.376 367.817 284.599C370.624 284.697 386.402 285.229 392.937 285.13C400.123 285.021 416.891 283.929 420.085 283.765C423.278 283.601 438.649 281.636 438.649 281.636C438.649 281.636 430.864 284.966 425.674 286.604C420.484 288.242 408.307 291.026 398.526 293.21C388.745 295.394 370.181 297.359 370.181 297.359C370.181 297.359 373.774 292.992 373.575 291.245Z",
    fill: "url(#paint267_linear_210_10376)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M391.743 267.933C393.739 265.53 388.749 262.255 388.749 262.255C388.749 262.255 401.923 261.054 406.515 260.89C411.106 260.726 417.094 261.654 423.482 261.654C429.869 261.654 432.464 261.163 435.858 261.108C439.251 261.054 442.245 262.145 440.848 263.401C439.451 264.657 420.487 268.751 420.687 269.734C420.887 270.717 435.458 277.323 439.251 280.599C439.251 280.599 423.881 280.599 418.292 279.889C412.703 279.179 401.724 278.306 396.334 277.76C390.945 277.214 377.371 274.32 377.371 274.32C377.371 274.32 389.747 270.335 391.743 267.933Z",
    fill: "url(#paint268_linear_210_10376)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M395.731 278.034C389.743 277.324 377.167 274.321 377.167 274.321C379.362 280.873 367.785 284.585 367.785 284.585C367.785 284.585 382.557 285.131 393.934 284.804C405.312 284.476 415.493 283.766 420.683 283.329C425.873 282.893 438.249 281.146 438.249 281.146C438.249 281.146 427.469 280.709 421.681 280.491C415.892 280.272 401.719 278.743 395.731 278.034Z",
    fill: "url(#paint269_linear_210_10376)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M467.594 264.546C467.994 264.709 468.992 264.928 469.191 265.037C469.391 265.146 469.391 265.638 469.79 265.801C470.189 265.965 471.786 266.675 472.185 266.839C472.585 267.002 472.784 267.658 471.786 267.712C470.788 267.767 469.191 266.729 468.393 266.729C467.594 266.729 467.794 266.948 467.994 267.002C468.193 267.057 471.387 268.313 470.788 268.75C470.189 269.186 470.189 269.951 467.994 269.951C465.798 269.951 464.999 269.405 464.999 269.132V267.876C464.999 267.658 464.001 267.494 462.804 267.494C461.606 267.494 460.807 267.712 460.807 267.876V269.459C460.807 269.459 460.807 270.06 459.211 269.951C457.614 269.841 455.817 269.022 455.817 268.586C455.817 268.149 456.815 267.712 457.015 267.439C457.214 267.166 456.616 266.839 456.216 266.839C455.817 266.839 455.817 267.275 455.817 267.439C455.817 267.603 455.019 268.149 454.22 268.149C453.422 268.149 453.821 267.548 453.422 267.275C453.023 267.002 454.619 266.293 454.619 266.293C454.619 266.293 454.42 265.801 454.22 265.692C454.021 265.583 455.218 265.365 455.218 265.365V263.399C455.218 263.126 453.821 262.526 453.023 262.471C453.023 262.471 451.426 262.198 448.631 261.98C445.836 261.761 443.241 260.615 440.846 260.615C438.451 260.615 435.057 261.106 435.057 261.106C435.057 261.106 429.867 261.598 424.677 261.652C419.488 261.707 410.106 261.161 408.908 259.96C407.71 258.759 408.708 257.885 408.708 257.885C408.708 257.885 409.108 257.066 408.11 256.739C407.112 256.411 405.315 256.52 404.317 256.193C403.319 255.865 401.922 254.991 401.722 254.609C401.522 254.227 399.925 252.971 398.927 252.862C397.929 252.753 396.931 253.408 395.933 253.354C394.935 253.299 394.137 252.971 394.137 252.48C394.137 251.989 395.734 250.242 395.933 249.696C396.133 249.15 393.737 248.986 395.135 248.822C396.532 248.658 401.722 248.822 402.92 248.822C404.117 248.822 402.121 249.204 401.323 249.314C400.524 249.423 399.925 250.133 399.726 250.46C399.526 250.788 399.726 251.497 399.925 251.88C400.125 252.262 403.319 253.135 404.517 253.627C405.714 254.118 413.898 256.193 415.495 256.302C417.092 256.411 419.288 257.667 419.288 257.667L424.478 257.121C424.478 257.121 422.083 256.848 422.083 256.629C422.083 256.411 420.286 254.937 419.288 254.555C418.29 254.173 413.1 254.391 412.9 254.118C412.701 253.845 412.501 253.244 414.497 253.026C416.493 252.808 421.883 251.388 422.282 251.388C422.681 251.388 423.28 251.006 423.081 250.842C422.881 250.678 421.683 249.696 421.883 249.477C422.083 249.259 423.081 249.041 424.478 249.095C425.875 249.15 425.676 249.587 426.075 249.86C426.474 250.133 426.075 250.951 425.676 251.388C425.276 251.825 420.885 252.862 421.084 253.627C421.284 254.391 431.265 256.902 431.265 256.902C431.265 256.902 433.86 256.52 435.257 256.302C436.654 256.083 439.648 255.974 439.648 255.974C439.648 255.974 439.449 255.101 440.048 254.828C440.647 254.555 442.842 254.009 444.04 253.79C445.238 253.572 448.631 252.917 449.43 252.589C450.228 252.262 450.028 251.989 450.028 251.443C450.028 250.897 447.234 250.405 447.433 250.023C447.633 249.641 452.424 249.314 452.823 249.314C453.222 249.314 453.222 248.768 454.021 248.768C454.819 248.768 457.015 248.658 457.813 248.658C458.612 248.658 458.212 248.768 458.212 248.768L461.606 248.877C461.606 249.259 457.813 249.259 456.815 249.423C455.817 249.587 455.218 250.242 455.019 250.405C454.819 250.569 454.819 250.733 454.819 250.897C454.819 251.061 454.619 251.716 454.819 252.207C455.019 252.698 456.616 254.391 456.815 254.828C457.015 255.264 456.017 255.537 456.216 255.974C456.416 256.411 462.005 258.267 462.205 258.649C462.404 259.032 462.604 259.796 462.604 260.123C462.604 260.451 464.6 261.379 464.999 261.816C465.399 262.253 465.798 263.235 465.798 263.508C465.798 263.781 467.195 264.382 467.594 264.546Z",
    fill: "url(#paint270_linear_210_10376)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M394.137 252.48C394.137 251.988 395.734 250.241 395.933 249.695C395.933 249.695 396.532 251.934 396.931 252.261C397.331 252.589 398.927 252.862 398.927 252.862C397.929 252.753 396.931 253.408 395.933 253.353C394.935 253.299 394.137 252.971 394.137 252.48Z",
    fill: "#33123A"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M422.283 251.387C421.884 251.387 416.495 252.807 414.499 253.025C412.502 253.243 412.702 253.844 412.902 254.117C413.095 254.382 417.994 254.184 419.192 254.522C419.256 254.543 419.289 254.554 419.289 254.554C419.26 254.543 419.228 254.532 419.192 254.522C418.909 254.43 418.035 254.146 416.894 253.789C415.497 253.353 422.283 251.387 422.283 251.387Z",
    fill: "#4F2758"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M444.041 253.79C445.238 253.572 448.632 252.917 449.43 252.589C449.43 252.589 444.44 254.991 444.44 255.81C444.44 256.629 448.632 257.666 445.238 259.086C445.238 259.086 447.234 257.83 445.638 257.121C444.041 256.411 439.649 255.974 439.649 255.974C439.649 255.974 439.45 255.1 440.048 254.828C440.647 254.555 442.843 254.009 444.041 253.79Z",
    fill: "url(#paint271_linear_210_10376)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M465.799 263.508C465.799 263.781 467.196 264.382 467.596 264.545C467.596 264.545 465.599 264.054 464.402 263.781C463.204 263.508 463.004 263.29 461.607 263.399C460.21 263.508 457.016 264.218 457.016 264.655C457.016 265.091 455.22 265.364 455.22 265.364V263.399C455.22 263.399 458.813 262.634 458.813 261.379C458.813 260.123 459.212 259.359 458.813 259.086C458.413 258.813 456.218 259.086 456.218 259.086C456.817 258.649 452.824 256.629 452.824 256.629C452.824 256.629 457.815 257.503 459.212 257.939C460.609 258.376 460.21 258.758 460.41 259.086C460.609 259.413 462.605 260.123 462.605 260.123C462.605 260.451 464.601 261.379 465.001 261.816C465.4 262.252 465.799 263.235 465.799 263.508Z",
    fill: "url(#paint272_linear_210_10376)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M426.276 257.558C428.272 257.339 431.266 256.903 431.266 256.903C431.266 256.903 423.082 258.54 424.28 259.196C424.08 259.523 419.09 257.721 419.09 257.721C419.09 257.721 424.28 257.776 426.276 257.558Z",
    fill: "url(#paint273_linear_210_10376)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M466.595 265.966C464.798 265.857 464 264.983 464 264.983C464 264.983 466.395 265.256 467.393 265.256C468.391 265.256 468.391 265.748 468.391 265.748C468.391 265.748 468.391 266.075 466.595 265.966Z",
    fill: "#896778"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M458.809 265.965C459.807 265.801 460.006 265.037 460.006 265.037C460.006 265.037 458.01 265.255 456.812 265.419C455.615 265.583 455.699 265.922 456.014 266.074C456.014 266.074 457.81 266.129 458.809 265.965Z",
    fill: "#896778"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M462.602 264.327C462.203 264.273 462.004 264 462.004 264C462.004 264 463.001 264.109 463.201 264.109C463.401 264.109 463.6 264.273 463.6 264.273C463.6 264.273 463.001 264.382 462.602 264.327Z",
    fill: "#6B466A"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M460.792 264.32C461.151 264.25 461.18 263.983 461.18 263.983C461.18 263.983 460.265 264.134 460.069 264.144C459.872 264.153 459.776 264.317 459.776 264.317C459.776 264.317 460.433 264.391 460.792 264.32Z",
    fill: "#6B466A"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M453.62 250.133C453.42 249.969 453.819 248.823 453.819 248.823C453.819 248.823 452.621 249.805 453.021 250.024C453.42 250.242 453.42 251.989 453.42 252.426C453.42 252.863 452.422 256.575 452.422 256.575C452.422 256.575 453.22 255.483 453.42 255.047C453.62 254.61 453.819 250.297 453.62 250.133Z",
    fill: "url(#paint274_linear_210_10376)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M467.591 264.546C467.991 264.71 468.989 264.928 469.188 265.037C469.388 265.146 469.388 265.638 469.787 265.802C470.186 265.965 471.783 266.675 472.183 266.839C472.582 267.003 472.781 267.658 471.783 267.712C470.785 267.767 469.188 266.73 468.39 266.73C467.591 266.73 467.791 266.948 467.991 267.003C468.19 267.057 471.384 268.313 470.785 268.75C470.186 269.186 470.186 269.951 467.991 269.951C465.795 269.951 464.997 269.405 464.997 269.132V267.876C464.997 267.658 463.998 267.494 462.801 267.494C461.603 267.494 460.805 267.712 460.805 267.876V269.459C460.805 269.459 460.805 270.06 459.208 269.951C457.611 269.842 455.814 269.023 455.814 268.586C455.814 268.149 456.812 267.712 457.012 267.439C457.212 267.166 456.613 266.839 456.214 266.839C455.814 266.839 455.814 267.276 455.814 267.439C455.814 267.603 455.016 268.149 454.217 268.149C453.419 268.149 453.818 267.549 453.419 267.276C453.02 267.003 454.617 266.293 454.617 266.293C454.617 266.293 454.417 265.802 454.217 265.692C454.018 265.583 455.215 265.365 455.215 265.365V263.399C455.215 263.126 453.818 262.526 453.02 262.471C452.221 262.417 447.031 263.945 447.031 263.945C447.031 263.945 436.053 267.276 437.849 270.606C439.646 273.936 457.212 279.669 457.212 279.669C457.212 279.669 467.991 289.278 457.212 302.326C446.433 315.374 435.454 318.868 435.454 318.868C435.454 318.868 431.062 314.446 430.264 312.753C429.465 311.061 422.08 308.823 422.08 308.823C422.08 308.823 415.093 313.463 399.523 318.541C399.523 318.541 397.527 311.552 396.33 310.188C395.132 308.823 391.539 307.239 381.958 305.929C380.959 299.76 370.18 297.358 370.18 297.358C370.18 297.358 373.773 292.99 373.574 291.243C373.374 289.496 373.574 287.367 367.785 284.582C379.762 280.16 377.366 274.318 377.366 274.318C377.366 274.318 389.742 270.333 391.739 267.931C393.735 265.529 388.744 262.253 388.744 262.253C386.349 262.58 372.975 262.144 372.975 262.144C372.975 262.144 374.971 261.489 374.173 261.652C373.374 261.816 370.38 261.489 370.38 261.489C370.38 261.489 372.975 260.56 372.975 259.741C372.975 258.923 372.376 258.322 371.178 258.213C369.981 258.104 352.415 256.138 345.828 255.428C339.24 254.719 327.663 254.555 323.471 255.046C319.279 255.538 316.085 256.193 315.486 256.138C314.888 256.084 316.085 255.592 316.085 255.592C316.085 255.592 307.901 257.667 306.703 258.65C305.506 259.632 302.312 262.526 301.513 262.144C300.715 261.762 302.911 258.65 302.911 258.65C302.911 258.65 300.715 260.178 299.917 260.724C299.118 261.27 296.922 261.216 295.924 262.144C294.926 263.072 290.734 260.506 291.932 259.632C293.13 258.759 296.124 256.957 300.316 256.52C304.508 256.084 313.291 255.265 313.49 254.937C313.69 254.61 310.097 254.555 310.097 254.555C310.097 254.555 313.291 254.009 316.884 254.173C320.477 254.337 333.052 254.064 337.643 254.173C342.235 254.282 352.016 254.719 356.008 255.155C360 255.592 406.111 259.523 408.706 257.885C408.706 257.885 409.105 257.066 408.107 256.739C407.109 256.411 405.312 256.52 404.314 256.193C403.316 255.865 401.919 254.992 401.719 254.61C401.52 254.227 399.923 252.972 398.925 252.862C397.927 252.753 396.928 253.408 395.93 253.354C394.932 253.299 394.134 252.972 394.134 252.48C394.134 251.989 395.731 250.242 395.93 249.696C396.13 249.15 393.735 248.986 395.132 248.822C396.529 248.659 401.719 248.822 402.917 248.822C404.115 248.822 402.118 249.205 401.32 249.314C400.522 249.423 399.923 250.133 399.723 250.46C399.523 250.788 399.723 251.498 399.923 251.88C400.122 252.262 403.316 253.135 404.514 253.627C405.711 254.118 413.896 256.193 415.492 256.302C417.089 256.411 419.285 257.667 419.285 257.667L424.475 257.121C424.475 257.121 422.08 256.848 422.08 256.63C422.08 256.411 420.283 254.937 419.285 254.555C418.287 254.173 413.097 254.391 412.898 254.118C412.698 253.845 412.498 253.245 414.494 253.026C416.491 252.808 421.88 251.388 422.279 251.388C422.679 251.388 423.277 251.006 423.078 250.842C422.878 250.679 421.68 249.696 421.88 249.478C422.08 249.259 423.078 249.041 424.475 249.095C425.872 249.15 425.673 249.587 426.072 249.86C426.471 250.133 426.072 250.952 425.673 251.388C425.274 251.825 420.882 252.862 421.082 253.627C421.281 254.391 431.262 256.903 431.262 256.903C431.262 256.903 433.857 256.52 435.254 256.302C436.651 256.084 439.646 255.974 439.646 255.974C439.646 255.974 439.446 255.101 440.045 254.828C440.644 254.555 442.839 254.009 444.037 253.791C445.235 253.572 448.628 252.917 449.427 252.59C450.225 252.262 450.026 251.989 450.026 251.443C450.026 250.897 447.231 250.406 447.431 250.024C447.63 249.641 452.421 249.314 452.82 249.314C453.219 249.314 453.219 248.768 454.018 248.768C454.816 248.768 457.012 248.659 457.81 248.659C458.609 248.659 458.21 248.768 458.21 248.768L461.603 248.877C461.603 249.259 457.81 249.259 456.812 249.423C455.814 249.587 455.215 250.242 455.016 250.406C454.816 250.569 454.816 250.733 454.816 250.897C454.816 251.061 454.617 251.716 454.816 252.207C455.016 252.699 456.613 254.391 456.812 254.828C457.012 255.265 456.014 255.538 456.214 255.974C456.413 256.411 462.002 258.267 462.202 258.65C462.402 259.032 462.601 259.796 462.601 260.124C462.601 260.451 464.597 261.379 464.997 261.816C465.396 262.253 465.795 263.236 465.795 263.509C465.795 263.782 467.192 264.382 467.591 264.546Z",
    fill: "url(#paint275_linear_210_10376)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M457.212 279.669C457.212 279.669 467.991 289.278 457.212 302.326C450.648 310.271 444.01 314.674 439.822 316.903C439.822 316.903 446.033 312.917 447.83 310.952C449.627 308.986 454.617 304.51 456.813 301.398C459.008 298.286 460.206 294.792 460.006 290.533C459.807 286.275 455.216 281.47 455.216 281.47C455.216 281.47 453.22 286.329 453.22 287.749C453.22 289.168 436.851 298.395 436.851 298.395L438.049 296.812C438.049 296.812 451.423 289.168 451.423 287.476C451.423 285.783 453.22 281.197 453.22 281.197L443.239 286.602V285.947C443.239 285.947 451.623 281.798 451.822 281.47C452.022 281.143 452.621 280.815 452.221 280.761C451.822 280.706 447.264 281.84 443.838 282.18V281.853C447.276 281.389 452.421 280.433 451.822 280.269C451.223 280.106 442.44 280.433 442.44 280.433L441.842 279.942C441.842 279.942 452.82 280.051 452.621 279.669C452.421 279.287 444.437 276.448 442.44 275.52C440.444 274.591 431.262 271.862 430.663 271.316C430.065 270.77 430.464 270.224 431.262 269.35C432.061 268.477 432.859 267.712 434.256 267.276C435.654 266.839 446.233 264.109 446.632 263.836C447.032 263.563 451.223 262.198 451.223 262.198L453.02 262.471C452.222 262.417 447.032 263.945 447.032 263.945C447.032 263.945 436.053 267.276 437.849 270.606C439.646 273.936 457.212 279.669 457.212 279.669Z",
    fill: "url(#paint276_linear_210_10376)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M442.442 265.703C439.68 266.979 436.873 268.792 437.851 270.605C438.505 271.818 441.254 273.351 444.483 274.809C444.483 274.809 436.653 272.297 435.855 271.915C435.056 271.533 433.095 271.26 433.26 269.731C433.424 268.203 442.442 265.703 442.442 265.703Z",
    fill: "url(#paint277_linear_210_10376)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M356.008 255.156C360 255.593 406.111 259.523 408.706 257.886C408.706 257.886 407.907 259.469 409.304 260.179C410.702 260.888 413.896 261.161 413.896 261.161C413.896 261.161 409.304 260.834 406.51 260.888C403.715 260.943 388.744 262.253 388.744 262.253C386.349 262.581 372.975 262.144 372.975 262.144C372.975 262.144 374.971 261.489 374.173 261.653C373.374 261.816 370.38 261.489 370.38 261.489C370.38 261.489 372.975 260.561 372.975 259.742C372.975 258.923 372.376 258.322 371.178 258.213C369.981 258.104 352.415 256.139 345.828 255.429C339.24 254.719 327.663 254.555 323.471 255.047C319.279 255.538 316.085 256.193 315.486 256.139C314.888 256.084 316.085 255.593 316.085 255.593C316.085 255.593 307.901 257.667 306.703 258.65C305.506 259.633 302.312 262.526 301.513 262.144C300.715 261.762 302.911 258.65 302.911 258.65C302.911 258.65 300.715 260.179 299.917 260.725C299.118 261.27 296.922 261.216 295.924 262.144C294.926 263.072 290.734 260.506 291.932 259.633C293.13 258.759 296.124 256.957 300.316 256.521C304.508 256.084 313.291 255.265 313.49 254.937C313.69 254.61 310.097 254.555 310.097 254.555C310.097 254.555 313.291 254.009 316.884 254.173C320.477 254.337 333.052 254.064 337.643 254.173C342.235 254.282 352.016 254.719 356.008 255.156Z",
    fill: "url(#paint278_linear_210_10376)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M356.011 255.156C360.003 255.593 406.114 259.523 408.709 257.886C408.709 257.886 407.91 259.469 409.308 260.179C410.705 260.888 413.899 261.161 413.899 261.161C413.899 261.161 409.308 260.834 406.513 260.888C403.719 260.943 388.748 262.253 388.748 262.253C386.352 262.581 372.978 262.144 372.978 262.144C372.978 262.144 374.974 261.489 374.176 261.653C373.378 261.816 370.383 261.489 370.383 261.489C370.383 261.489 372.978 260.561 372.978 259.742C372.978 258.923 372.379 258.322 371.182 258.213C369.984 258.104 352.418 256.139 345.831 255.429C339.244 254.719 327.666 254.555 323.474 255.047C323.474 255.047 322.676 254.937 316.687 255.374C310.699 255.811 302.914 258.65 302.914 258.65C302.914 258.65 306.307 256.193 312.695 255.429C319.083 254.664 325.271 254.206 325.271 254.206C329.904 254.172 335.051 254.111 337.647 254.173C342.238 254.282 352.019 254.719 356.011 255.156Z",
    fill: "url(#paint279_linear_210_10376)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 259.742C372.974 258.923 372.375 258.322 371.177 258.213C371.177 258.213 397.925 259.905 399.722 260.397C401.518 260.888 374.172 261.652 374.172 261.652C373.373 261.816 370.379 261.489 370.379 261.489C370.379 261.489 372.974 260.56 372.974 259.742Z",
    fill: "url(#paint280_linear_210_10376)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M391.739 267.932C393.735 265.53 388.745 262.254 388.745 262.254C388.745 262.254 404.913 260.835 408.107 260.889C411.301 260.944 412.698 261.108 412.698 261.108C412.698 261.108 418.287 261.708 424.475 261.654C430.663 261.599 434.855 261.108 434.855 261.108C434.855 261.108 440.245 260.453 441.842 260.671C443.438 260.889 446.433 261.818 448.03 261.927C449.626 262.036 451.024 262.2 451.024 262.2C451.024 262.2 447.032 263.565 446.433 263.947C445.834 264.329 436.851 266.513 433.657 267.277C430.464 268.041 425.872 269.461 425.872 270.116C425.872 270.771 426.471 271.153 427.07 271.699C427.669 272.245 442.241 280.162 443.239 280.926C444.237 281.69 443.838 283.874 443.638 284.857C443.438 285.839 442.241 290.207 441.642 291.736C441.043 293.264 437.849 297.195 436.851 298.396C435.853 299.597 422.08 308.824 422.08 308.824C422.08 308.824 415.093 313.465 399.524 318.542C399.524 318.542 397.528 311.554 396.33 310.189C395.132 308.824 391.539 307.241 381.958 305.93C380.96 299.761 370.181 297.359 370.181 297.359C370.181 297.359 373.774 292.991 373.574 291.244C373.374 289.497 373.574 287.368 367.785 284.584C379.762 280.162 377.367 274.32 377.367 274.32C377.367 274.32 389.743 270.334 391.739 267.932Z",
    fill: "url(#paint281_linear_210_10376)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M396.333 310.189C395.135 308.824 391.542 307.241 381.961 305.93C381.961 305.93 401.922 302.819 413.3 298.342C424.678 293.865 433.86 290.207 435.058 288.788C436.256 287.368 441.246 282.618 441.246 282.618C441.246 282.618 440.447 287.204 438.851 291.627C437.254 296.049 422.083 308.824 422.083 308.824C422.083 308.824 415.097 313.465 399.527 318.542C399.527 318.542 397.531 311.554 396.333 310.189Z",
    fill: "url(#paint282_linear_210_10376)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M381.961 305.93C380.963 299.76 370.184 297.358 370.184 297.358C370.184 297.358 391.941 295.174 400.325 293.209C408.709 291.244 423.68 287.695 426.275 286.931C428.87 286.166 439.649 282.126 439.649 282.126C439.649 282.126 436.255 285.839 433.461 288.077C430.666 290.315 423.081 293.755 412.701 297.795C402.321 301.835 381.961 305.93 381.961 305.93Z",
    fill: "url(#paint283_linear_210_10376)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M373.575 291.245C373.375 289.501 373.574 287.376 367.817 284.599C370.624 284.697 386.402 285.229 392.937 285.13C400.123 285.021 416.891 283.929 420.085 283.765C423.278 283.601 438.649 281.636 438.649 281.636C438.649 281.636 430.864 284.966 425.674 286.604C420.484 288.242 408.307 291.026 398.526 293.21C388.745 295.394 370.181 297.359 370.181 297.359C370.181 297.359 373.774 292.992 373.575 291.245Z",
    fill: "url(#paint284_linear_210_10376)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M391.743 267.933C393.739 265.53 388.749 262.255 388.749 262.255C388.749 262.255 401.923 261.054 406.515 260.89C411.106 260.726 417.094 261.654 423.482 261.654C429.869 261.654 432.464 261.163 435.858 261.108C439.251 261.054 442.245 262.145 440.848 263.401C439.451 264.657 420.487 268.751 420.687 269.734C420.887 270.717 435.458 277.323 439.251 280.599C439.251 280.599 423.881 280.599 418.292 279.889C412.703 279.179 401.724 278.306 396.334 277.76C390.945 277.214 377.371 274.32 377.371 274.32C377.371 274.32 389.747 270.335 391.743 267.933Z",
    fill: "url(#paint285_linear_210_10376)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M395.731 278.034C389.743 277.324 377.167 274.321 377.167 274.321C379.362 280.873 367.785 284.585 367.785 284.585C367.785 284.585 382.557 285.131 393.934 284.804C405.312 284.476 415.493 283.766 420.683 283.329C425.873 282.893 438.249 281.146 438.249 281.146C438.249 281.146 427.469 280.709 421.681 280.491C415.892 280.272 401.719 278.743 395.731 278.034Z",
    fill: "url(#paint286_linear_210_10376)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M467.594 264.546C467.994 264.709 468.992 264.928 469.191 265.037C469.391 265.146 469.391 265.638 469.79 265.801C470.189 265.965 471.786 266.675 472.185 266.839C472.585 267.002 472.784 267.658 471.786 267.712C470.788 267.767 469.191 266.729 468.393 266.729C467.594 266.729 467.794 266.948 467.994 267.002C468.193 267.057 471.387 268.313 470.788 268.75C470.189 269.186 470.189 269.951 467.994 269.951C465.798 269.951 464.999 269.405 464.999 269.132V267.876C464.999 267.658 464.001 267.494 462.804 267.494C461.606 267.494 460.807 267.712 460.807 267.876V269.459C460.807 269.459 460.807 270.06 459.211 269.951C457.614 269.841 455.817 269.022 455.817 268.586C455.817 268.149 456.815 267.712 457.015 267.439C457.214 267.166 456.616 266.839 456.216 266.839C455.817 266.839 455.817 267.275 455.817 267.439C455.817 267.603 455.019 268.149 454.22 268.149C453.422 268.149 453.821 267.548 453.422 267.275C453.023 267.002 454.619 266.293 454.619 266.293C454.619 266.293 454.42 265.801 454.22 265.692C454.021 265.583 455.218 265.365 455.218 265.365V263.399C455.218 263.126 453.821 262.526 453.023 262.471C453.023 262.471 451.426 262.198 448.631 261.98C445.836 261.761 443.241 260.615 440.846 260.615C438.451 260.615 435.057 261.106 435.057 261.106C435.057 261.106 429.867 261.598 424.677 261.652C419.488 261.707 410.106 261.161 408.908 259.96C407.71 258.759 408.708 257.885 408.708 257.885C408.708 257.885 409.108 257.066 408.11 256.739C407.112 256.411 405.315 256.52 404.317 256.193C403.319 255.865 401.922 254.991 401.722 254.609C401.522 254.227 399.925 252.971 398.927 252.862C397.929 252.753 396.931 253.408 395.933 253.354C394.935 253.299 394.137 252.971 394.137 252.48C394.137 251.989 395.734 250.242 395.933 249.696C396.133 249.15 393.737 248.986 395.135 248.822C396.532 248.658 401.722 248.822 402.92 248.822C404.117 248.822 402.121 249.204 401.323 249.314C400.524 249.423 399.925 250.133 399.726 250.46C399.526 250.788 399.726 251.497 399.925 251.88C400.125 252.262 403.319 253.135 404.517 253.627C405.714 254.118 413.898 256.193 415.495 256.302C417.092 256.411 419.288 257.667 419.288 257.667L424.478 257.121C424.478 257.121 422.083 256.848 422.083 256.629C422.083 256.411 420.286 254.937 419.288 254.555C418.29 254.173 413.1 254.391 412.9 254.118C412.701 253.845 412.501 253.244 414.497 253.026C416.493 252.808 421.883 251.388 422.282 251.388C422.681 251.388 423.28 251.006 423.081 250.842C422.881 250.678 421.683 249.696 421.883 249.477C422.083 249.259 423.081 249.041 424.478 249.095C425.875 249.15 425.676 249.587 426.075 249.86C426.474 250.133 426.075 250.951 425.676 251.388C425.276 251.825 420.885 252.862 421.084 253.627C421.284 254.391 431.265 256.902 431.265 256.902C431.265 256.902 433.86 256.52 435.257 256.302C436.654 256.083 439.648 255.974 439.648 255.974C439.648 255.974 439.449 255.101 440.048 254.828C440.647 254.555 442.842 254.009 444.04 253.79C445.238 253.572 448.631 252.917 449.43 252.589C450.228 252.262 450.028 251.989 450.028 251.443C450.028 250.897 447.234 250.405 447.433 250.023C447.633 249.641 452.424 249.314 452.823 249.314C453.222 249.314 453.222 248.768 454.021 248.768C454.819 248.768 457.015 248.658 457.813 248.658C458.612 248.658 458.212 248.768 458.212 248.768L461.606 248.877C461.606 249.259 457.813 249.259 456.815 249.423C455.817 249.587 455.218 250.242 455.019 250.405C454.819 250.569 454.819 250.733 454.819 250.897C454.819 251.061 454.619 251.716 454.819 252.207C455.019 252.698 456.616 254.391 456.815 254.828C457.015 255.264 456.017 255.537 456.216 255.974C456.416 256.411 462.005 258.267 462.205 258.649C462.404 259.032 462.604 259.796 462.604 260.123C462.604 260.451 464.6 261.379 464.999 261.816C465.399 262.253 465.798 263.235 465.798 263.508C465.798 263.781 467.195 264.382 467.594 264.546Z",
    fill: "url(#paint287_linear_210_10376)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M394.137 252.48C394.137 251.988 395.734 250.241 395.933 249.695C395.933 249.695 396.532 251.934 396.931 252.261C397.331 252.589 398.927 252.862 398.927 252.862C397.929 252.753 396.931 253.408 395.933 253.353C394.935 253.299 394.137 252.971 394.137 252.48Z",
    fill: "#33123A"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M422.283 251.387C421.884 251.387 416.495 252.807 414.499 253.025C412.502 253.243 412.702 253.844 412.902 254.117C413.095 254.382 417.994 254.184 419.192 254.522C419.256 254.543 419.289 254.554 419.289 254.554C419.26 254.543 419.228 254.532 419.192 254.522C418.909 254.43 418.035 254.146 416.894 253.789C415.497 253.353 422.283 251.387 422.283 251.387Z",
    fill: "#4F2758"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M444.041 253.79C445.238 253.572 448.632 252.917 449.43 252.589C449.43 252.589 444.44 254.991 444.44 255.81C444.44 256.629 448.632 257.666 445.238 259.086C445.238 259.086 447.234 257.83 445.638 257.121C444.041 256.411 439.649 255.974 439.649 255.974C439.649 255.974 439.45 255.1 440.048 254.828C440.647 254.555 442.843 254.009 444.041 253.79Z",
    fill: "url(#paint288_linear_210_10376)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M465.799 263.508C465.799 263.781 467.196 264.382 467.596 264.545C467.596 264.545 465.599 264.054 464.402 263.781C463.204 263.508 463.004 263.29 461.607 263.399C460.21 263.508 457.016 264.218 457.016 264.655C457.016 265.091 455.22 265.364 455.22 265.364V263.399C455.22 263.399 458.813 262.634 458.813 261.379C458.813 260.123 459.212 259.359 458.813 259.086C458.413 258.813 456.218 259.086 456.218 259.086C456.817 258.649 452.824 256.629 452.824 256.629C452.824 256.629 457.815 257.503 459.212 257.939C460.609 258.376 460.21 258.758 460.41 259.086C460.609 259.413 462.605 260.123 462.605 260.123C462.605 260.451 464.601 261.379 465.001 261.816C465.4 262.252 465.799 263.235 465.799 263.508Z",
    fill: "url(#paint289_linear_210_10376)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M426.276 257.558C428.272 257.339 431.266 256.903 431.266 256.903C431.266 256.903 423.082 258.54 424.28 259.196C424.08 259.523 419.09 257.721 419.09 257.721C419.09 257.721 424.28 257.776 426.276 257.558Z",
    fill: "url(#paint290_linear_210_10376)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M466.595 265.966C464.798 265.857 464 264.983 464 264.983C464 264.983 466.395 265.256 467.393 265.256C468.391 265.256 468.391 265.748 468.391 265.748C468.391 265.748 468.391 266.075 466.595 265.966Z",
    fill: "#896778"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M458.809 265.965C459.807 265.801 460.006 265.037 460.006 265.037C460.006 265.037 458.01 265.255 456.812 265.419C455.615 265.583 455.699 265.922 456.014 266.074C456.014 266.074 457.81 266.129 458.809 265.965Z",
    fill: "#896778"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M462.602 264.327C462.203 264.273 462.004 264 462.004 264C462.004 264 463.001 264.109 463.201 264.109C463.401 264.109 463.6 264.273 463.6 264.273C463.6 264.273 463.001 264.382 462.602 264.327Z",
    fill: "#6B466A"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M460.792 264.32C461.151 264.25 461.18 263.983 461.18 263.983C461.18 263.983 460.265 264.134 460.069 264.144C459.872 264.153 459.776 264.317 459.776 264.317C459.776 264.317 460.433 264.391 460.792 264.32Z",
    fill: "#6B466A"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M453.62 250.133C453.42 249.969 453.819 248.823 453.819 248.823C453.819 248.823 452.621 249.805 453.021 250.024C453.42 250.242 453.42 251.989 453.42 252.426C453.42 252.863 452.422 256.575 452.422 256.575C452.422 256.575 453.22 255.483 453.42 255.047C453.62 254.61 453.819 250.297 453.62 250.133Z",
    fill: "url(#paint291_linear_210_10376)"
  }))), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M298.636 260.499C298.836 261.864 299.235 263.175 299.235 263.175C299.235 263.175 310.613 263.884 312.21 263.721C313.807 263.557 312.01 260.663 312.21 259.626C312.409 258.589 309.415 257.442 309.216 255.859C309.016 254.276 308.218 251.437 308.218 251.437C308.218 251.437 304.225 252.802 303.227 252.747C302.229 252.692 301.431 252.529 301.431 252.529C301.431 252.529 301.752 254.561 301.431 255.859C300.977 257.691 298.437 259.135 298.636 260.499Z",
    fill: "#6771C7"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M298.637 260.499C298.836 261.864 299.236 263.175 299.236 263.175C299.236 263.175 310.613 263.884 312.21 263.721C313.807 263.557 312.011 260.663 312.21 259.626C312.41 258.589 309.416 257.442 309.216 255.859C309.017 254.276 308.218 251.437 308.218 251.437C308.218 251.437 308.218 255.422 306.821 257.442C305.423 259.462 298.637 260.499 298.637 260.499Z",
    fill: "url(#paint292_linear_210_10376)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M303.225 252.747C302.227 252.693 301.428 252.529 301.428 252.529C301.428 252.529 299.033 251 298.035 250.618C297.037 250.236 298.833 249.472 299.831 249.308C300.829 249.144 303.823 249.526 305.021 249.69C306.219 249.854 306.219 247.233 307.217 247.179C308.215 247.124 307.217 249.253 307.416 249.363C307.616 249.472 309.213 249.799 309.612 250.127C310.011 250.454 308.215 251.437 308.215 251.437C308.215 251.437 304.223 252.802 303.225 252.747Z",
    fill: "#27195D"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M312.803 262.791C313.203 263.501 312.404 263.719 312.404 263.719C312.404 263.719 326.377 263.992 324.98 262.791C323.582 261.59 318.393 259.734 318.991 258.587C319.59 257.441 321.986 257.004 321.986 257.004C321.986 257.004 318.703 255.555 317.993 254.438L317.983 254.423C317.268 253.297 315.6 250.669 315.997 250.289C316.396 249.907 318.792 249.252 317.993 248.87C317.195 248.487 313.203 248.324 311.606 248.487C310.009 248.651 309.61 250.453 309.809 250.671C310.009 250.89 310.608 251.545 310.408 252.091C310.208 252.637 310.408 253.674 310.208 254.547C310.009 255.421 312.404 258.697 312.404 259.406C312.404 260.116 312.404 262.082 312.803 262.791Z",
    fill: "#6771C7"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M312.799 262.791C313.198 263.501 312.4 263.719 312.4 263.719C312.4 263.719 326.373 263.992 324.975 262.791C323.578 261.59 318.388 259.734 318.987 258.587C319.586 257.441 321.981 257.004 321.981 257.004C321.981 257.004 318.698 255.555 317.989 254.438L317.979 254.423C317.264 253.297 315.595 250.669 315.993 250.289V249.579C315.993 249.579 312.799 250.835 312.599 251.49C312.4 252.145 314.795 252.91 314.795 253.401C314.795 253.892 316.592 255.585 316.791 256.458C316.991 257.332 311.945 258.315 311.945 258.315C312.212 258.807 312.4 259.208 312.4 259.406C312.4 260.116 312.4 262.082 312.799 262.791Z",
    fill: "url(#paint293_linear_210_10376)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M310.404 252.09C310.603 251.544 310.004 250.889 309.805 250.67C309.805 250.67 309.811 250.554 309.76 250.404C309.796 249.837 310.302 248.62 311.601 248.487C313.198 248.323 317.191 248.487 317.989 248.869C318.788 249.251 316.392 249.906 315.993 250.288C315.819 250.454 316.04 251.05 316.404 251.762C316.404 251.762 317.191 250.834 317.989 250.124C318.787 249.415 319.386 248.705 319.386 248.323C319.386 247.941 318.987 247.504 317.989 247.285C316.991 247.067 311.601 247.067 310.204 247.285C308.807 247.504 309.006 249.797 309.006 249.797C309.496 249.911 309.686 250.192 309.76 250.404C309.751 250.534 309.768 250.63 309.805 250.67C309.805 250.67 308.807 250.943 308.607 251.216C308.408 251.489 309.006 252.527 309.006 252.745C309.006 252.963 310.304 253.236 310.304 253.236C310.304 252.783 310.301 252.371 310.404 252.09Z",
    fill: "#27195D"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M319.192 258.424C320.789 256.24 333.564 254.93 333.564 254.93C333.564 254.93 335.361 257.496 339.952 258.752C344.543 260.007 341.748 263.174 343.345 263.665C344.942 264.157 347.338 270.817 348.136 272.455C348.934 274.093 350.931 277.041 351.529 278.351C352.128 279.662 350.132 283.92 349.733 284.848C349.334 285.776 357.717 287.36 359.514 288.179C361.31 288.997 363.506 292.328 362.109 293.365C360.712 294.402 359.514 296.805 355.522 297.405C351.529 298.006 341.748 298.279 338.555 298.388C335.361 298.497 334.762 297.405 333.764 297.405C332.766 297.405 327.975 297.842 325.38 297.842C322.785 297.842 318.593 297.405 315.2 297.405C311.806 297.405 303.822 296.586 299.63 296.805C295.438 297.023 295.638 297.842 295.638 297.842C295.638 297.842 282.064 297.623 278.271 297.023C274.479 296.422 244.138 287.633 243.14 286.65C242.141 285.667 244.537 284.029 251.124 282.828C257.711 281.627 263.3 281.736 266.494 281.627C269.688 281.518 270.087 281.136 270.886 280.644C271.684 280.153 269.488 276.823 270.087 275.785C270.686 274.748 272.682 274.639 273.281 273.765C273.88 272.892 270.487 267.651 271.085 266.559C271.684 265.467 283.062 262.464 286.256 262.082C289.45 261.7 293.043 261.754 294.64 261.481C296.237 261.208 298.632 260.499 298.632 260.499C298.632 260.499 295.039 261.645 296.037 262.628C297.035 263.611 321.787 264.266 324.382 263.283C326.977 262.3 317.595 260.608 319.192 258.424Z",
    fill: "url(#paint294_linear_210_10376)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M319.192 258.424C320.789 256.24 333.564 254.93 333.564 254.93C333.564 254.93 335.361 257.496 339.952 258.752C344.543 260.007 341.748 263.174 343.345 263.665C344.942 264.157 347.338 270.817 348.136 272.455C348.934 274.093 350.931 277.041 351.529 278.351C352.128 279.662 350.132 283.92 349.733 284.848C349.334 285.776 357.717 287.36 359.514 288.179C361.31 288.997 363.506 292.328 362.109 293.365C360.712 294.402 359.514 296.805 355.522 297.405C351.529 298.006 341.748 298.279 338.555 298.388C335.361 298.497 334.762 297.405 333.764 297.405C332.766 297.405 327.975 297.842 325.38 297.842C322.785 297.842 318.593 297.405 315.2 297.405C311.806 297.405 303.822 296.586 299.63 296.805C295.438 297.023 295.638 297.842 295.638 297.842C295.638 297.842 282.064 297.623 278.271 297.023C274.479 296.422 244.138 287.633 243.14 286.65C242.141 285.667 244.537 284.029 251.124 282.828C257.711 281.627 263.3 281.736 266.494 281.627C269.688 281.518 270.087 281.136 270.886 280.644C271.684 280.153 269.488 276.823 270.087 275.785C270.686 274.748 272.682 274.639 273.281 273.765C273.88 272.892 270.487 267.651 271.085 266.559C271.684 265.467 283.062 262.464 286.256 262.082C289.45 261.7 293.043 261.754 294.64 261.481C296.237 261.208 298.632 260.499 298.632 260.499C298.632 260.499 295.039 261.645 296.037 262.628C297.035 263.611 321.787 264.266 324.382 263.283C326.977 262.3 317.595 260.608 319.192 258.424Z",
    stroke: "url(#paint295_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M319.192 258.424C320.789 256.24 333.564 254.93 333.564 254.93C333.564 254.93 335.361 257.496 339.952 258.752C344.543 260.007 341.748 263.174 343.345 263.665C344.942 264.157 347.338 270.817 348.136 272.455C348.934 274.093 350.931 277.041 351.529 278.351C352.128 279.662 350.132 283.92 349.733 284.848C349.334 285.776 357.717 287.36 359.514 288.179C361.31 288.997 363.506 292.328 362.109 293.365C360.712 294.402 359.514 296.805 355.522 297.405C351.529 298.006 341.748 298.279 338.555 298.388C335.361 298.497 334.762 297.405 333.764 297.405C332.766 297.405 327.975 297.842 325.38 297.842C322.785 297.842 318.593 297.405 315.2 297.405C311.806 297.405 303.822 296.586 299.63 296.805C295.438 297.023 295.638 297.842 295.638 297.842C295.638 297.842 282.064 297.623 278.271 297.023C274.479 296.422 244.138 287.633 243.14 286.65C242.141 285.667 244.537 284.029 251.124 282.828C257.711 281.627 263.3 281.736 266.494 281.627C269.688 281.518 270.087 281.136 270.886 280.644C271.684 280.153 269.488 276.823 270.087 275.785C270.686 274.748 272.682 274.639 273.281 273.765C273.88 272.892 270.487 267.651 271.085 266.559C271.684 265.467 283.062 262.464 286.256 262.082C289.45 261.7 293.043 261.754 294.64 261.481C296.237 261.208 298.632 260.499 298.632 260.499C298.632 260.499 295.039 261.645 296.037 262.628C297.035 263.611 321.787 264.266 324.382 263.283C326.977 262.3 317.595 260.608 319.192 258.424Z",
    stroke: "url(#paint296_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M319.192 258.424C320.789 256.24 333.564 254.93 333.564 254.93C333.564 254.93 335.361 257.496 339.952 258.752C344.543 260.007 341.748 263.174 343.345 263.665C344.942 264.157 347.338 270.817 348.136 272.455C348.934 274.093 350.931 277.041 351.529 278.351C352.128 279.662 350.132 283.92 349.733 284.848C349.334 285.776 357.717 287.36 359.514 288.179C361.31 288.997 363.506 292.328 362.109 293.365C360.712 294.402 359.514 296.805 355.522 297.405C351.529 298.006 341.748 298.279 338.555 298.388C335.361 298.497 334.762 297.405 333.764 297.405C332.766 297.405 327.975 297.842 325.38 297.842C322.785 297.842 318.593 297.405 315.2 297.405C311.806 297.405 303.822 296.586 299.63 296.805C295.438 297.023 295.638 297.842 295.638 297.842C295.638 297.842 282.064 297.623 278.271 297.023C274.479 296.422 244.138 287.633 243.14 286.65C242.141 285.667 244.537 284.029 251.124 282.828C257.711 281.627 263.3 281.736 266.494 281.627C269.688 281.518 270.087 281.136 270.886 280.644C271.684 280.153 269.488 276.823 270.087 275.785C270.686 274.748 272.682 274.639 273.281 273.765C273.88 272.892 270.487 267.651 271.085 266.559C271.684 265.467 283.062 262.464 286.256 262.082C289.45 261.7 293.043 261.754 294.64 261.481C296.237 261.208 298.632 260.499 298.632 260.499C298.632 260.499 295.039 261.645 296.037 262.628C297.035 263.611 321.787 264.266 324.382 263.283C326.977 262.3 317.595 260.608 319.192 258.424Z",
    stroke: "url(#paint297_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M285.657 293.53C285.058 292.383 285.657 288.998 285.657 288.998C285.657 288.998 288.052 292.383 291.446 291.946C294.839 291.51 297.234 289.981 297.234 289.981C300.598 290.121 302.339 290.191 309.211 290.527C313.823 292.996 314.921 293.31 310.808 293.148C306.695 292.985 302.025 290.855 300.229 290.909C298.432 290.964 296.835 291.4 295.837 291.946C294.839 292.492 295.039 295.441 291.845 295.713C288.651 295.986 286.256 294.676 285.657 293.53Z",
    fill: "url(#paint298_linear_210_10376)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M283.261 295.495C283.86 296.75 282.263 297.296 278.47 297.078C274.678 296.86 261.902 285.831 261.902 285.831C261.902 285.831 274.038 284.66 274.637 283.022C275.236 281.384 270.844 280.729 270.844 280.729C270.844 280.729 271.284 280.481 271.085 279.553C270.885 278.625 284.059 276.223 284.059 276.223C284.059 276.223 286.255 276.823 287.253 277.26C288.251 277.697 293.242 279.253 292.044 279.826C290.846 280.399 279.468 278.734 278.869 279.116C278.271 279.498 295.637 284.357 294.24 284.467C292.842 284.576 266.493 286.432 268.889 287.087C271.284 287.742 282.662 294.239 283.261 295.495Z",
    fill: "url(#paint299_linear_210_10376)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M283.261 295.495C283.86 296.75 282.263 297.296 278.47 297.078C274.678 296.86 261.902 285.831 261.902 285.831C261.902 285.831 274.038 284.66 274.637 283.022C275.236 281.384 270.844 280.729 270.844 280.729C270.844 280.729 271.284 280.481 271.085 279.553C270.885 278.625 284.059 276.223 284.059 276.223C284.059 276.223 286.255 276.823 287.253 277.26C288.251 277.697 293.242 279.253 292.044 279.826C290.846 280.399 279.468 278.734 278.869 279.116C278.271 279.498 295.637 284.357 294.24 284.467C292.842 284.576 266.493 286.432 268.889 287.087C271.284 287.742 282.662 294.239 283.261 295.495Z",
    stroke: "url(#paint300_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M283.261 295.495C283.86 296.75 282.263 297.296 278.47 297.078C274.678 296.86 261.902 285.831 261.902 285.831C261.902 285.831 274.038 284.66 274.637 283.022C275.236 281.384 270.844 280.729 270.844 280.729C270.844 280.729 271.284 280.481 271.085 279.553C270.885 278.625 284.059 276.223 284.059 276.223C284.059 276.223 286.255 276.823 287.253 277.26C288.251 277.697 293.242 279.253 292.044 279.826C290.846 280.399 279.468 278.734 278.869 279.116C278.271 279.498 295.637 284.357 294.24 284.467C292.842 284.576 266.493 286.432 268.889 287.087C271.284 287.742 282.662 294.239 283.261 295.495Z",
    stroke: "url(#paint301_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M278.272 274.258C281.266 274.477 297.435 277.425 297.435 277.425C297.435 277.425 297.235 275.842 294.84 275.623C292.445 275.405 286.855 271.474 286.855 271.474C286.855 271.474 275.278 274.04 278.272 274.258Z",
    fill: "#291F63"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M278.27 274.256C281.264 274.475 297.433 277.423 297.433 277.423L290.446 282.609C290.446 282.609 294.439 282.063 299.429 282.336C304.419 282.609 319.59 284.848 319.59 284.848L300.826 286.104C310.334 288.315 314.335 289.389 316.995 290.744C316.995 290.744 300.028 290.253 297.433 289.98C294.838 289.707 295.836 285.885 294.838 284.739C293.84 283.592 280.266 280.207 278.869 279.279C277.471 278.351 292.443 280.589 292.243 279.716C292.043 278.842 288.849 278.133 285.855 276.822C282.861 275.512 278.869 275.676 278.27 275.294C277.671 274.912 278.27 274.256 278.27 274.256Z",
    fill: "url(#paint302_linear_210_10376)",
    stroke: "url(#paint303_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M299.634 296.805C295.442 297.023 295.642 297.842 295.642 297.842C295.642 297.842 302.629 297.951 304.226 298.88C305.822 299.808 306.022 300.954 305.224 301.063C304.425 301.173 303.427 302.155 303.227 302.374C303.028 302.592 301.631 302.592 301.431 303.193C301.231 303.793 302.629 304.175 302.629 304.175V305.704C302.629 306.141 305.822 307.342 311.212 307.287C316.602 307.233 319.396 306.305 319.396 305.704V304.175C319.396 304.175 320.594 303.629 320.394 303.193C320.195 302.756 318.797 302.374 318.797 302.374C318.797 302.374 317.799 301.227 317.2 301.063C316.602 300.9 317.2 299.917 317.999 299.153C318.797 298.388 325.384 297.842 325.384 297.842C322.789 297.842 318.598 297.406 315.204 297.406C311.811 297.406 303.826 296.587 299.634 296.805Z",
    fill: "#959ACF"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M299.634 296.805C295.442 297.023 295.642 297.842 295.642 297.842C295.642 297.842 302.629 297.951 304.226 298.88C305.822 299.808 306.022 300.954 305.224 301.063C304.425 301.173 303.427 302.155 303.227 302.374C303.028 302.592 301.631 302.592 301.431 303.193C301.231 303.793 302.629 304.175 302.629 304.175V305.704C302.629 306.141 305.822 307.342 311.212 307.287C316.602 307.233 319.396 306.305 319.396 305.704V304.175C319.396 304.175 320.594 303.629 320.394 303.193C320.195 302.756 318.797 302.374 318.797 302.374C318.797 302.374 317.799 301.227 317.2 301.063C316.602 300.9 317.2 299.917 317.999 299.153C318.797 298.388 325.384 297.842 325.384 297.842C322.789 297.842 318.598 297.406 315.204 297.406C311.811 297.406 303.826 296.587 299.634 296.805Z",
    fill: "url(#paint304_radial_210_10376)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M311.614 301.555C310.815 301.555 309.418 301.609 309.418 301.609C309.418 301.609 310.216 301.391 311.214 301.391C312.213 301.391 313.693 301.609 313.693 301.609C313.693 301.609 312.412 301.555 311.614 301.555Z",
    fill: "#505699"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M311.21 301.961C310.333 301.961 309.336 301.944 308.615 301.929C308.615 301.929 309.813 302.156 310.212 302.156C310.611 302.156 310.811 302.101 311.21 302.101C311.609 302.101 311.809 302.21 312.408 302.156C313.007 302.101 313.406 301.946 313.406 301.946C312.835 301.97 311.923 301.961 311.21 301.961Z",
    fill: "#505699"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M311.407 302.974C310.808 302.974 310.409 303.083 310.01 303.083C309.611 303.083 309.211 302.701 309.611 302.592C310.01 302.482 310.609 302.592 311.407 302.592C312.206 302.592 312.405 302.537 313.004 302.592C313.603 302.646 313.204 302.919 312.805 303.028C312.405 303.138 312.006 302.974 311.407 302.974Z",
    fill: "#505699"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M314.804 304.449C313.407 304.394 313.008 304.012 313.008 304.012C313.008 304.012 314.205 303.63 315.603 303.684C317 303.739 317.998 304.394 317.998 304.394C317.998 304.394 316.202 304.503 314.804 304.449Z",
    fill: "#505699"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M307.889 304.433C309.23 304.38 309.613 304.008 309.613 304.008C309.613 304.008 308.464 303.636 307.122 303.689C305.781 303.742 304.823 304.38 304.823 304.38C304.823 304.38 306.547 304.487 307.889 304.433Z",
    fill: "#505699"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M310.415 300.681C307.221 300.736 306.023 301.009 306.023 301.009C306.023 301.009 309.018 299.862 309.816 299.644C310.615 299.426 310.615 299.153 309.816 298.989C309.018 298.825 309.816 297.733 309.816 297.733C309.816 297.733 309.592 298.115 309.816 298.443C310.04 298.77 310.615 298.77 311.014 299.153C311.413 299.535 310.215 299.589 310.415 299.862C310.615 300.135 315.605 300.954 315.605 300.954C315.605 300.954 313.609 300.627 310.415 300.681Z",
    fill: "url(#paint305_linear_210_10376)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M338.555 298.388C335.361 298.497 334.762 297.405 333.764 297.405C333.764 297.405 319.193 292.328 317.196 290.799C315.2 289.27 300.828 286.104 300.828 286.104L320.191 284.848C320.191 284.848 329.373 287.414 331.968 287.25C334.563 287.087 339.952 287.96 342.348 288.67C344.743 289.38 344.144 295.167 347.937 296.095C351.729 297.023 355.522 297.405 355.522 297.405C351.53 298.006 341.749 298.279 338.555 298.388Z",
    fill: "url(#paint306_linear_210_10376)",
    stroke: "url(#paint307_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M331.969 287.252C329.374 287.416 320.191 284.85 320.191 284.85C320.191 284.85 322.188 284.686 323.186 284.359C324.184 284.031 327.577 284.468 329.773 284.14C331.969 283.813 332.368 282.666 334.364 282.284C336.36 281.902 341.151 281.957 344.145 282.175C347.139 282.393 350.333 283.321 350.333 283.321L331.969 287.252Z",
    fill: "url(#paint308_linear_210_10376)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M266.494 281.628C269.688 281.519 270.087 281.136 270.886 280.645C270.886 280.645 277.473 282.228 273.281 283.866C269.089 285.504 245.661 287.678 243.14 286.651C242.141 285.668 244.537 284.03 251.124 282.829C257.711 281.628 263.3 281.737 266.494 281.628Z",
    fill: "url(#paint309_linear_210_10376)",
    stroke: "url(#paint310_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M319.19 258.425C320.787 256.242 333.562 254.931 333.562 254.931C333.562 254.931 335.359 257.497 339.95 258.753C339.95 258.753 333.762 262.083 333.762 265.687C333.762 269.29 336.031 271.331 333.762 274.859C331.78 277.94 322.783 280.373 324.38 282.447C325.977 284.522 320.388 284.795 320.388 284.795C320.388 284.795 317.394 282.557 316.595 282.229C315.797 281.901 319.589 274.094 319.19 272.784C318.791 271.474 324.38 263.284 324.38 263.284C326.975 262.302 317.593 260.609 319.19 258.425Z",
    fill: "url(#paint311_linear_210_10376)",
    stroke: "url(#paint312_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M324.383 263.282C321.788 264.264 297.036 263.609 296.038 262.626C295.696 262.29 295.893 261.934 296.299 261.612C296.414 261.527 296.479 261.48 296.479 261.48C296.416 261.523 296.356 261.567 296.299 261.612C295.432 262.257 291.763 265.11 292.645 266.557C293.643 268.195 299.631 273 298.633 275.565C297.635 278.131 290.648 282.608 290.648 282.608C290.648 282.608 293.243 282.335 298.633 282.335C304.023 282.335 318.395 284.847 319.992 284.847C321.588 284.847 317.995 283.045 316.798 282.335C315.6 281.626 319.193 274.528 319.193 273C319.193 271.471 324.383 263.282 324.383 263.282Z",
    fill: "url(#paint313_linear_210_10376)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M319.193 258.423C317.596 260.606 326.978 262.299 324.383 263.282M324.383 263.282C321.788 264.264 297.036 263.609 296.038 262.626C295.649 262.243 295.958 261.835 296.479 261.48C296.479 261.48 291.647 264.919 292.645 266.557C293.643 268.195 299.631 273 298.633 275.565C297.635 278.131 290.648 282.608 290.648 282.608C290.648 282.608 293.243 282.335 298.633 282.335C304.023 282.335 318.395 284.847 319.992 284.847C321.588 284.847 317.995 283.045 316.798 282.335C315.6 281.626 319.193 274.528 319.193 273C319.193 271.471 324.383 263.282 324.383 263.282Z",
    stroke: "url(#paint314_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M277.671 265.685C272.681 266.723 277.671 270.817 277.671 270.817C277.671 270.817 278.27 265.467 284.258 268.306C290.247 271.145 295.037 273.001 295.037 273.001C295.037 273.001 290.446 266.559 287.652 265.685C284.857 264.812 282.661 264.648 277.671 265.685Z",
    fill: "url(#paint315_linear_210_10376)",
    stroke: "url(#paint316_radial_210_10376)",
    strokeWidth: 1.09872
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter5_i_210_10376)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 22.7559,
    ry: 6.22386,
    transform: "matrix(1 0 0 -1 311.604 305.213)",
    fill: "url(#paint317_linear_210_10376)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 22.7559,
    ry: 6.22386,
    transform: "matrix(1 0 0 -1 311.604 305.213)",
    fill: "url(#paint318_linear_210_10376)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_210_10376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.233 306.468C293.636 306.413 295.233 307.287 295.233 307.287C295.233 307.287 297.229 308.87 300.423 308.979C303.617 309.089 305.613 310.181 307.21 310.126C308.807 310.071 318.588 309.252 316.193 309.089C313.797 308.925 304.67 308.704 302.02 308.215C299.37 307.726 296.83 306.523 295.233 306.468Z",
    fill: "url(#paint319_linear_210_10376)"
  }))), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M263.896 279.007C264.495 279.662 270.284 284.63 270.284 284.63C270.284 284.63 272.679 284.139 273.477 283.811C274.276 283.483 274.475 283.265 274.475 283.265L270.882 280.754C270.882 280.754 271.282 279.935 271.082 279.443C270.882 278.952 270.084 276.987 269.884 276.659C269.685 276.331 270.084 275.949 269.884 275.84C269.685 275.731 268.886 275.84 268.886 275.84C268.886 275.84 269.884 275.512 269.685 275.349C269.485 275.185 268.687 275.239 268.288 275.349C267.888 275.458 263.497 276.823 263.497 277.15C263.497 277.478 263.297 278.351 263.896 279.007Z",
    fill: "url(#paint320_linear_210_10376)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M268.886 275.84C268.886 275.84 269.884 275.512 269.685 275.349C269.485 275.185 268.687 275.239 268.288 275.349C267.888 275.458 263.497 276.823 263.497 277.15C263.497 277.478 263.297 278.351 263.896 279.007C264.495 279.662 270.284 284.63 270.284 284.63C270.284 284.63 272.679 284.139 273.477 283.811C274.276 283.483 274.475 283.265 274.475 283.265L270.882 280.754C270.882 280.754 271.282 279.935 271.082 279.443C270.882 278.952 270.084 276.987 269.884 276.659C269.685 276.331 270.084 275.949 269.884 275.84C269.685 275.731 268.886 275.84 268.886 275.84ZM268.886 275.84C268.886 275.84 268.088 276.058 267.788 276.222M267.788 276.222C267.788 276.222 266.691 276.331 266.691 276.604C266.691 276.877 267.888 277.86 267.888 277.86L267.788 276.222Z",
    stroke: "url(#paint321_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M350.726 289.38C349.129 290.8 344.538 292.056 344.538 292.056L344.534 292.042C344.166 290.817 343.958 290.125 342.941 288.944C342.941 288.944 344.538 288.944 346.135 288.179C347.732 287.415 350.327 285.34 350.327 285.34C350.327 285.34 351.525 284.194 351.724 283.976C351.924 283.757 351.325 283.102 351.525 282.938C351.724 282.774 351.724 282.229 352.922 282.229C354.12 282.229 353.321 283.102 354.12 283.102C354.918 283.102 355.5 282.707 355.717 282.501C355.933 282.296 355.517 282.01 354.918 281.737C354.319 281.464 353.422 281.41 353.571 281.191C353.721 280.973 355.916 281.249 355.916 281.249C355.916 281.249 354.817 280.707 354.469 280.594C354.12 280.481 354.33 280.297 355.517 280.372C356.704 280.447 359.655 281.986 359.709 282.01C359.763 282.034 359.509 281.573 359.509 281.41C359.509 281.246 358.511 281.027 358.511 280.918C358.511 280.809 358.91 280.7 359.509 280.809C360.108 280.918 360.997 281.355 361.106 281.573C361.216 281.792 361.106 282.174 360.707 282.501C360.308 282.829 356.515 283.703 355.916 284.249C355.317 284.794 352.323 287.961 350.726 289.38Z",
    fill: "url(#paint322_linear_210_10376)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M355.916 281.249C355.916 281.249 354.817 280.707 354.469 280.594C354.12 280.481 354.33 280.297 355.517 280.372C356.704 280.447 359.655 281.986 359.709 282.01C359.763 282.034 359.509 281.573 359.509 281.41C359.509 281.246 358.511 281.027 358.511 280.918C358.511 280.809 358.91 280.7 359.509 280.809C360.108 280.918 360.997 281.355 361.106 281.573C361.216 281.792 361.106 282.174 360.707 282.501C360.308 282.829 356.515 283.703 355.916 284.249C355.317 284.794 352.323 287.961 350.726 289.38C349.129 290.8 344.538 292.056 344.538 292.056C344.167 290.822 343.962 290.129 342.941 288.944C342.941 288.944 344.538 288.944 346.135 288.179C347.732 287.415 350.327 285.34 350.327 285.34C350.327 285.34 351.525 284.194 351.724 283.976C351.924 283.757 351.325 283.102 351.525 282.938C351.724 282.774 351.724 282.229 352.922 282.229C354.12 282.229 353.321 283.102 354.12 283.102C354.918 283.102 355.5 282.707 355.717 282.501C355.933 282.296 355.517 282.01 354.918 281.737C354.319 281.464 353.422 281.41 353.571 281.191C353.721 280.973 355.916 281.249 355.916 281.249ZM355.916 281.249C356.315 281.249 357.321 281.687 357.713 282.174",
    stroke: "url(#paint323_radial_210_10376)",
    strokeWidth: 1.09872
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7
  }, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M298.636 260.5C298.836 261.865 299.235 263.176 299.235 263.176C299.235 263.176 310.613 263.885 312.21 263.722C313.807 263.558 312.01 260.664 312.21 259.627C312.409 258.59 309.415 257.443 309.216 255.86C309.016 254.277 308.218 251.438 308.218 251.438C308.218 251.438 304.225 252.803 303.227 252.748C302.229 252.693 301.431 252.53 301.431 252.53C301.431 252.53 301.752 254.562 301.431 255.86C300.977 257.692 298.437 259.136 298.636 260.5Z",
    fill: "#6771C7"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M298.637 260.5C298.836 261.865 299.236 263.176 299.236 263.176C299.236 263.176 310.613 263.885 312.21 263.722C313.807 263.558 312.011 260.664 312.21 259.627C312.41 258.59 309.416 257.443 309.216 255.86C309.017 254.277 308.218 251.438 308.218 251.438C308.218 251.438 308.218 255.423 306.821 257.443C305.423 259.463 298.637 260.5 298.637 260.5Z",
    fill: "url(#paint324_linear_210_10376)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M303.225 252.748C302.227 252.694 301.428 252.53 301.428 252.53C301.428 252.53 299.033 251.001 298.035 250.619C297.037 250.237 298.833 249.473 299.831 249.309C300.829 249.145 303.823 249.527 305.021 249.691C306.219 249.855 306.219 247.234 307.217 247.18C308.215 247.125 307.217 249.254 307.416 249.364C307.616 249.473 309.213 249.8 309.612 250.128C310.011 250.455 308.215 251.438 308.215 251.438C308.215 251.438 304.223 252.803 303.225 252.748Z",
    fill: "#27195D"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M312.803 262.794C313.203 263.504 312.404 263.722 312.404 263.722C312.404 263.722 326.377 263.995 324.98 262.794C323.582 261.593 318.393 259.737 318.991 258.59C319.59 257.444 321.986 257.007 321.986 257.007C321.986 257.007 318.703 255.558 317.993 254.441L317.983 254.426C317.268 253.3 315.6 250.672 315.997 250.292C316.396 249.91 318.792 249.255 317.993 248.872C317.195 248.49 313.203 248.326 311.606 248.49C310.009 248.654 309.61 250.456 309.809 250.674C310.009 250.892 310.608 251.548 310.408 252.094C310.208 252.64 310.408 253.677 310.208 254.55C310.009 255.424 312.404 258.7 312.404 259.409C312.404 260.119 312.404 262.085 312.803 262.794Z",
    fill: "#6771C7"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M312.799 262.794C313.198 263.504 312.4 263.722 312.4 263.722C312.4 263.722 326.373 263.995 324.975 262.794C323.578 261.593 318.388 259.737 318.987 258.59C319.586 257.444 321.981 257.007 321.981 257.007C321.981 257.007 318.698 255.558 317.989 254.441L317.979 254.426C317.264 253.3 315.595 250.672 315.993 250.292V249.582C315.993 249.582 312.799 250.838 312.599 251.493C312.4 252.148 314.795 252.913 314.795 253.404C314.795 253.895 316.592 255.588 316.791 256.461C316.991 257.335 311.945 258.317 311.945 258.317C312.212 258.81 312.4 259.21 312.4 259.409C312.4 260.119 312.4 262.085 312.799 262.794Z",
    fill: "url(#paint325_linear_210_10376)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M310.404 252.093C310.603 251.547 310.004 250.892 309.805 250.673C309.805 250.673 309.811 250.557 309.76 250.407C309.796 249.84 310.302 248.623 311.601 248.489C313.198 248.326 317.191 248.489 317.989 248.872C318.788 249.254 316.392 249.909 315.993 250.291C315.819 250.457 316.04 251.053 316.404 251.765C316.404 251.765 317.191 250.837 317.989 250.127C318.787 249.418 319.386 248.708 319.386 248.326C319.386 247.944 318.987 247.507 317.989 247.288C316.991 247.07 311.601 247.07 310.204 247.288C308.807 247.507 309.006 249.8 309.006 249.8C309.496 249.914 309.686 250.195 309.76 250.407C309.751 250.537 309.768 250.633 309.805 250.673C309.805 250.673 308.807 250.946 308.607 251.219C308.408 251.492 309.006 252.53 309.006 252.748C309.006 252.966 310.304 253.239 310.304 253.239C310.304 252.786 310.301 252.374 310.404 252.093Z",
    fill: "#27195D"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M319.192 258.426C320.789 256.242 333.564 254.932 333.564 254.932C333.564 254.932 335.361 257.498 339.952 258.754C344.543 260.009 341.748 263.176 343.345 263.667C344.942 264.159 347.338 270.819 348.136 272.457C348.934 274.095 350.931 277.043 351.529 278.353C352.128 279.664 350.132 283.922 349.733 284.85C349.334 285.778 357.717 287.362 359.514 288.18C361.31 288.999 363.506 292.33 362.109 293.367C360.712 294.404 359.514 296.807 355.522 297.407C351.529 298.008 341.748 298.281 338.555 298.39C335.361 298.499 334.762 297.407 333.764 297.407C332.766 297.407 327.975 297.844 325.38 297.844C322.785 297.844 318.593 297.407 315.2 297.407C311.806 297.407 303.822 296.588 299.63 296.807C295.438 297.025 295.638 297.844 295.638 297.844C295.638 297.844 282.064 297.625 278.271 297.025C274.479 296.424 244.138 287.635 243.14 286.652C242.141 285.669 244.537 284.031 251.124 282.83C257.711 281.629 263.3 281.738 266.494 281.629C269.688 281.52 270.087 281.138 270.886 280.646C271.684 280.155 269.488 276.825 270.087 275.787C270.686 274.75 272.682 274.641 273.281 273.767C273.88 272.894 270.487 267.653 271.085 266.561C271.684 265.469 283.062 262.466 286.256 262.084C289.45 261.702 293.043 261.756 294.64 261.483C296.237 261.21 298.632 260.501 298.632 260.501C298.632 260.501 295.039 261.647 296.037 262.63C297.035 263.613 321.787 264.268 324.382 263.285C326.977 262.302 317.595 260.61 319.192 258.426Z",
    fill: "url(#paint326_linear_210_10376)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M319.192 258.426C320.789 256.242 333.564 254.932 333.564 254.932C333.564 254.932 335.361 257.498 339.952 258.754C344.543 260.009 341.748 263.176 343.345 263.667C344.942 264.159 347.338 270.819 348.136 272.457C348.934 274.095 350.931 277.043 351.529 278.353C352.128 279.664 350.132 283.922 349.733 284.85C349.334 285.778 357.717 287.362 359.514 288.18C361.31 288.999 363.506 292.33 362.109 293.367C360.712 294.404 359.514 296.807 355.522 297.407C351.529 298.008 341.748 298.281 338.555 298.39C335.361 298.499 334.762 297.407 333.764 297.407C332.766 297.407 327.975 297.844 325.38 297.844C322.785 297.844 318.593 297.407 315.2 297.407C311.806 297.407 303.822 296.588 299.63 296.807C295.438 297.025 295.638 297.844 295.638 297.844C295.638 297.844 282.064 297.625 278.271 297.025C274.479 296.424 244.138 287.635 243.14 286.652C242.141 285.669 244.537 284.031 251.124 282.83C257.711 281.629 263.3 281.738 266.494 281.629C269.688 281.52 270.087 281.138 270.886 280.646C271.684 280.155 269.488 276.825 270.087 275.787C270.686 274.75 272.682 274.641 273.281 273.767C273.88 272.894 270.487 267.653 271.085 266.561C271.684 265.469 283.062 262.466 286.256 262.084C289.45 261.702 293.043 261.756 294.64 261.483C296.237 261.21 298.632 260.501 298.632 260.501C298.632 260.501 295.039 261.647 296.037 262.63C297.035 263.613 321.787 264.268 324.382 263.285C326.977 262.302 317.595 260.61 319.192 258.426Z",
    stroke: "url(#paint327_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M319.192 258.426C320.789 256.242 333.564 254.932 333.564 254.932C333.564 254.932 335.361 257.498 339.952 258.754C344.543 260.009 341.748 263.176 343.345 263.667C344.942 264.159 347.338 270.819 348.136 272.457C348.934 274.095 350.931 277.043 351.529 278.353C352.128 279.664 350.132 283.922 349.733 284.85C349.334 285.778 357.717 287.362 359.514 288.18C361.31 288.999 363.506 292.33 362.109 293.367C360.712 294.404 359.514 296.807 355.522 297.407C351.529 298.008 341.748 298.281 338.555 298.39C335.361 298.499 334.762 297.407 333.764 297.407C332.766 297.407 327.975 297.844 325.38 297.844C322.785 297.844 318.593 297.407 315.2 297.407C311.806 297.407 303.822 296.588 299.63 296.807C295.438 297.025 295.638 297.844 295.638 297.844C295.638 297.844 282.064 297.625 278.271 297.025C274.479 296.424 244.138 287.635 243.14 286.652C242.141 285.669 244.537 284.031 251.124 282.83C257.711 281.629 263.3 281.738 266.494 281.629C269.688 281.52 270.087 281.138 270.886 280.646C271.684 280.155 269.488 276.825 270.087 275.787C270.686 274.75 272.682 274.641 273.281 273.767C273.88 272.894 270.487 267.653 271.085 266.561C271.684 265.469 283.062 262.466 286.256 262.084C289.45 261.702 293.043 261.756 294.64 261.483C296.237 261.21 298.632 260.501 298.632 260.501C298.632 260.501 295.039 261.647 296.037 262.63C297.035 263.613 321.787 264.268 324.382 263.285C326.977 262.302 317.595 260.61 319.192 258.426Z",
    stroke: "url(#paint328_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M319.192 258.426C320.789 256.242 333.564 254.932 333.564 254.932C333.564 254.932 335.361 257.498 339.952 258.754C344.543 260.009 341.748 263.176 343.345 263.667C344.942 264.159 347.338 270.819 348.136 272.457C348.934 274.095 350.931 277.043 351.529 278.353C352.128 279.664 350.132 283.922 349.733 284.85C349.334 285.778 357.717 287.362 359.514 288.18C361.31 288.999 363.506 292.33 362.109 293.367C360.712 294.404 359.514 296.807 355.522 297.407C351.529 298.008 341.748 298.281 338.555 298.39C335.361 298.499 334.762 297.407 333.764 297.407C332.766 297.407 327.975 297.844 325.38 297.844C322.785 297.844 318.593 297.407 315.2 297.407C311.806 297.407 303.822 296.588 299.63 296.807C295.438 297.025 295.638 297.844 295.638 297.844C295.638 297.844 282.064 297.625 278.271 297.025C274.479 296.424 244.138 287.635 243.14 286.652C242.141 285.669 244.537 284.031 251.124 282.83C257.711 281.629 263.3 281.738 266.494 281.629C269.688 281.52 270.087 281.138 270.886 280.646C271.684 280.155 269.488 276.825 270.087 275.787C270.686 274.75 272.682 274.641 273.281 273.767C273.88 272.894 270.487 267.653 271.085 266.561C271.684 265.469 283.062 262.466 286.256 262.084C289.45 261.702 293.043 261.756 294.64 261.483C296.237 261.21 298.632 260.501 298.632 260.501C298.632 260.501 295.039 261.647 296.037 262.63C297.035 263.613 321.787 264.268 324.382 263.285C326.977 262.302 317.595 260.61 319.192 258.426Z",
    stroke: "url(#paint329_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M285.657 293.531C285.058 292.384 285.657 288.999 285.657 288.999C285.657 288.999 288.052 292.384 291.446 291.947C294.839 291.511 297.234 289.982 297.234 289.982C300.598 290.122 302.339 290.192 309.211 290.528C313.823 292.997 314.921 293.311 310.808 293.148C306.695 292.986 302.025 290.855 300.229 290.91C298.432 290.965 296.835 291.401 295.837 291.947C294.839 292.493 295.039 295.441 291.845 295.714C288.651 295.987 286.256 294.677 285.657 293.531Z",
    fill: "url(#paint330_linear_210_10376)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M283.261 295.497C283.86 296.752 282.263 297.298 278.47 297.08C274.678 296.862 261.902 285.833 261.902 285.833C261.902 285.833 274.038 284.662 274.637 283.024C275.236 281.386 270.844 280.731 270.844 280.731C270.844 280.731 271.284 280.483 271.085 279.555C270.885 278.627 284.059 276.225 284.059 276.225C284.059 276.225 286.255 276.825 287.253 277.262C288.251 277.699 293.242 279.255 292.044 279.828C290.846 280.401 279.468 278.736 278.869 279.118C278.271 279.5 295.637 284.359 294.24 284.468C292.842 284.578 266.493 286.434 268.889 287.089C271.284 287.744 282.662 294.241 283.261 295.497Z",
    fill: "url(#paint331_linear_210_10376)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M283.261 295.497C283.86 296.752 282.263 297.298 278.47 297.08C274.678 296.862 261.902 285.833 261.902 285.833C261.902 285.833 274.038 284.662 274.637 283.024C275.236 281.386 270.844 280.731 270.844 280.731C270.844 280.731 271.284 280.483 271.085 279.555C270.885 278.627 284.059 276.225 284.059 276.225C284.059 276.225 286.255 276.825 287.253 277.262C288.251 277.699 293.242 279.255 292.044 279.828C290.846 280.401 279.468 278.736 278.869 279.118C278.271 279.5 295.637 284.359 294.24 284.468C292.842 284.578 266.493 286.434 268.889 287.089C271.284 287.744 282.662 294.241 283.261 295.497Z",
    stroke: "url(#paint332_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M283.261 295.497C283.86 296.752 282.263 297.298 278.47 297.08C274.678 296.862 261.902 285.833 261.902 285.833C261.902 285.833 274.038 284.662 274.637 283.024C275.236 281.386 270.844 280.731 270.844 280.731C270.844 280.731 271.284 280.483 271.085 279.555C270.885 278.627 284.059 276.225 284.059 276.225C284.059 276.225 286.255 276.825 287.253 277.262C288.251 277.699 293.242 279.255 292.044 279.828C290.846 280.401 279.468 278.736 278.869 279.118C278.271 279.5 295.637 284.359 294.24 284.468C292.842 284.578 266.493 286.434 268.889 287.089C271.284 287.744 282.662 294.241 283.261 295.497Z",
    stroke: "url(#paint333_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M278.272 274.26C281.266 274.479 297.435 277.427 297.435 277.427C297.435 277.427 297.235 275.843 294.84 275.625C292.445 275.407 286.855 271.476 286.855 271.476C286.855 271.476 275.278 274.042 278.272 274.26Z",
    fill: "#291F63"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M278.27 274.258C281.264 274.477 297.433 277.425 297.433 277.425L290.446 282.611C290.446 282.611 294.439 282.065 299.429 282.338C304.419 282.611 319.59 284.85 319.59 284.85L300.826 286.105C310.334 288.317 314.335 289.391 316.995 290.746C316.995 290.746 300.028 290.255 297.433 289.982C294.838 289.709 295.836 285.887 294.838 284.741C293.84 283.594 280.266 280.209 278.869 279.281C277.471 278.353 292.443 280.591 292.243 279.718C292.043 278.844 288.849 278.135 285.855 276.824C282.861 275.514 278.869 275.678 278.27 275.296C277.671 274.913 278.27 274.258 278.27 274.258Z",
    fill: "url(#paint334_linear_210_10376)",
    stroke: "url(#paint335_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M299.634 296.807C295.442 297.025 295.642 297.844 295.642 297.844C295.642 297.844 302.629 297.953 304.226 298.882C305.822 299.81 306.022 300.956 305.224 301.065C304.425 301.175 303.427 302.157 303.227 302.376C303.028 302.594 301.631 302.594 301.431 303.195C301.231 303.795 302.629 304.177 302.629 304.177V305.706C302.629 306.143 305.822 307.344 311.212 307.289C316.602 307.235 319.396 306.306 319.396 305.706V304.177C319.396 304.177 320.594 303.631 320.394 303.195C320.195 302.758 318.797 302.376 318.797 302.376C318.797 302.376 317.799 301.229 317.2 301.065C316.602 300.902 317.2 299.919 317.999 299.155C318.797 298.39 325.384 297.844 325.384 297.844C322.789 297.844 318.598 297.407 315.204 297.407C311.811 297.407 303.826 296.589 299.634 296.807Z",
    fill: "#959ACF"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M299.634 296.807C295.442 297.025 295.642 297.844 295.642 297.844C295.642 297.844 302.629 297.953 304.226 298.882C305.822 299.81 306.022 300.956 305.224 301.065C304.425 301.175 303.427 302.157 303.227 302.376C303.028 302.594 301.631 302.594 301.431 303.195C301.231 303.795 302.629 304.177 302.629 304.177V305.706C302.629 306.143 305.822 307.344 311.212 307.289C316.602 307.235 319.396 306.306 319.396 305.706V304.177C319.396 304.177 320.594 303.631 320.394 303.195C320.195 302.758 318.797 302.376 318.797 302.376C318.797 302.376 317.799 301.229 317.2 301.065C316.602 300.902 317.2 299.919 317.999 299.155C318.797 298.39 325.384 297.844 325.384 297.844C322.789 297.844 318.598 297.407 315.204 297.407C311.811 297.407 303.826 296.589 299.634 296.807Z",
    fill: "url(#paint336_radial_210_10376)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M311.614 301.557C310.815 301.557 309.418 301.611 309.418 301.611C309.418 301.611 310.216 301.393 311.214 301.393C312.213 301.393 313.693 301.611 313.693 301.611C313.693 301.611 312.412 301.557 311.614 301.557Z",
    fill: "#505699"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M311.21 301.962C310.333 301.962 309.336 301.946 308.615 301.931C308.615 301.931 309.813 302.158 310.212 302.158C310.611 302.158 310.811 302.103 311.21 302.103C311.609 302.103 311.809 302.212 312.408 302.158C313.007 302.103 313.406 301.948 313.406 301.948C312.835 301.972 311.923 301.962 311.21 301.962Z",
    fill: "#505699"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M311.407 302.976C310.808 302.976 310.409 303.085 310.01 303.085C309.611 303.085 309.211 302.703 309.611 302.594C310.01 302.484 310.609 302.594 311.407 302.594C312.206 302.594 312.405 302.539 313.004 302.594C313.603 302.648 313.204 302.921 312.805 303.03C312.405 303.14 312.006 302.976 311.407 302.976Z",
    fill: "#505699"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M314.804 304.451C313.407 304.396 313.008 304.014 313.008 304.014C313.008 304.014 314.205 303.632 315.603 303.686C317 303.741 317.998 304.396 317.998 304.396C317.998 304.396 316.202 304.505 314.804 304.451Z",
    fill: "#505699"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M307.889 304.435C309.23 304.382 309.613 304.01 309.613 304.01C309.613 304.01 308.464 303.638 307.122 303.691C305.781 303.744 304.823 304.382 304.823 304.382C304.823 304.382 306.547 304.488 307.889 304.435Z",
    fill: "#505699"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M310.415 300.683C307.221 300.738 306.023 301.011 306.023 301.011C306.023 301.011 309.018 299.864 309.816 299.646C310.615 299.427 310.615 299.155 309.816 298.991C309.018 298.827 309.816 297.735 309.816 297.735C309.816 297.735 309.592 298.117 309.816 298.445C310.04 298.772 310.615 298.772 311.014 299.155C311.413 299.537 310.215 299.591 310.415 299.864C310.615 300.137 315.605 300.956 315.605 300.956C315.605 300.956 313.609 300.629 310.415 300.683Z",
    fill: "url(#paint337_linear_210_10376)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M338.555 298.39C335.361 298.499 334.762 297.407 333.764 297.407C333.764 297.407 319.193 292.33 317.196 290.801C315.2 289.272 300.828 286.106 300.828 286.106L320.191 284.85C320.191 284.85 329.373 287.416 331.968 287.252C334.563 287.089 339.952 287.962 342.348 288.672C344.743 289.382 344.144 295.169 347.937 296.097C351.729 297.025 355.522 297.407 355.522 297.407C351.53 298.008 341.749 298.281 338.555 298.39Z",
    fill: "url(#paint338_linear_210_10376)",
    stroke: "url(#paint339_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M331.969 287.253C329.374 287.417 320.191 284.851 320.191 284.851C320.191 284.851 322.188 284.687 323.186 284.36C324.184 284.032 327.577 284.469 329.773 284.141C331.969 283.814 332.368 282.667 334.364 282.285C336.36 281.903 341.151 281.957 344.145 282.176C347.139 282.394 350.333 283.322 350.333 283.322L331.969 287.253Z",
    fill: "url(#paint340_linear_210_10376)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M266.494 281.629C269.688 281.52 270.087 281.137 270.886 280.646C270.886 280.646 277.473 282.229 273.281 283.867C269.089 285.505 245.661 287.679 243.14 286.652C242.141 285.669 244.537 284.031 251.124 282.83C257.711 281.629 263.3 281.738 266.494 281.629Z",
    fill: "url(#paint341_linear_210_10376)",
    stroke: "url(#paint342_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M319.19 258.426C320.787 256.243 333.562 254.932 333.562 254.932C333.562 254.932 335.359 257.498 339.95 258.754C339.95 258.754 333.762 262.084 333.762 265.688C333.762 269.291 336.031 271.332 333.762 274.86C331.78 277.941 322.783 280.374 324.38 282.448C325.977 284.523 320.388 284.796 320.388 284.796C320.388 284.796 317.394 282.557 316.595 282.23C315.797 281.902 319.589 274.095 319.19 272.785C318.791 271.475 324.38 263.285 324.38 263.285C326.975 262.303 317.593 260.61 319.19 258.426Z",
    fill: "url(#paint343_linear_210_10376)",
    stroke: "url(#paint344_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M324.383 263.284C321.788 264.266 297.036 263.611 296.038 262.628C295.696 262.292 295.893 261.936 296.299 261.614C296.414 261.529 296.479 261.482 296.479 261.482C296.416 261.525 296.356 261.569 296.299 261.614C295.432 262.259 291.763 265.112 292.645 266.559C293.643 268.197 299.631 273.001 298.633 275.567C297.635 278.133 290.648 282.61 290.648 282.61C290.648 282.61 293.243 282.337 298.633 282.337C304.023 282.337 318.395 284.849 319.992 284.849C321.588 284.849 317.995 283.047 316.798 282.337C315.6 281.628 319.193 274.53 319.193 273.001C319.193 271.473 324.383 263.284 324.383 263.284Z",
    fill: "url(#paint345_linear_210_10376)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M319.193 258.425C317.596 260.608 326.978 262.301 324.383 263.284M324.383 263.284C321.788 264.266 297.036 263.611 296.038 262.628C295.649 262.245 295.958 261.837 296.479 261.482C296.479 261.482 291.647 264.921 292.645 266.559C293.643 268.197 299.631 273.001 298.633 275.567C297.635 278.133 290.648 282.61 290.648 282.61C290.648 282.61 293.243 282.337 298.633 282.337C304.023 282.337 318.395 284.849 319.992 284.849C321.588 284.849 317.995 283.047 316.798 282.337C315.6 281.628 319.193 274.53 319.193 273.001C319.193 271.473 324.383 263.284 324.383 263.284Z",
    stroke: "url(#paint346_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M277.671 265.687C272.681 266.724 277.671 270.819 277.671 270.819C277.671 270.819 278.27 265.469 284.258 268.308C290.247 271.147 295.037 273.003 295.037 273.003C295.037 273.003 290.446 266.561 287.652 265.687C284.857 264.814 282.661 264.65 277.671 265.687Z",
    fill: "url(#paint347_linear_210_10376)",
    stroke: "url(#paint348_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M263.896 279.009C264.495 279.664 270.284 284.632 270.284 284.632C270.284 284.632 272.679 284.14 273.477 283.813C274.276 283.485 274.475 283.267 274.475 283.267L270.882 280.756C270.882 280.756 271.282 279.937 271.082 279.445C270.882 278.954 270.084 276.988 269.884 276.661C269.685 276.333 270.084 275.951 269.884 275.842C269.685 275.733 268.886 275.842 268.886 275.842C268.886 275.842 269.884 275.514 269.685 275.351C269.485 275.187 268.687 275.241 268.288 275.351C267.888 275.46 263.497 276.825 263.497 277.152C263.497 277.48 263.297 278.353 263.896 279.009Z",
    fill: "url(#paint349_linear_210_10376)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M268.886 275.842C268.886 275.842 269.884 275.514 269.685 275.351C269.485 275.187 268.687 275.241 268.288 275.351C267.888 275.46 263.497 276.825 263.497 277.152C263.497 277.48 263.297 278.353 263.896 279.009C264.495 279.664 270.284 284.632 270.284 284.632C270.284 284.632 272.679 284.14 273.477 283.813C274.276 283.485 274.475 283.267 274.475 283.267L270.882 280.756C270.882 280.756 271.282 279.937 271.082 279.445C270.882 278.954 270.084 276.988 269.884 276.661C269.685 276.333 270.084 275.951 269.884 275.842C269.685 275.733 268.886 275.842 268.886 275.842ZM268.886 275.842C268.886 275.842 268.088 276.06 267.788 276.224M267.788 276.224C267.788 276.224 266.691 276.333 266.691 276.606C266.691 276.879 267.888 277.862 267.888 277.862L267.788 276.224Z",
    stroke: "url(#paint350_radial_210_10376)",
    strokeWidth: 1.09872
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M350.726 289.38C349.129 290.8 344.538 292.056 344.538 292.056L344.534 292.042C344.166 290.817 343.958 290.125 342.941 288.944C342.941 288.944 344.538 288.944 346.135 288.179C347.732 287.415 350.327 285.34 350.327 285.34C350.327 285.34 351.525 284.194 351.724 283.976C351.924 283.757 351.325 283.102 351.525 282.938C351.724 282.774 351.724 282.229 352.922 282.229C354.12 282.229 353.321 283.102 354.12 283.102C354.918 283.102 355.5 282.707 355.717 282.501C355.933 282.296 355.517 282.01 354.918 281.737C354.319 281.464 353.422 281.41 353.571 281.191C353.721 280.973 355.916 281.249 355.916 281.249C355.916 281.249 354.817 280.707 354.469 280.594C354.12 280.481 354.33 280.297 355.517 280.372C356.704 280.447 359.655 281.986 359.709 282.01C359.763 282.034 359.509 281.573 359.509 281.41C359.509 281.246 358.511 281.027 358.511 280.918C358.511 280.809 358.91 280.7 359.509 280.809C360.108 280.918 360.997 281.355 361.106 281.573C361.216 281.792 361.106 282.174 360.707 282.501C360.308 282.829 356.515 283.703 355.916 284.249C355.317 284.794 352.323 287.961 350.726 289.38Z",
    fill: "url(#paint351_linear_210_10376)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M355.916 281.249C355.916 281.249 354.817 280.707 354.469 280.594C354.12 280.481 354.33 280.297 355.517 280.372C356.704 280.447 359.655 281.986 359.709 282.01C359.763 282.034 359.509 281.573 359.509 281.41C359.509 281.246 358.511 281.027 358.511 280.918C358.511 280.809 358.91 280.7 359.509 280.809C360.108 280.918 360.997 281.355 361.106 281.573C361.216 281.792 361.106 282.174 360.707 282.501C360.308 282.829 356.515 283.703 355.916 284.249C355.317 284.794 352.323 287.961 350.726 289.38C349.129 290.8 344.538 292.056 344.538 292.056C344.167 290.822 343.962 290.129 342.941 288.944C342.941 288.944 344.538 288.944 346.135 288.179C347.732 287.415 350.327 285.34 350.327 285.34C350.327 285.34 351.525 284.194 351.724 283.976C351.924 283.757 351.325 283.102 351.525 282.938C351.724 282.774 351.724 282.229 352.922 282.229C354.12 282.229 353.321 283.102 354.12 283.102C354.918 283.102 355.5 282.707 355.717 282.501C355.933 282.296 355.517 282.01 354.918 281.737C354.319 281.464 353.422 281.41 353.571 281.191C353.721 280.973 355.916 281.249 355.916 281.249ZM355.916 281.249C356.315 281.249 357.321 281.687 357.713 282.174",
    stroke: "url(#paint352_radial_210_10376)",
    strokeWidth: 1.09872
  }))), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M204.595 252.756C204.595 252.865 202.799 254.285 202.799 254.449C202.799 254.612 201.601 254.94 201.601 254.94H200.603C200.603 254.94 200.204 254.558 199.006 254.449C197.809 254.339 197.809 255.322 197.809 255.322L198.407 255.486L198.008 255.704C198.008 255.704 198.807 256.578 199.206 256.687C199.605 256.796 201.002 257.342 201.402 257.451C201.801 257.561 204.995 258.652 205.594 258.816C206.192 258.98 208.588 261.218 208.787 261.71C208.987 262.201 211.183 265.695 212.181 266.678C213.179 267.661 215.375 269.353 215.375 269.571V270.281C215.375 270.39 215.574 270.936 218.369 271.1C221.163 271.264 225.954 271.319 225.954 271.319C225.954 271.319 230.545 272.356 231.144 272.465C231.743 272.574 244.119 272.683 244.518 272.356C244.917 272.028 244.718 271.81 244.917 271.701C245.117 271.591 245.716 271.373 245.915 271.319C246.115 271.264 247.313 270.008 247.712 269.844C248.111 269.681 250.307 268.753 250.307 268.261C250.307 267.77 248.91 265.313 248.71 265.04C248.51 264.767 249.109 262.201 249.109 261.983C249.109 261.764 249.708 261.655 250.307 261.328C250.906 261 250.107 260.072 250.307 259.417C250.506 258.762 249.508 257.833 249.508 257.833C249.508 257.833 252.103 256.359 252.503 256.141C252.902 255.923 252.503 255.759 252.902 255.377C253.301 254.995 251.105 254.066 250.906 253.848C250.706 253.63 249.908 253.466 249.508 253.357C249.109 253.247 243.32 251.992 243.32 251.992V251.009C243.32 250.9 242.123 250.518 240.526 250.518C238.929 250.518 237.532 250.9 237.332 251.009C237.132 251.118 236.134 251.883 236.134 251.883C236.134 251.883 234.138 251.773 233.14 251.773C232.142 251.773 213.778 252.429 213.778 252.429C213.778 252.429 212.58 252.046 211.981 251.992C211.382 251.937 210.783 251.282 210.185 251.282H209.187C209.187 251.282 208.987 251.064 208.188 251.064C207.39 251.064 204.396 251.227 204.196 251.555C203.997 251.883 204.595 252.647 204.595 252.756Z",
    fill: "url(#paint353_linear_210_10376)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M218.369 271.101C221.164 271.265 225.954 271.319 225.954 271.319C225.954 271.319 231.743 271.101 232.142 271.046C232.542 270.992 233.141 270.664 233.739 270.664C234.338 270.664 233.939 270.828 234.538 270.828C235.137 270.828 236.135 270.773 236.534 270.773C236.933 270.773 238.73 270.828 239.129 270.773C239.528 270.719 240.726 270.5 241.325 270.5C241.924 270.5 243.121 270.61 243.321 270.61C243.52 270.61 243.72 270.5 244.119 270.446C244.518 270.391 244.918 270.446 245.317 270.446C245.716 270.446 246.714 270.337 246.714 270.337C246.714 270.337 246.515 270.009 246.515 269.9V269.081C246.515 268.917 246.115 267.989 246.115 267.934C246.115 267.88 246.315 267.388 246.315 267.225C246.315 267.061 246.115 266.788 245.916 266.624C245.716 266.46 246.115 266.29 246.115 266.157C246.115 266.024 245.517 264.167 245.517 263.949C245.517 263.731 246.515 262.857 246.515 262.584C246.515 262.311 245.517 261.874 244.718 261.82C243.92 261.765 240.526 261.929 239.927 262.093C239.329 262.257 239.329 262.857 239.329 262.966C239.329 263.075 237.532 263.567 236.933 263.567C236.334 263.567 232.342 263.512 231.544 263.621C230.745 263.731 229.947 264.55 229.747 264.604C229.548 264.659 229.348 264.986 229.348 265.15C229.348 265.314 230.945 266.133 230.945 266.46C230.945 266.788 229.747 267.116 229.548 267.334C229.348 267.552 229.747 268.153 229.148 268.153C228.549 268.153 228.749 267.989 228.549 267.989C228.35 267.989 228.749 267.552 228.15 267.552C227.551 267.552 225.954 267.88 225.853 267.989C225.752 268.098 226.354 269.518 225.555 269.627C224.757 269.736 223.559 269.681 221.164 269.681C218.768 269.681 217.97 269.081 217.571 269.081C217.172 269.081 216.772 269.136 216.772 269.245C216.772 269.354 217.77 269.791 217.371 269.9C216.972 270.009 215.375 269.9 215.375 269.9V270.282C215.375 270.391 215.575 270.937 218.369 271.101Z",
    fill: "url(#paint354_linear_210_10376)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M223.365 272.084C224.313 271.778 224.536 271.598 224.562 271.265C224.337 271.562 224.098 271.73 223.165 272.029C223.165 272.029 222.566 271.865 222.167 271.811C221.768 271.756 220.77 271.702 220.77 271.811C220.77 271.92 220.969 272.084 221.568 272.138C222.167 272.193 222.965 272.193 222.965 272.193C222.965 272.193 223.11 272.519 223.963 272.63C224.817 272.74 225.161 272.684 225.361 272.63C225.56 272.575 225.56 272.411 225.161 272.302C224.762 272.193 223.365 272.084 223.365 272.084Z",
    fill: "url(#paint355_linear_210_10376)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M248.908 269.791C249.107 269.791 248.509 269.518 248.509 269.518C248.509 269.518 249.107 269.736 249.307 269.736C249.507 269.736 249.706 269.518 250.305 269.572C250.904 269.627 250.704 269.736 250.305 269.791C249.906 269.845 249.507 269.845 249.507 269.845C249.507 269.845 249.507 269.955 249.307 270.009C249.107 270.064 248.109 270.118 248.109 270.009C248.109 269.9 248.708 269.791 248.908 269.791Z",
    fill: "url(#paint356_linear_210_10376)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M250.505 261.538C250.705 261.538 250.106 261.265 250.106 261.265C250.106 261.265 250.705 261.483 250.905 261.483C251.104 261.483 251.304 261.265 251.903 261.32C252.502 261.374 252.302 261.483 251.903 261.538C251.504 261.593 251.104 261.593 251.104 261.593C251.104 261.593 251.104 261.702 250.905 261.756C250.705 261.811 249.707 261.865 249.707 261.756C249.707 261.647 250.306 261.538 250.505 261.538Z",
    fill: "url(#paint357_linear_210_10376)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M203.601 258.162L203.6 258.161C203.607 258.439 203.527 258.572 202.801 258.652C202.801 258.652 202.203 258.488 201.803 258.543C201.404 258.598 201.404 258.707 201.803 258.816C202.203 258.925 202.801 258.87 202.801 258.87C202.801 258.87 202.801 259.034 203.201 259.143C203.6 259.253 203.999 259.362 204.398 259.253C204.798 259.143 204.798 259.034 204.398 258.925C203.999 258.816 203.201 258.761 203.201 258.761C203.843 258.526 203.756 258.395 203.601 258.162Z",
    fill: "url(#paint358_linear_210_10376)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M217.492 271.539C217.973 271.376 218.086 271.279 218.1 271.101C217.986 271.26 217.864 271.35 217.391 271.51C217.391 271.51 217.087 271.422 216.885 271.393C216.682 271.364 216.176 271.335 216.176 271.393C216.176 271.451 216.277 271.539 216.581 271.568C216.885 271.597 217.29 271.597 217.29 271.597C217.29 271.597 217.363 271.772 217.796 271.831C218.229 271.89 218.403 271.86 218.505 271.831C218.606 271.802 218.606 271.714 218.403 271.656C218.201 271.597 217.492 271.539 217.492 271.539Z",
    fill: "url(#paint359_linear_210_10376)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M243.318 258.434L243.717 258.598L236.731 258.379L234.335 257.615L229.744 255.704L229.345 255.104L228.746 254.285L230.143 255.267V255.54L234.734 257.67L236.93 258.27L243.318 258.434Z",
    fill: "url(#paint360_linear_210_10376)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M243.719 255.322C244.917 255.541 244.318 255.978 244.917 255.978C245.516 255.978 245.915 255.432 245.715 255.322C245.516 255.213 238.13 253.903 237.331 253.848C236.533 253.794 237.331 254.067 237.331 254.067C237.331 254.067 242.521 255.104 243.719 255.322Z",
    fill: "url(#paint361_linear_210_10376)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M219.967 260.562L214.977 257.177L221.364 260.07H219.967V260.562Z",
    fill: "url(#paint362_linear_210_10376)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M233.736 258.818H232.339L230.742 261.22L231.541 262.039L233.537 261.984L235.134 261.548L233.736 258.818Z",
    fill: "url(#paint363_linear_210_10376)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M214.578 253.41L216.375 253.792C216.375 253.792 225.357 254.557 225.357 254.502C225.357 254.447 224.359 254.175 224.359 254.175L214.578 253.41Z",
    fill: "url(#paint364_linear_210_10376)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M233.342 253.249L224.359 254.177L225.357 254.505L234.34 253.741L233.342 253.249Z",
    fill: "url(#paint365_linear_210_10376)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M216.176 267.553L218.171 267.335C218.171 267.335 218.171 268.044 217.173 268.044C216.176 268.044 216.176 267.553 216.176 267.553Z",
    fill: "url(#paint366_linear_210_10376)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M240.928 267.17C241.726 267.17 241.726 266.515 241.726 266.515H239.73C239.73 266.515 240.13 267.17 240.928 267.17Z",
    fill: "url(#paint367_linear_210_10376)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M238.727 266.787V266.514H237.331C237.331 266.514 237.131 266.733 237.331 266.787C237.53 266.842 237.73 266.896 237.929 266.896C238.129 266.896 238.727 266.842 238.727 266.787Z",
    fill: "url(#paint368_linear_210_10376)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M229.945 272.138C229.945 272.138 230.544 272.356 231.143 272.465C231.742 272.575 243.319 272.738 244.517 272.356C245.116 272.247 244.717 271.701 244.717 271.701C244.717 271.701 243.719 271.374 243.519 271.374C243.319 271.374 241.323 271.647 240.924 271.647H238.529C237.93 271.647 238.129 271.865 237.73 271.865H236.333C236.133 271.865 235.135 271.647 234.536 271.647C233.938 271.647 232.141 271.647 231.742 271.756C231.343 271.865 232.74 271.974 232.141 271.974C231.542 271.974 229.945 272.138 229.945 272.138Z",
    fill: "url(#paint369_linear_210_10376)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M250.902 253.849C250.702 253.631 249.903 253.467 249.504 253.358C249.504 253.358 248.706 253.576 248.307 253.631C247.907 253.686 246.111 254.668 246.31 254.941C246.51 255.214 245.712 257.453 245.911 257.616C246.111 257.78 247.309 258.108 247.508 258.272C247.708 258.435 247.907 259.309 247.907 259.418V261.111C247.907 261.274 246.51 262.366 246.51 262.366V263.84L247.109 264.878L248.845 265.26C248.781 265.154 248.733 265.078 248.706 265.041C248.506 264.768 249.105 262.202 249.105 261.984C249.105 261.766 249.704 261.656 250.303 261.329C250.902 261.001 250.103 260.073 250.303 259.418C250.502 258.763 249.504 257.835 249.504 257.835C249.504 257.835 252.099 256.361 252.498 256.142C252.898 255.924 252.498 255.76 252.898 255.378C253.297 254.996 251.101 254.068 250.902 253.849Z",
    fill: "url(#paint370_linear_210_10376)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M247.914 255.322V258.271L248.513 258.216C248.513 258.216 251.307 255.814 250.908 255.486C250.509 255.159 250.709 254.613 250.709 254.613H249.311C249.311 254.613 249.711 255.322 249.311 255.377C248.912 255.432 247.914 255.322 247.914 255.322Z",
    fill: "url(#paint371_linear_210_10376)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M249.309 255.377C248.91 255.432 247.912 255.323 247.912 255.323C247.912 255.323 247.113 254.613 247.113 254.504C247.113 254.395 248.311 254.231 248.311 254.231L249.323 254.64C249.391 254.769 249.662 255.329 249.309 255.377Z",
    fill: "url(#paint372_linear_210_10376)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M248.509 254.23L249.307 254.612H250.704C250.704 254.612 250.106 254.012 250.106 253.903V253.63L249.507 253.357L248.109 253.684L248.509 254.23Z",
    fill: "url(#paint373_linear_210_10376)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M197.809 255.323L198.407 255.486L200.204 255.377L200.603 254.94C200.603 254.94 200.204 254.558 199.006 254.449C197.809 254.34 197.809 255.323 197.809 255.323Z",
    fill: "url(#paint374_linear_210_10376)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M200.203 255.378L200.602 254.941H201.6L202.798 254.504L203.197 255.651C203.197 255.651 202.798 255.814 202 255.814C201.201 255.814 200.203 255.378 200.203 255.378Z",
    fill: "url(#paint375_linear_210_10376)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M204.597 252.757C204.597 252.866 202.801 254.286 202.801 254.449L203 254.559L205.196 253.903L208.989 253.576C208.989 253.576 217.373 253.139 219.568 253.085C221.764 253.03 232.942 253.303 234.938 253.303C236.935 253.303 247.714 254.013 247.714 254.013L248.113 253.685L249.51 253.357C249.111 253.248 243.322 251.993 243.322 251.993V251.01C243.322 250.901 242.125 250.519 240.528 250.519C238.931 250.519 237.533 250.901 237.334 251.01C237.134 251.119 236.136 251.883 236.136 251.883C236.136 251.883 234.14 251.774 233.142 251.774C232.144 251.774 213.779 252.429 213.779 252.429C213.779 252.429 212.582 252.047 211.983 251.993C211.384 251.938 210.785 251.283 210.186 251.283H209.188C209.188 251.283 208.989 251.064 208.19 251.064C207.392 251.064 204.398 251.228 204.198 251.556C203.998 251.883 204.597 252.648 204.597 252.757Z",
    fill: "url(#paint376_linear_210_10376)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M246.713 270.336C246.713 270.336 246.71 270.331 246.705 270.321C246.73 270.291 246.899 270.195 247.711 269.899C248.909 269.462 250.107 268.643 250.306 268.261C250.506 267.879 248.709 265.204 248.709 265.204C248.709 265.204 247.312 265.04 247.113 264.876C246.913 264.713 246.514 263.839 246.514 263.73V262.583C246.514 262.856 245.516 263.73 245.516 263.948C245.516 264.167 246.114 266.023 246.114 266.156C246.114 266.289 245.715 266.46 245.915 266.623C246.114 266.787 246.314 267.06 246.314 267.224C246.314 267.388 246.114 267.879 246.114 267.934C246.114 267.988 246.514 268.916 246.514 269.08V269.899C246.514 269.995 246.666 270.257 246.705 270.321C246.693 270.336 246.713 270.336 246.713 270.336Z",
    fill: "url(#paint377_linear_210_10376)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M204.197 251.556C203.997 251.883 204.596 252.648 204.596 252.757C204.596 252.757 204.596 253.412 205.395 253.412C206.193 253.412 207.59 252.757 207.59 252.757C207.59 252.757 208.389 252.866 208.389 252.975C208.389 253.085 209.387 253.194 209.786 253.139C210.185 253.085 211.583 252.757 211.583 252.757L213.778 252.429C213.778 252.429 212.581 252.047 211.982 251.993C211.383 251.938 210.784 251.283 210.185 251.283H209.187C209.187 251.283 208.988 251.065 208.189 251.065C207.391 251.065 204.397 251.228 204.197 251.556Z",
    fill: "url(#paint378_linear_210_10376)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M204.197 251.556C203.997 251.883 204.596 252.648 204.596 252.757C204.596 252.757 204.596 253.412 205.395 253.412C206.193 253.412 207.59 252.757 207.59 252.757C207.59 252.757 209.387 252.047 209.187 251.72C208.988 251.392 209.187 251.283 209.187 251.283C209.187 251.283 208.988 251.065 208.189 251.065C207.391 251.065 204.397 251.228 204.197 251.556Z",
    fill: "url(#paint379_linear_210_10376)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M237.33 251.009C237.131 251.119 236.133 251.883 236.133 251.883C236.133 251.883 237.33 252.429 238.129 252.483C238.927 252.538 239.726 252.538 240.125 252.538C240.524 252.538 241.722 253.084 242.121 253.029C242.52 252.975 243.319 251.992 243.319 251.992V251.009C243.319 250.9 242.121 250.518 240.524 250.518C238.927 250.518 237.53 250.9 237.33 251.009Z",
    fill: "url(#paint380_linear_210_10376)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M240.525 250.518C238.928 250.518 237.53 250.9 237.331 251.009C237.331 251.009 237.131 251.173 237.93 251.446C238.728 251.719 240.125 252.538 240.125 252.538C240.525 252.538 241.722 253.084 242.121 253.029C242.521 252.975 243.319 251.992 243.319 251.992V251.009C243.319 250.9 242.121 250.518 240.525 250.518Z",
    fill: "url(#paint381_linear_210_10376)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.19768,
    ry: 0.327572,
    transform: "matrix(1 0 0 -1 219.764 268.481)",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.19768,
    ry: 0.327572,
    transform: "matrix(1 0 0 -1 240.127 267.935)",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M230.745 266.624L225.555 266.896C225.555 266.896 232.741 266.842 233.938 266.842C235.136 266.842 242.322 266.514 242.322 266.514L230.745 266.624Z",
    fill: "url(#paint382_linear_210_10376)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M218.165 267.333L215.57 267.606C215.57 267.606 221.758 266.842 223.355 266.788C224.952 266.733 228.944 266.515 230.741 266.46C232.537 266.405 242.318 266.515 242.318 266.515L230.741 266.624L225.551 266.897L218.165 267.333Z",
    fill: "url(#paint383_linear_210_10376)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M215.57 267.606L218.165 267.333L225.551 266.897L230.741 266.624L242.318 266.515",
    stroke: "url(#paint384_linear_210_10376)",
    strokeWidth: 1.09872
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4
  }, _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M204.595 252.756C204.595 252.865 202.799 254.285 202.799 254.449C202.799 254.612 201.601 254.94 201.601 254.94H200.603C200.603 254.94 200.204 254.558 199.006 254.449C197.809 254.339 197.809 255.322 197.809 255.322L198.407 255.486L198.008 255.704C198.008 255.704 198.807 256.578 199.206 256.687C199.605 256.796 201.002 257.342 201.402 257.451C201.801 257.561 204.995 258.652 205.594 258.816C206.192 258.98 208.588 261.218 208.787 261.71C208.987 262.201 211.183 265.695 212.181 266.678C213.179 267.661 215.375 269.353 215.375 269.571V270.281C215.375 270.39 215.574 270.936 218.369 271.1C221.163 271.264 225.954 271.319 225.954 271.319C225.954 271.319 230.545 272.356 231.144 272.465C231.743 272.574 244.119 272.683 244.518 272.356C244.917 272.028 244.718 271.81 244.917 271.701C245.117 271.591 245.716 271.373 245.915 271.319C246.115 271.264 247.313 270.008 247.712 269.844C248.111 269.681 250.307 268.753 250.307 268.261C250.307 267.77 248.91 265.313 248.71 265.04C248.51 264.767 249.109 262.201 249.109 261.983C249.109 261.764 249.708 261.655 250.307 261.328C250.906 261 250.107 260.072 250.307 259.417C250.506 258.762 249.508 257.833 249.508 257.833C249.508 257.833 252.103 256.359 252.503 256.141C252.902 255.923 252.503 255.759 252.902 255.377C253.301 254.995 251.105 254.066 250.906 253.848C250.706 253.63 249.908 253.466 249.508 253.357C249.109 253.247 243.32 251.992 243.32 251.992V251.009C243.32 250.9 242.123 250.518 240.526 250.518C238.929 250.518 237.532 250.9 237.332 251.009C237.132 251.118 236.134 251.883 236.134 251.883C236.134 251.883 234.138 251.773 233.14 251.773C232.142 251.773 213.778 252.429 213.778 252.429C213.778 252.429 212.58 252.046 211.981 251.992C211.382 251.937 210.783 251.282 210.185 251.282H209.187C209.187 251.282 208.987 251.064 208.188 251.064C207.39 251.064 204.396 251.227 204.196 251.555C203.997 251.883 204.595 252.647 204.595 252.756Z",
    fill: "url(#paint385_linear_210_10376)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M218.369 271.101C221.164 271.265 225.954 271.319 225.954 271.319C225.954 271.319 231.743 271.101 232.142 271.046C232.542 270.992 233.141 270.664 233.739 270.664C234.338 270.664 233.939 270.828 234.538 270.828C235.137 270.828 236.135 270.773 236.534 270.773C236.933 270.773 238.73 270.828 239.129 270.773C239.528 270.719 240.726 270.5 241.325 270.5C241.924 270.5 243.121 270.61 243.321 270.61C243.52 270.61 243.72 270.5 244.119 270.446C244.518 270.391 244.918 270.446 245.317 270.446C245.716 270.446 246.714 270.337 246.714 270.337C246.714 270.337 246.515 270.009 246.515 269.9V269.081C246.515 268.917 246.115 267.989 246.115 267.934C246.115 267.88 246.315 267.388 246.315 267.225C246.315 267.061 246.115 266.788 245.916 266.624C245.716 266.46 246.115 266.29 246.115 266.157C246.115 266.024 245.517 264.167 245.517 263.949C245.517 263.731 246.515 262.857 246.515 262.584C246.515 262.311 245.517 261.874 244.718 261.82C243.92 261.765 240.526 261.929 239.927 262.093C239.329 262.257 239.329 262.857 239.329 262.966C239.329 263.075 237.532 263.567 236.933 263.567C236.334 263.567 232.342 263.512 231.544 263.621C230.745 263.731 229.947 264.55 229.747 264.604C229.548 264.659 229.348 264.986 229.348 265.15C229.348 265.314 230.945 266.133 230.945 266.46C230.945 266.788 229.747 267.116 229.548 267.334C229.348 267.552 229.747 268.153 229.148 268.153C228.549 268.153 228.749 267.989 228.549 267.989C228.35 267.989 228.749 267.552 228.15 267.552C227.551 267.552 225.954 267.88 225.853 267.989C225.752 268.098 226.354 269.518 225.555 269.627C224.757 269.736 223.559 269.681 221.164 269.681C218.768 269.681 217.97 269.081 217.571 269.081C217.172 269.081 216.772 269.136 216.772 269.245C216.772 269.354 217.77 269.791 217.371 269.9C216.972 270.009 215.375 269.9 215.375 269.9V270.282C215.375 270.391 215.575 270.937 218.369 271.101Z",
    fill: "url(#paint386_linear_210_10376)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M223.365 272.084C224.313 271.778 224.536 271.598 224.562 271.265C224.337 271.562 224.098 271.73 223.165 272.029C223.165 272.029 222.566 271.865 222.167 271.811C221.768 271.756 220.77 271.702 220.77 271.811C220.77 271.92 220.969 272.084 221.568 272.138C222.167 272.193 222.965 272.193 222.965 272.193C222.965 272.193 223.11 272.519 223.963 272.63C224.817 272.74 225.161 272.684 225.361 272.63C225.56 272.575 225.56 272.411 225.161 272.302C224.762 272.193 223.365 272.084 223.365 272.084Z",
    fill: "url(#paint387_linear_210_10376)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M248.908 269.791C249.107 269.791 248.509 269.518 248.509 269.518C248.509 269.518 249.107 269.736 249.307 269.736C249.507 269.736 249.706 269.518 250.305 269.572C250.904 269.627 250.704 269.736 250.305 269.791C249.906 269.845 249.507 269.845 249.507 269.845C249.507 269.845 249.507 269.955 249.307 270.009C249.107 270.064 248.109 270.118 248.109 270.009C248.109 269.9 248.708 269.791 248.908 269.791Z",
    fill: "url(#paint388_linear_210_10376)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M250.505 261.538C250.705 261.538 250.106 261.265 250.106 261.265C250.106 261.265 250.705 261.483 250.905 261.483C251.104 261.483 251.304 261.265 251.903 261.32C252.502 261.374 252.302 261.483 251.903 261.538C251.504 261.593 251.104 261.593 251.104 261.593C251.104 261.593 251.104 261.702 250.905 261.756C250.705 261.811 249.707 261.865 249.707 261.756C249.707 261.647 250.306 261.538 250.505 261.538Z",
    fill: "url(#paint389_linear_210_10376)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M203.601 258.162L203.6 258.161C203.607 258.439 203.527 258.572 202.801 258.652C202.801 258.652 202.203 258.488 201.803 258.543C201.404 258.598 201.404 258.707 201.803 258.816C202.203 258.925 202.801 258.87 202.801 258.87C202.801 258.87 202.801 259.034 203.201 259.143C203.6 259.253 203.999 259.362 204.398 259.253C204.798 259.143 204.798 259.034 204.398 258.925C203.999 258.816 203.201 258.761 203.201 258.761C203.843 258.526 203.756 258.395 203.601 258.162Z",
    fill: "url(#paint390_linear_210_10376)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M217.492 271.539C217.973 271.376 218.086 271.279 218.1 271.101C217.986 271.26 217.864 271.35 217.391 271.51C217.391 271.51 217.087 271.422 216.885 271.393C216.682 271.364 216.176 271.335 216.176 271.393C216.176 271.451 216.277 271.539 216.581 271.568C216.885 271.597 217.29 271.597 217.29 271.597C217.29 271.597 217.363 271.772 217.796 271.831C218.229 271.89 218.403 271.86 218.505 271.831C218.606 271.802 218.606 271.714 218.403 271.656C218.201 271.597 217.492 271.539 217.492 271.539Z",
    fill: "url(#paint391_linear_210_10376)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M243.318 258.434L243.717 258.598L236.731 258.379L234.335 257.615L229.744 255.704L229.345 255.104L228.746 254.285L230.143 255.267V255.54L234.734 257.67L236.93 258.27L243.318 258.434Z",
    fill: "url(#paint392_linear_210_10376)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M243.719 255.322C244.917 255.541 244.318 255.978 244.917 255.978C245.516 255.978 245.915 255.432 245.715 255.322C245.516 255.213 238.13 253.903 237.331 253.848C236.533 253.794 237.331 254.067 237.331 254.067C237.331 254.067 242.521 255.104 243.719 255.322Z",
    fill: "url(#paint393_linear_210_10376)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M219.967 260.562L214.977 257.177L221.364 260.07H219.967V260.562Z",
    fill: "url(#paint394_linear_210_10376)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M233.736 258.818H232.339L230.742 261.22L231.541 262.039L233.537 261.984L235.134 261.548L233.736 258.818Z",
    fill: "url(#paint395_linear_210_10376)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M214.578 253.41L216.375 253.792C216.375 253.792 225.357 254.557 225.357 254.502C225.357 254.447 224.359 254.175 224.359 254.175L214.578 253.41Z",
    fill: "url(#paint396_linear_210_10376)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M233.342 253.249L224.359 254.177L225.357 254.505L234.34 253.741L233.342 253.249Z",
    fill: "url(#paint397_linear_210_10376)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M216.176 267.553L218.171 267.335C218.171 267.335 218.171 268.044 217.173 268.044C216.176 268.044 216.176 267.553 216.176 267.553Z",
    fill: "url(#paint398_linear_210_10376)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M240.928 267.17C241.726 267.17 241.726 266.515 241.726 266.515H239.73C239.73 266.515 240.13 267.17 240.928 267.17Z",
    fill: "url(#paint399_linear_210_10376)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M238.727 266.787V266.514H237.331C237.331 266.514 237.131 266.733 237.331 266.787C237.53 266.842 237.73 266.896 237.929 266.896C238.129 266.896 238.727 266.842 238.727 266.787Z",
    fill: "url(#paint400_linear_210_10376)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M229.945 272.138C229.945 272.138 230.544 272.356 231.143 272.465C231.742 272.575 243.319 272.738 244.517 272.356C245.116 272.247 244.717 271.701 244.717 271.701C244.717 271.701 243.719 271.374 243.519 271.374C243.319 271.374 241.323 271.647 240.924 271.647H238.529C237.93 271.647 238.129 271.865 237.73 271.865H236.333C236.133 271.865 235.135 271.647 234.536 271.647C233.938 271.647 232.141 271.647 231.742 271.756C231.343 271.865 232.74 271.974 232.141 271.974C231.542 271.974 229.945 272.138 229.945 272.138Z",
    fill: "url(#paint401_linear_210_10376)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M250.902 253.849C250.702 253.631 249.903 253.467 249.504 253.358C249.504 253.358 248.706 253.576 248.307 253.631C247.907 253.686 246.111 254.668 246.31 254.941C246.51 255.214 245.712 257.453 245.911 257.616C246.111 257.78 247.309 258.108 247.508 258.272C247.708 258.435 247.907 259.309 247.907 259.418V261.111C247.907 261.274 246.51 262.366 246.51 262.366V263.84L247.109 264.878L248.845 265.26C248.781 265.154 248.733 265.078 248.706 265.041C248.506 264.768 249.105 262.202 249.105 261.984C249.105 261.766 249.704 261.656 250.303 261.329C250.902 261.001 250.103 260.073 250.303 259.418C250.502 258.763 249.504 257.835 249.504 257.835C249.504 257.835 252.099 256.361 252.498 256.142C252.898 255.924 252.498 255.76 252.898 255.378C253.297 254.996 251.101 254.068 250.902 253.849Z",
    fill: "url(#paint402_linear_210_10376)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M247.914 255.322V258.271L248.513 258.216C248.513 258.216 251.307 255.814 250.908 255.486C250.509 255.159 250.709 254.613 250.709 254.613H249.311C249.311 254.613 249.711 255.322 249.311 255.377C248.912 255.432 247.914 255.322 247.914 255.322Z",
    fill: "url(#paint403_linear_210_10376)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M249.309 255.377C248.91 255.432 247.912 255.323 247.912 255.323C247.912 255.323 247.113 254.613 247.113 254.504C247.113 254.395 248.311 254.231 248.311 254.231L249.323 254.64C249.391 254.769 249.662 255.329 249.309 255.377Z",
    fill: "url(#paint404_linear_210_10376)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M248.509 254.23L249.307 254.612H250.704C250.704 254.612 250.106 254.012 250.106 253.903V253.63L249.507 253.357L248.109 253.684L248.509 254.23Z",
    fill: "url(#paint405_linear_210_10376)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M197.809 255.323L198.407 255.486L200.204 255.377L200.603 254.94C200.603 254.94 200.204 254.558 199.006 254.449C197.809 254.34 197.809 255.323 197.809 255.323Z",
    fill: "url(#paint406_linear_210_10376)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M200.203 255.378L200.602 254.941H201.6L202.798 254.504L203.197 255.651C203.197 255.651 202.798 255.814 202 255.814C201.201 255.814 200.203 255.378 200.203 255.378Z",
    fill: "url(#paint407_linear_210_10376)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M204.597 252.757C204.597 252.866 202.801 254.286 202.801 254.449L203 254.559L205.196 253.903L208.989 253.576C208.989 253.576 217.373 253.139 219.568 253.085C221.764 253.03 232.942 253.303 234.938 253.303C236.935 253.303 247.714 254.013 247.714 254.013L248.113 253.685L249.51 253.357C249.111 253.248 243.322 251.993 243.322 251.993V251.01C243.322 250.901 242.125 250.519 240.528 250.519C238.931 250.519 237.533 250.901 237.334 251.01C237.134 251.119 236.136 251.883 236.136 251.883C236.136 251.883 234.14 251.774 233.142 251.774C232.144 251.774 213.779 252.429 213.779 252.429C213.779 252.429 212.582 252.047 211.983 251.993C211.384 251.938 210.785 251.283 210.186 251.283H209.188C209.188 251.283 208.989 251.064 208.19 251.064C207.392 251.064 204.398 251.228 204.198 251.556C203.998 251.883 204.597 252.648 204.597 252.757Z",
    fill: "url(#paint408_linear_210_10376)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M246.713 270.336C246.713 270.336 246.71 270.331 246.705 270.321C246.73 270.291 246.899 270.195 247.711 269.899C248.909 269.462 250.107 268.643 250.306 268.261C250.506 267.879 248.709 265.204 248.709 265.204C248.709 265.204 247.312 265.04 247.113 264.876C246.913 264.713 246.514 263.839 246.514 263.73V262.583C246.514 262.856 245.516 263.73 245.516 263.948C245.516 264.167 246.114 266.023 246.114 266.156C246.114 266.289 245.715 266.46 245.915 266.623C246.114 266.787 246.314 267.06 246.314 267.224C246.314 267.388 246.114 267.879 246.114 267.934C246.114 267.988 246.514 268.916 246.514 269.08V269.899C246.514 269.995 246.666 270.257 246.705 270.321C246.693 270.336 246.713 270.336 246.713 270.336Z",
    fill: "url(#paint409_linear_210_10376)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M204.197 251.556C203.997 251.883 204.596 252.648 204.596 252.757C204.596 252.757 204.596 253.412 205.395 253.412C206.193 253.412 207.59 252.757 207.59 252.757C207.59 252.757 208.389 252.866 208.389 252.975C208.389 253.085 209.387 253.194 209.786 253.139C210.185 253.085 211.583 252.757 211.583 252.757L213.778 252.429C213.778 252.429 212.581 252.047 211.982 251.993C211.383 251.938 210.784 251.283 210.185 251.283H209.187C209.187 251.283 208.988 251.065 208.189 251.065C207.391 251.065 204.397 251.228 204.197 251.556Z",
    fill: "url(#paint410_linear_210_10376)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M204.197 251.556C203.997 251.883 204.596 252.648 204.596 252.757C204.596 252.757 204.596 253.412 205.395 253.412C206.193 253.412 207.59 252.757 207.59 252.757C207.59 252.757 209.387 252.047 209.187 251.72C208.988 251.392 209.187 251.283 209.187 251.283C209.187 251.283 208.988 251.065 208.189 251.065C207.391 251.065 204.397 251.228 204.197 251.556Z",
    fill: "url(#paint411_linear_210_10376)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M237.33 251.009C237.131 251.119 236.133 251.883 236.133 251.883C236.133 251.883 237.33 252.429 238.129 252.483C238.927 252.538 239.726 252.538 240.125 252.538C240.524 252.538 241.722 253.084 242.121 253.029C242.52 252.975 243.319 251.992 243.319 251.992V251.009C243.319 250.9 242.121 250.518 240.524 250.518C238.927 250.518 237.53 250.9 237.33 251.009Z",
    fill: "url(#paint412_linear_210_10376)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M240.525 250.518C238.928 250.518 237.53 250.9 237.331 251.009C237.331 251.009 237.131 251.173 237.93 251.446C238.728 251.719 240.125 252.538 240.125 252.538C240.525 252.538 241.722 253.084 242.121 253.029C242.521 252.975 243.319 251.992 243.319 251.992V251.009C243.319 250.9 242.121 250.518 240.525 250.518Z",
    fill: "url(#paint413_linear_210_10376)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.19768,
    ry: 0.327572,
    transform: "matrix(1 0 0 -1 219.764 268.481)",
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.19768,
    ry: 0.327572,
    transform: "matrix(1 0 0 -1 240.127 267.935)",
    fill: "white"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M230.745 266.624L225.555 266.896C225.555 266.896 232.741 266.842 233.938 266.842C235.136 266.842 242.322 266.514 242.322 266.514L230.745 266.624Z",
    fill: "url(#paint414_linear_210_10376)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M218.165 267.333L215.57 267.606C215.57 267.606 221.758 266.842 223.355 266.788C224.952 266.733 228.944 266.515 230.741 266.46C232.537 266.405 242.318 266.515 242.318 266.515L230.741 266.624L225.551 266.897L218.165 267.333Z",
    fill: "url(#paint415_linear_210_10376)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M215.57 267.606L218.165 267.333L225.551 266.897L230.741 266.624L242.318 266.515",
    stroke: "url(#paint416_linear_210_10376)",
    strokeWidth: 1.09872
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_210_10376",
    x: 283.588,
    y: 26.2792,
    width: 48.1467,
    height: 46.9581,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.19744,
    dy: -1.09872
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64808
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_210_10376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_210_10376",
    x: 277.236,
    y: 17.9149,
    width: 50.8245,
    height: 42.0589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.14168,
    result: "effect1_foregroundBlur_210_10376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_210_10376",
    x: 283.588,
    y: 26.2792,
    width: 48.1467,
    height: 46.9581,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.19744,
    dy: -1.09872
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64808
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_210_10376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_210_10376",
    x: 277.236,
    y: 17.9149,
    width: 50.8245,
    height: 42.0589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.14168,
    result: "effect1_foregroundBlur_210_10376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_210_10376",
    x: 187.92,
    y: 237.234,
    width: 294.48,
    height: 91.5231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.94424,
    result: "effect1_foregroundBlur_210_10376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_210_10376",
    x: 286.65,
    y: 297.891,
    width: 47.7092,
    height: 13.546,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.19744,
    dy: -1.09872
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64808
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_210_10376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_210_10376",
    x: 280.24,
    y: 292.182,
    width: 50.6097,
    height: 32.2288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.14168,
    result: "effect1_foregroundBlur_210_10376"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_210_10376",
    x1: 181.494,
    y1: 209.374,
    x2: 212.251,
    y2: -8.76079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(302.687 139.004) rotate(124.025) scale(418.113 36970.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_210_10376",
    x1: 184.81,
    y1: 132.529,
    x2: 225.535,
    y2: 300.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_210_10376",
    x1: 174.559,
    y1: 214.453,
    x2: 199.574,
    y2: 102.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193.902 162.956) rotate(101.81) scale(172.191 6576.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_210_10376",
    x1: 225.733,
    y1: 146.854,
    x2: 268.205,
    y2: 120.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDFE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(247.97 160.478) rotate(101.266) scale(170.483 6227.88)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_210_10376",
    x1: 340.926,
    y1: 51.9908,
    x2: 419.871,
    y2: 115.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(390.784 99.1565) rotate(100.922) scale(220.405 7817.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_210_10376",
    x1: 272.201,
    y1: 210.165,
    x2: 314.906,
    y2: 17.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(305.912 121.385) rotate(101.935) scale(296.993 11456.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_210_10376",
    x1: 374.814,
    y1: 160.012,
    x2: 401.897,
    y2: 148.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDFE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(386.987 170.697) rotate(97.9154) scale(132.39 3443.01)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_210_10376",
    x1: 402.46,
    y1: 214.925,
    x2: 411.37,
    y2: 160.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(415.262 190.206) rotate(106.082) scale(84.1972 4273.07)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_210_10376",
    x1: 425.393,
    y1: 170.402,
    x2: 455.719,
    y2: 151.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDFE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(441.577 179.988) rotate(101.643) scale(120.117 4526.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_210_10376",
    x1: 146.489,
    y1: 217.567,
    x2: 150.039,
    y2: 183.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDFE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(302.687 223.359) rotate(163.099) scale(244.516 12968.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_210_10376",
    x1: 181.494,
    y1: 295.331,
    x2: 243.294,
    y2: 601.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(302.687 396.095) rotate(-115.243) scale(548.594 40347.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_210_10376",
    x1: 1.99998,
    y1: 227.844,
    x2: 533.407,
    y2: 243.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_210_10376",
    x1: 174.559,
    y1: 288.059,
    x2: 223.392,
    y2: 440.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193.902 361.798) rotate(-98.3075) scale(243.905 6648.71)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_210_10376",
    x1: 225.733,
    y1: 384.853,
    x2: 275.2,
    y2: 406.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(247.97 365.346) rotate(-97.9198) scale(241.72 6289.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_210_10376",
    x1: 340.926,
    y1: 520.69,
    x2: 439.826,
    y2: 465.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(390.784 453.152) rotate(-97.6748) scale(312.688 7890.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_210_10376",
    x1: 272.201,
    y1: 294.197,
    x2: 355.65,
    y2: 556.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(305.912 421.323) rotate(-98.3967) scale(420.588 11584.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_210_10376",
    x1: 374.814,
    y1: 366.012,
    x2: 404.26,
    y2: 374.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDFE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(386.987 350.712) rotate(-95.5459) scale(188.65 3459.85)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_210_10376",
    x1: 402.46,
    y1: 287.38,
    x2: 420.248,
    y2: 363.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(415.262 322.774) rotate(-101.384) scale(118.17 4359.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_210_10376",
    x1: 425.393,
    y1: 351.134,
    x2: 461.006,
    y2: 367.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D4D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(441.577 337.408) rotate(-98.1885) scale(170.194 4574.77)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_210_10376",
    x1: 146.489,
    y1: 283.6,
    x2: 153.686,
    y2: 331.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDFE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(302.687 275.306) rotate(-156.487) scale(255.139 17796.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_210_10376",
    x1: 379.783,
    y1: -34.3944,
    x2: 479.007,
    y2: 206.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944142,
    stopColor: "#4B2355"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_210_10376",
    x1: 444.68,
    y1: 54.5081,
    x2: 464.154,
    y2: 178.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EADCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542D59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_210_10376",
    x1: 443.065,
    y1: 162.519,
    x2: 437.275,
    y2: 195.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91778A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C1844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_210_10376",
    x1: 300.582,
    y1: 227.889,
    x2: 397.516,
    y2: 221.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D2557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3662"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_210_10376",
    x1: 314.69,
    y1: 216.625,
    x2: 392.475,
    y2: 227.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A808E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D3863"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_210_10376",
    x1: 356.81,
    y1: 207.172,
    x2: 389.442,
    y2: 219.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216987,
    stopColor: "#7E5D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33123A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_210_10376",
    x1: 407.59,
    y1: 47.2674,
    x2: 441.32,
    y2: 218.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_210_10376",
    x1: 409.724,
    y1: 1.20703,
    x2: 409.724,
    y2: 133.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_210_10376",
    x1: 381.19,
    y1: 47.8701,
    x2: 434.242,
    y2: 135.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_210_10376",
    x1: 376.555,
    y1: 81.8628,
    x2: 431.663,
    y2: 138.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_210_10376",
    x1: 360.233,
    y1: 182.23,
    x2: 430.764,
    y2: 191.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_210_10376",
    x1: 369.098,
    y1: 146.629,
    x2: 427.942,
    y2: 140.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_210_10376",
    x1: 454.953,
    y1: 180.22,
    x2: 423.017,
    y2: 258.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBBB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D2557"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_210_10376",
    x1: 442.958,
    y1: 220.246,
    x2: 442.958,
    y2: 244.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_210_10376",
    x1: 458.796,
    y1: 197.115,
    x2: 458.796,
    y2: 229.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_210_10376",
    x1: 423.428,
    y1: 219.697,
    x2: 423.428,
    y2: 228.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_210_10376",
    x1: 451.643,
    y1: 229.498,
    x2: 451.643,
    y2: 258.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A466A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_210_10376",
    x1: 379.783,
    y1: -34.3944,
    x2: 479.007,
    y2: 206.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944142,
    stopColor: "#4B2355"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_210_10376",
    x1: 444.68,
    y1: 54.5081,
    x2: 464.154,
    y2: 178.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EADCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542D59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_210_10376",
    x1: 443.065,
    y1: 162.519,
    x2: 437.275,
    y2: 195.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91778A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C1844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_210_10376",
    x1: 300.582,
    y1: 227.889,
    x2: 397.516,
    y2: 221.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D2557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3662"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_210_10376",
    x1: 314.69,
    y1: 216.625,
    x2: 392.475,
    y2: 227.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A808E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D3863"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_210_10376",
    x1: 356.81,
    y1: 207.172,
    x2: 389.442,
    y2: 219.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216987,
    stopColor: "#7E5D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33123A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_210_10376",
    x1: 407.59,
    y1: 47.2674,
    x2: 441.32,
    y2: 218.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_210_10376",
    x1: 409.724,
    y1: 1.20703,
    x2: 409.724,
    y2: 133.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_210_10376",
    x1: 381.19,
    y1: 47.8701,
    x2: 434.242,
    y2: 135.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_210_10376",
    x1: 376.555,
    y1: 81.8628,
    x2: 431.663,
    y2: 138.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_210_10376",
    x1: 360.233,
    y1: 182.23,
    x2: 430.764,
    y2: 191.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_210_10376",
    x1: 369.098,
    y1: 146.629,
    x2: 427.942,
    y2: 140.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_210_10376",
    x1: 464.425,
    y1: 163.525,
    x2: 430.476,
    y2: 236.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBBB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D2557"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_210_10376",
    x1: 442.958,
    y1: 220.246,
    x2: 442.958,
    y2: 244.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_210_10376",
    x1: 458.796,
    y1: 197.115,
    x2: 458.796,
    y2: 229.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_210_10376",
    x1: 423.428,
    y1: 219.697,
    x2: 423.428,
    y2: 228.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_210_10376",
    x1: 451.643,
    y1: 229.498,
    x2: 451.643,
    y2: 258.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A466A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_210_10376",
    x1: 295.459,
    y1: 197.943,
    x2: 305.297,
    y2: 239.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_210_10376",
    x1: 305.324,
    y1: 203.172,
    x2: 321.991,
    y2: 242.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_210_10376",
    x1: 268.852,
    y1: 75.249,
    x2: 330.71,
    y2: 242.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210452"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(351.278 90.1332) rotate(104.755) scale(36.3993 27.5809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.865 80.8809) rotate(83.9583) scale(28.721 21.7673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.905 215.643) rotate(-36.1011) scale(30.0893 22.7474)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_210_10376",
    x1: 282.151,
    y1: 85.3054,
    x2: 296.362,
    y2: 110.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4651A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43448E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_210_10376",
    x1: 274.935,
    y1: 80.1035,
    x2: 274.935,
    y2: 157.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201563"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.381 107.832) rotate(109.978) scale(33.1731 14.181)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(258.369 171.794) rotate(-63.0356) scale(36.7834 15.7189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_210_10376",
    x1: 295.825,
    y1: 103.608,
    x2: 274.972,
    y2: 164.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F62B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C266C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.44 105.62) rotate(56.4533) scale(16.4108 11.3885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.548 45.4788) rotate(66.1679) scale(20.4494 15.8326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFF",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969BD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_210_10376",
    x1: 307.95,
    y1: 65.7939,
    x2: 307.95,
    y2: 77.8622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#656BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959ACF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_210_10376",
    x1: 325.481,
    y1: 75.4219,
    x2: 306.599,
    y2: 118.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F7FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5354A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(323.936 87.5285) rotate(86.1915) scale(26.1292 28.9809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_210_10376",
    x1: 332.633,
    y1: 116.453,
    x2: 332.633,
    y2: 135.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342E74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_210_10376",
    x1: 242.25,
    y1: 117.889,
    x2: 255.401,
    y2: 140.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5DAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270E5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(254.543 123.32) rotate(85.2271) scale(12.1102 16.8049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_210_10376",
    x1: 325.529,
    y1: 125.531,
    x2: 325.529,
    y2: 235.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F104E",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318.229 229.921) rotate(-87.8589) scale(53.9424 11.694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_210_10376",
    x1: 304.854,
    y1: 125.331,
    x2: 304.854,
    y2: 222.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5353A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2D8E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(312.987 207.797) rotate(-101.837) scale(40.2794 14.373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_210_10376",
    x1: 275.501,
    y1: 180.443,
    x2: 282.117,
    y2: 198.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595BAD",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413893"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.121 200.356) rotate(-64.9283) scale(9.64637 6.47404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_210_10376",
    x1: 333.655,
    y1: 33.3791,
    x2: 300.732,
    y2: 54.8688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A529A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_210_10376",
    x1: 294.249,
    y1: 67.8065,
    x2: 313.643,
    y2: 51.2772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#725CB0",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_210_10376",
    x1: 306.343,
    y1: 32.2055,
    x2: 293.482,
    y2: 53.5482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3076",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_210_10376",
    x1: 265.711,
    y1: 126.137,
    x2: 262.816,
    y2: 143.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(260.991 147.658) rotate(47.4338) scale(26.2176 8.41451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_210_10376",
    x1: 340.798,
    y1: 101.197,
    x2: 349.836,
    y2: 123.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942546,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(341.781 125.617) rotate(39.3878) scale(37.9394 11.987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_210_10376",
    x1: 295.459,
    y1: 197.942,
    x2: 305.297,
    y2: 239.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_210_10376",
    x1: 305.324,
    y1: 203.172,
    x2: 321.991,
    y2: 242.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_210_10376",
    x1: 268.852,
    y1: 75.249,
    x2: 330.71,
    y2: 242.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210452"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(351.278 90.1332) rotate(104.755) scale(36.3993 27.5809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.865 80.8809) rotate(83.9583) scale(28.721 21.7673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.905 215.643) rotate(-36.1011) scale(30.0893 22.7474)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_210_10376",
    x1: 282.151,
    y1: 85.3054,
    x2: 296.362,
    y2: 110.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4651A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43448E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_210_10376",
    x1: 274.935,
    y1: 80.1035,
    x2: 274.935,
    y2: 157.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201563"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.381 107.832) rotate(109.978) scale(33.1731 14.181)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(258.369 171.794) rotate(-63.0356) scale(36.7834 15.7189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_210_10376",
    x1: 295.825,
    y1: 103.608,
    x2: 274.972,
    y2: 164.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F62B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C266C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.44 105.62) rotate(56.4533) scale(16.4108 11.3885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.548 45.4788) rotate(66.1679) scale(20.4494 15.8326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFF",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969BD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_210_10376",
    x1: 307.95,
    y1: 65.7939,
    x2: 307.95,
    y2: 77.8622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#656BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959ACF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_210_10376",
    x1: 325.481,
    y1: 75.4219,
    x2: 306.599,
    y2: 118.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F7FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5354A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(323.936 87.5285) rotate(86.1915) scale(26.1292 28.9809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_210_10376",
    x1: 332.633,
    y1: 116.453,
    x2: 332.633,
    y2: 135.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342E74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_210_10376",
    x1: 242.25,
    y1: 117.889,
    x2: 255.401,
    y2: 140.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5DAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270E5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(254.543 123.32) rotate(85.2271) scale(12.1102 16.8049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_210_10376",
    x1: 325.529,
    y1: 125.531,
    x2: 325.529,
    y2: 235.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F104E",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318.229 229.921) rotate(-87.8589) scale(53.9424 11.694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_210_10376",
    x1: 304.854,
    y1: 125.331,
    x2: 304.854,
    y2: 222.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5353A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2D8E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(312.987 207.797) rotate(-101.837) scale(40.2794 14.373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_210_10376",
    x1: 275.501,
    y1: 180.443,
    x2: 282.117,
    y2: 198.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595BAD",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413893"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.121 200.356) rotate(-64.9283) scale(9.64637 6.47404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_210_10376",
    x1: 265.711,
    y1: 126.138,
    x2: 262.816,
    y2: 143.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(260.991 147.659) rotate(47.4338) scale(26.2176 8.41451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_210_10376",
    x1: 340.798,
    y1: 101.196,
    x2: 349.836,
    y2: 123.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942546,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(341.781 125.616) rotate(39.3878) scale(37.9394 11.987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_210_10376",
    x1: 295.459,
    y1: 197.943,
    x2: 305.297,
    y2: 239.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_210_10376",
    x1: 305.324,
    y1: 203.172,
    x2: 321.991,
    y2: 242.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_210_10376",
    x1: 268.852,
    y1: 75.249,
    x2: 330.71,
    y2: 242.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210452"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(351.278 90.1332) rotate(104.755) scale(36.3993 27.5809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.865 80.8809) rotate(83.9583) scale(28.721 21.7673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.905 215.643) rotate(-36.1011) scale(30.0893 22.7474)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_210_10376",
    x1: 282.151,
    y1: 85.3054,
    x2: 296.362,
    y2: 110.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4651A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43448E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_210_10376",
    x1: 274.935,
    y1: 80.1035,
    x2: 274.935,
    y2: 157.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201563"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.381 107.832) rotate(109.978) scale(33.1731 14.181)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(258.369 171.794) rotate(-63.0356) scale(36.7834 15.7189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_210_10376",
    x1: 295.825,
    y1: 103.608,
    x2: 274.972,
    y2: 164.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F62B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C266C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.44 105.62) rotate(56.4533) scale(16.4108 11.3885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.548 45.4788) rotate(66.1679) scale(20.4494 15.8326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFF",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969BD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_210_10376",
    x1: 307.95,
    y1: 65.7939,
    x2: 307.95,
    y2: 77.8622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#656BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959ACF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_210_10376",
    x1: 325.481,
    y1: 75.4219,
    x2: 306.599,
    y2: 118.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F7FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5354A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(323.936 87.5285) rotate(86.1915) scale(26.1292 28.9809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_210_10376",
    x1: 332.633,
    y1: 116.453,
    x2: 332.633,
    y2: 135.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342E74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_210_10376",
    x1: 242.25,
    y1: 117.889,
    x2: 255.401,
    y2: 140.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5DAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270E5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(254.543 123.32) rotate(85.2271) scale(12.1102 16.8049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_210_10376",
    x1: 325.529,
    y1: 125.531,
    x2: 325.529,
    y2: 235.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F104E",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318.229 229.921) rotate(-87.8589) scale(53.9424 11.694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_210_10376",
    x1: 304.854,
    y1: 125.331,
    x2: 304.854,
    y2: 222.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5353A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2D8E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(312.987 207.797) rotate(-101.837) scale(40.2794 14.373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_210_10376",
    x1: 275.501,
    y1: 180.443,
    x2: 282.117,
    y2: 198.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595BAD",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413893"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.121 200.356) rotate(-64.9283) scale(9.64637 6.47404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_210_10376",
    x1: 333.655,
    y1: 33.3791,
    x2: 300.732,
    y2: 54.8688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A529A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_210_10376",
    x1: 294.249,
    y1: 67.8065,
    x2: 313.643,
    y2: 51.2772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#725CB0",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_210_10376",
    x1: 306.343,
    y1: 32.2055,
    x2: 293.482,
    y2: 53.5482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3076",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_210_10376",
    x1: 265.711,
    y1: 126.137,
    x2: 262.816,
    y2: 143.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(260.991 147.658) rotate(47.4338) scale(26.2176 8.41451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_210_10376",
    x1: 340.798,
    y1: 101.197,
    x2: 349.836,
    y2: 123.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942546,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(341.781 125.617) rotate(39.3878) scale(37.9394 11.987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_210_10376",
    x1: 295.459,
    y1: 197.942,
    x2: 305.297,
    y2: 239.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_210_10376",
    x1: 305.324,
    y1: 203.172,
    x2: 321.991,
    y2: 242.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_210_10376",
    x1: 268.852,
    y1: 75.249,
    x2: 330.71,
    y2: 242.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210452"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(351.278 90.1332) rotate(104.755) scale(36.3993 27.5809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.865 80.8809) rotate(83.9583) scale(28.721 21.7673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.905 215.643) rotate(-36.1011) scale(30.0893 22.7474)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_210_10376",
    x1: 282.151,
    y1: 85.3054,
    x2: 296.362,
    y2: 110.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4651A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43448E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_210_10376",
    x1: 274.935,
    y1: 80.1035,
    x2: 274.935,
    y2: 157.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201563"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.381 107.832) rotate(109.978) scale(33.1731 14.181)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(258.369 171.794) rotate(-63.0356) scale(36.7834 15.7189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_210_10376",
    x1: 295.825,
    y1: 103.608,
    x2: 274.972,
    y2: 164.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F62B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C266C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.44 105.62) rotate(56.4533) scale(16.4108 11.3885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.548 45.4788) rotate(66.1679) scale(20.4494 15.8326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFF",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969BD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_210_10376",
    x1: 307.95,
    y1: 65.7939,
    x2: 307.95,
    y2: 77.8622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#656BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959ACF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_210_10376",
    x1: 325.481,
    y1: 75.4219,
    x2: 306.599,
    y2: 118.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F7FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5354A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(323.936 87.5285) rotate(86.1915) scale(26.1292 28.9809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_210_10376",
    x1: 332.633,
    y1: 116.453,
    x2: 332.633,
    y2: 135.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342E74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_210_10376",
    x1: 242.25,
    y1: 117.889,
    x2: 255.401,
    y2: 140.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5DAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270E5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(254.543 123.32) rotate(85.2271) scale(12.1102 16.8049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_210_10376",
    x1: 325.529,
    y1: 125.531,
    x2: 325.529,
    y2: 235.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F104E",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318.229 229.921) rotate(-87.8589) scale(53.9424 11.694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_210_10376",
    x1: 304.854,
    y1: 125.331,
    x2: 304.854,
    y2: 222.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5353A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2D8E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(312.987 207.797) rotate(-101.837) scale(40.2794 14.373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_210_10376",
    x1: 275.501,
    y1: 180.443,
    x2: 282.117,
    y2: 198.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595BAD",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413893"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.121 200.356) rotate(-64.9283) scale(9.64637 6.47404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_210_10376",
    x1: 265.711,
    y1: 126.138,
    x2: 262.816,
    y2: 143.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(260.991 147.659) rotate(47.4338) scale(26.2176 8.41451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_210_10376",
    x1: 340.798,
    y1: 101.196,
    x2: 349.836,
    y2: 123.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942546,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(341.781 125.616) rotate(39.3878) scale(37.9394 11.987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_210_10376",
    x1: 216.644,
    y1: 170.758,
    x2: 230.296,
    y2: 252.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4982A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112855"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_210_10376",
    x1: 227.422,
    y1: 175.183,
    x2: 227.422,
    y2: 210.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76C6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#206A6A",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_210_10376",
    x1: 219.431,
    y1: 170.12,
    x2: 221.675,
    y2: 175.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_210_10376",
    x1: 245.955,
    y1: 179.777,
    x2: 244.354,
    y2: 181.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_210_10376",
    x1: 247.569,
    y1: 210.18,
    x2: 245.967,
    y2: 211.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_210_10376",
    x1: 199.214,
    y1: 219.466,
    x2: 201.205,
    y2: 223.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_210_10376",
    x1: 213.623,
    y1: 173.17,
    x2: 214.869,
    y2: 176.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_210_10376",
    x1: 232.663,
    y1: 222.046,
    x2: 232.663,
    y2: 237.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_210_10376",
    x1: 237.852,
    y1: 231.702,
    x2: 237.852,
    y2: 239.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_210_10376",
    x1: 214.424,
    y1: 214.807,
    x2: 214.424,
    y2: 227.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_210_10376",
    x1: 229.342,
    y1: 209.374,
    x2: 229.342,
    y2: 221.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_210_10376",
    x1: 211.805,
    y1: 240.15,
    x2: 222.08,
    y2: 237.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_210_10376",
    x1: 225.613,
    y1: 236.932,
    x2: 225.613,
    y2: 241.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_210_10376",
    x1: 213.422,
    y1: 187.251,
    x2: 213.422,
    y2: 189.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_210_10376",
    x1: 237.203,
    y1: 190.468,
    x2: 237.203,
    y2: 192.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_210_10376",
    x1: 234.429,
    y1: 191.474,
    x2: 234.429,
    y2: 192.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_210_10376",
    x1: 230.75,
    y1: 170.355,
    x2: 237.188,
    y2: 176.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CD3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#427799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_210_10376",
    x1: 245.978,
    y1: 197.508,
    x2: 245.978,
    y2: 241.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#346876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_210_10376",
    x1: 245.988,
    y1: 223.255,
    x2: 245.988,
    y2: 236.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B5279"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_210_10376",
    x1: 243.833,
    y1: 235.16,
    x2: 245.998,
    y2: 238.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_210_10376",
    x1: 244.858,
    y1: 238.138,
    x2: 247.189,
    y2: 241.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_210_10376",
    x1: 196.289,
    y1: 233.512,
    x2: 193.678,
    y2: 237.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_210_10376",
    x1: 197.897,
    y1: 232.305,
    x2: 196.288,
    y2: 235.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_210_10376",
    x1: 201.127,
    y1: 239.747,
    x2: 241.218,
    y2: 252.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24416D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_210_10376",
    x1: 244.465,
    y1: 178.802,
    x2: 244.465,
    y2: 207.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A8D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E4559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_210_10376",
    x1: 206.167,
    y1: 243.167,
    x2: 205.142,
    y2: 249.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#315383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_210_10376",
    x1: 202.829,
    y1: 241.155,
    x2: 202.829,
    y2: 249.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38668A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C203F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_210_10376",
    x1: 236.962,
    y1: 244.704,
    x2: 235.425,
    y2: 251.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#315383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_210_10376",
    x1: 236.792,
    y1: 242.549,
    x2: 236.792,
    y2: 251.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38668A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C203F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_210_10376",
    x1: 226.925,
    y1: 191.675,
    x2: 230.349,
    y2: 192.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#376687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C7E8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_210_10376",
    x1: 217.451,
    y1: 189.463,
    x2: 233.369,
    y2: 193.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D81A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A8DA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_210_10376",
    x1: 211.607,
    y1: 188.859,
    x2: 237.804,
    y2: 192.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DA8C5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505226,
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EC0D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_210_10376",
    x1: 216.644,
    y1: 170.758,
    x2: 230.296,
    y2: 252.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4982A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112855"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_210_10376",
    x1: 227.422,
    y1: 175.183,
    x2: 227.422,
    y2: 210.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76C6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#206A6A",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_210_10376",
    x1: 219.431,
    y1: 170.12,
    x2: 221.675,
    y2: 175.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_210_10376",
    x1: 245.955,
    y1: 179.777,
    x2: 244.354,
    y2: 181.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_210_10376",
    x1: 247.569,
    y1: 210.18,
    x2: 245.967,
    y2: 211.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_210_10376",
    x1: 199.214,
    y1: 219.466,
    x2: 201.205,
    y2: 223.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_210_10376",
    x1: 213.623,
    y1: 173.17,
    x2: 214.869,
    y2: 176.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_210_10376",
    x1: 232.663,
    y1: 222.046,
    x2: 232.663,
    y2: 237.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_210_10376",
    x1: 237.852,
    y1: 231.702,
    x2: 237.852,
    y2: 239.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_210_10376",
    x1: 214.424,
    y1: 214.807,
    x2: 214.424,
    y2: 227.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_210_10376",
    x1: 229.342,
    y1: 209.374,
    x2: 229.342,
    y2: 221.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_210_10376",
    x1: 211.805,
    y1: 240.15,
    x2: 222.08,
    y2: 237.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_210_10376",
    x1: 225.613,
    y1: 236.932,
    x2: 225.613,
    y2: 241.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_210_10376",
    x1: 213.422,
    y1: 187.251,
    x2: 213.422,
    y2: 189.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_210_10376",
    x1: 237.203,
    y1: 190.468,
    x2: 237.203,
    y2: 192.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_210_10376",
    x1: 234.429,
    y1: 191.474,
    x2: 234.429,
    y2: 192.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_210_10376",
    x1: 230.75,
    y1: 170.355,
    x2: 237.188,
    y2: 176.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CD3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#427799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_210_10376",
    x1: 245.978,
    y1: 197.508,
    x2: 245.978,
    y2: 241.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#346876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_210_10376",
    x1: 245.988,
    y1: 223.255,
    x2: 245.988,
    y2: 236.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B5279"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_210_10376",
    x1: 243.833,
    y1: 235.16,
    x2: 245.998,
    y2: 238.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_210_10376",
    x1: 244.858,
    y1: 238.138,
    x2: 247.189,
    y2: 241.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_210_10376",
    x1: 196.289,
    y1: 233.512,
    x2: 193.678,
    y2: 237.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_210_10376",
    x1: 197.897,
    y1: 232.305,
    x2: 196.288,
    y2: 235.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_210_10376",
    x1: 201.127,
    y1: 239.747,
    x2: 241.218,
    y2: 252.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24416D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_210_10376",
    x1: 244.465,
    y1: 178.802,
    x2: 244.465,
    y2: 207.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A8D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E4559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_210_10376",
    x1: 206.167,
    y1: 243.167,
    x2: 205.142,
    y2: 249.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#315383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_210_10376",
    x1: 202.829,
    y1: 241.155,
    x2: 202.829,
    y2: 249.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38668A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C203F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_210_10376",
    x1: 236.962,
    y1: 244.704,
    x2: 235.425,
    y2: 251.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#315383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_210_10376",
    x1: 236.792,
    y1: 242.549,
    x2: 236.792,
    y2: 251.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38668A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C203F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_210_10376",
    x1: 226.925,
    y1: 191.675,
    x2: 230.349,
    y2: 192.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#376687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C7E8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_210_10376",
    x1: 217.451,
    y1: 189.463,
    x2: 233.369,
    y2: 193.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D81A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A8DA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_210_10376",
    x1: 211.607,
    y1: 188.859,
    x2: 237.804,
    y2: 192.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DA8C5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505226,
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EC0D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_210_10376",
    x1: 381.944,
    y1: 328.204,
    x2: 390.464,
    y2: 252.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944142,
    stopColor: "#4B2355"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_210_10376",
    x1: 446.219,
    y1: 304.073,
    x2: 447.701,
    y2: 269.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EADCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542D59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_210_10376",
    x1: 444.624,
    y1: 274.754,
    x2: 444.181,
    y2: 265.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91778A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C1844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_210_10376",
    x1: 303.496,
    y1: 257.012,
    x2: 394.251,
    y2: 279.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D2557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3662"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_210_10376",
    x1: 317.472,
    y1: 260.069,
    x2: 380.605,
    y2: 228.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A808E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D3863"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_210_10376",
    x1: 359.187,
    y1: 262.635,
    x2: 372.164,
    y2: 245.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216987,
    stopColor: "#7E5D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33123A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_210_10376",
    x1: 409.491,
    y1: 306.04,
    x2: 412.089,
    y2: 257.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_210_10376",
    x1: 411.603,
    y1: 318.542,
    x2: 411.603,
    y2: 282.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_210_10376",
    x1: 383.344,
    y1: 305.875,
    x2: 388.588,
    y2: 274.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_210_10376",
    x1: 378.751,
    y1: 296.65,
    x2: 386.158,
    y2: 268.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_210_10376",
    x1: 362.586,
    y1: 269.407,
    x2: 419.895,
    y2: 241.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_210_10376",
    x1: 371.364,
    y1: 279.071,
    x2: 422.59,
    y2: 298.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_210_10376",
    x1: 456.402,
    y1: 269.951,
    x2: 453.667,
    y2: 245.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBBB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D2557"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_210_10376",
    x1: 444.524,
    y1: 259.086,
    x2: 444.524,
    y2: 252.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_210_10376",
    x1: 460.21,
    y1: 265.364,
    x2: 460.21,
    y2: 256.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_210_10376",
    x1: 425.178,
    y1: 259.235,
    x2: 425.178,
    y2: 256.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_210_10376",
    x1: 453.121,
    y1: 256.575,
    x2: 453.121,
    y2: 248.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A466A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_210_10376",
    x1: 381.944,
    y1: 328.204,
    x2: 390.464,
    y2: 252.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944142,
    stopColor: "#4B2355"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_210_10376",
    x1: 446.219,
    y1: 304.073,
    x2: 447.701,
    y2: 269.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EADCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542D59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_210_10376",
    x1: 444.624,
    y1: 274.754,
    x2: 444.181,
    y2: 265.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91778A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C1844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_210_10376",
    x1: 303.496,
    y1: 257.012,
    x2: 394.251,
    y2: 279.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D2557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3662"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_210_10376",
    x1: 317.472,
    y1: 260.069,
    x2: 380.605,
    y2: 228.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A808E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D3863"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_210_10376",
    x1: 359.187,
    y1: 262.635,
    x2: 372.164,
    y2: 245.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216987,
    stopColor: "#7E5D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33123A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_210_10376",
    x1: 409.491,
    y1: 306.04,
    x2: 412.089,
    y2: 257.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_210_10376",
    x1: 411.603,
    y1: 318.542,
    x2: 411.603,
    y2: 282.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_210_10376",
    x1: 383.344,
    y1: 305.875,
    x2: 388.588,
    y2: 274.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_210_10376",
    x1: 378.751,
    y1: 296.65,
    x2: 386.158,
    y2: 268.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_210_10376",
    x1: 362.586,
    y1: 269.407,
    x2: 419.895,
    y2: 241.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_210_10376",
    x1: 371.364,
    y1: 279.071,
    x2: 422.59,
    y2: 298.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F4F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_210_10376",
    x1: 465.784,
    y1: 274.482,
    x2: 462.765,
    y2: 250.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBBB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D2557"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_210_10376",
    x1: 444.524,
    y1: 259.086,
    x2: 444.524,
    y2: 252.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_210_10376",
    x1: 460.21,
    y1: 265.364,
    x2: 460.21,
    y2: 256.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_210_10376",
    x1: 425.178,
    y1: 259.235,
    x2: 425.178,
    y2: 256.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_210_10376",
    x1: 453.121,
    y1: 256.575,
    x2: 453.121,
    y2: 248.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A466A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_210_10376",
    x1: 298.437,
    y1: 265.14,
    x2: 299.207,
    y2: 253.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_210_10376",
    x1: 308.208,
    y1: 263.719,
    x2: 309.646,
    y2: 251.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_210_10376",
    x1: 272.084,
    y1: 298.442,
    x2: 277.263,
    y2: 247.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210452"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint295_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(353.725 294.402) rotate(-133.863) scale(13.2512 20.3684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint296_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.83 296.914) rotate(-68.8824) scale(8.31065 20.2247)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint297_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(279.07 260.335) rotate(11.3012) scale(24.5564 7.49361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_210_10376",
    x1: 285.257,
    y1: 295.713,
    x2: 286.629,
    y2: 286.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4651A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43448E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_210_10376",
    x1: 278.111,
    y1: 297.125,
    x2: 278.111,
    y2: 276.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201563"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint300_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(289.449 289.598) rotate(-142.99) scale(14.0582 8.99651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint301_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.703 272.237) rotate(28.3096) scale(18.7646 8.28416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_210_10376",
    x1: 298.797,
    y1: 290.744,
    x2: 297.079,
    y2: 272.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F62B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C266C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint303_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.435 290.198) rotate(-22.4552) scale(9.71953 5.16966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint304_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310.414 306.523) rotate(-31.8151) scale(9.63118 9.03787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFF",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969BD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_210_10376",
    x1: 310.814,
    y1: 301.009,
    x2: 310.814,
    y2: 297.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#656BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959ACF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_210_10376",
    x1: 328.175,
    y1: 298.396,
    x2: 326.527,
    y2: 284.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F7FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5354A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint307_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.645 295.109) rotate(-76.3463) scale(7.28247 27.9557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_210_10376",
    x1: 335.262,
    y1: 287.26,
    x2: 335.262,
    y2: 282.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342E74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_210_10376",
    x1: 245.735,
    y1: 286.869,
    x2: 247.003,
    y2: 278.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5DAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270E5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint310_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257.911 285.395) rotate(-73.0547) scale(3.42439 15.9777)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_210_10376",
    x1: 328.217,
    y1: 284.795,
    x2: 328.217,
    y2: 254.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F104E",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint312_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320.987 256.46) rotate(82.2313) scale(14.7671 11.4844)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_210_10376",
    x1: 307.744,
    y1: 284.847,
    x2: 307.744,
    y2: 258.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5353A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2D8E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint314_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(315.8 262.463) rotate(127.41) scale(13.4716 11.5538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_210_10376",
    x1: 278.669,
    y1: 269.889,
    x2: 279.221,
    y2: 264.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595BAD",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413893"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint316_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(281.264 264.484) rotate(30.3603) scale(4.69227 3.57823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_210_10376",
    x1: 47.4142,
    y1: 1.62891,
    x2: 40.4458,
    y2: 18.2269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A529A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_210_10376",
    x1: 8.38375,
    y1: 10.9736,
    x2: 11.491,
    y2: 1.3098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#725CB0",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_210_10376",
    x1: 309.206,
    y1: 310.126,
    x2: 307.937,
    y2: 302.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3076",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_210_10376",
    x1: 268.97,
    y1: 284.63,
    x2: 268.749,
    y2: 279.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint321_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(264.295 278.788) rotate(-16.6135) scale(18.3312 3.23551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_210_10376",
    x1: 343.341,
    y1: 291.401,
    x2: 344.115,
    y2: 284.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942546,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint323_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(344.314 284.772) rotate(-12.6804) scale(29.7694 4.10717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_210_10376",
    x1: 298.437,
    y1: 265.141,
    x2: 299.207,
    y2: 253.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_210_10376",
    x1: 308.208,
    y1: 263.722,
    x2: 309.646,
    y2: 251.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_210_10376",
    x1: 272.084,
    y1: 298.444,
    x2: 277.263,
    y2: 247.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210452"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint327_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(353.725 294.404) rotate(-133.863) scale(13.2512 20.3684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint328_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.83 296.916) rotate(-68.8824) scale(8.31065 20.2247)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint329_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(279.07 260.337) rotate(11.3012) scale(24.5564 7.49361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_210_10376",
    x1: 285.257,
    y1: 295.714,
    x2: 286.629,
    y2: 286.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4651A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43448E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_210_10376",
    x1: 278.111,
    y1: 297.127,
    x2: 278.111,
    y2: 276.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201563"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint332_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(289.449 289.6) rotate(-142.99) scale(14.0582 8.99651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint333_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.703 272.239) rotate(28.3096) scale(18.7646 8.28416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_210_10376",
    x1: 298.797,
    y1: 290.746,
    x2: 297.079,
    y2: 272.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F62B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C266C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint335_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.435 290.2) rotate(-22.4552) scale(9.71953 5.16966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint336_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310.414 306.525) rotate(-31.8151) scale(9.63118 9.03787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFF",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969BD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_210_10376",
    x1: 310.814,
    y1: 301.011,
    x2: 310.814,
    y2: 297.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#656BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959ACF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_210_10376",
    x1: 328.175,
    y1: 298.397,
    x2: 326.527,
    y2: 284.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F7FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5354A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint339_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.645 295.111) rotate(-76.3463) scale(7.28247 27.9557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_210_10376",
    x1: 335.262,
    y1: 287.261,
    x2: 335.262,
    y2: 282.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342E74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_210_10376",
    x1: 245.735,
    y1: 286.87,
    x2: 247.003,
    y2: 278.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5DAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270E5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint342_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257.911 285.396) rotate(-73.0547) scale(3.42439 15.9777)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_210_10376",
    x1: 328.217,
    y1: 284.796,
    x2: 328.217,
    y2: 254.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F104E",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint344_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320.987 256.461) rotate(82.2313) scale(14.7671 11.4844)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_210_10376",
    x1: 307.744,
    y1: 284.849,
    x2: 307.744,
    y2: 258.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5353A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2D8E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint346_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(315.8 262.465) rotate(127.41) scale(13.4716 11.5538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_210_10376",
    x1: 278.669,
    y1: 269.891,
    x2: 279.221,
    y2: 264.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595BAD",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413893"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint348_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(281.264 264.486) rotate(30.3603) scale(4.69227 3.57823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_210_10376",
    x1: 268.97,
    y1: 284.632,
    x2: 268.749,
    y2: 279.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint350_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(264.295 278.79) rotate(-16.6135) scale(18.3312 3.23551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_210_10376",
    x1: 343.341,
    y1: 291.401,
    x2: 344.115,
    y2: 284.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6771C6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942546,
    stopColor: "#6771C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint352_radial_210_10376",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(344.314 284.772) rotate(-12.6804) scale(29.7694 4.10717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6771C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_210_10376",
    x1: 220.365,
    y1: 272.52,
    x2: 221.407,
    y2: 249.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4982A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112855"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_210_10376",
    x1: 231.045,
    y1: 271.319,
    x2: 231.045,
    y2: 261.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76C6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#206A6A",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_210_10376",
    x1: 223.131,
    y1: 272.693,
    x2: 223.323,
    y2: 270.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_210_10376",
    x1: 249.396,
    y1: 270.072,
    x2: 249.117,
    y2: 269.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_210_10376",
    x1: 250.994,
    y1: 261.819,
    x2: 250.714,
    y2: 261.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_210_10376",
    x1: 203.101,
    y1: 259.298,
    x2: 203.28,
    y2: 257.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_210_10376",
    x1: 217.373,
    y1: 271.865,
    x2: 217.482,
    y2: 270.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_210_10376",
    x1: 236.232,
    y1: 258.598,
    x2: 236.232,
    y2: 254.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_210_10376",
    x1: 241.372,
    y1: 255.978,
    x2: 241.372,
    y2: 253.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_210_10376",
    x1: 218.17,
    y1: 260.562,
    x2: 218.17,
    y2: 257.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_210_10376",
    x1: 232.938,
    y1: 262.039,
    x2: 232.938,
    y2: 258.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_210_10376",
    x1: 215.576,
    y1: 253.686,
    x2: 221.378,
    y2: 259.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_210_10376",
    x1: 229.25,
    y1: 254.559,
    x2: 229.25,
    y2: 253.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_210_10376",
    x1: 217.173,
    y1: 268.044,
    x2: 217.173,
    y2: 267.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_210_10376",
    x1: 240.728,
    y1: 267.17,
    x2: 240.728,
    y2: 266.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_210_10376",
    x1: 237.985,
    y1: 266.896,
    x2: 237.985,
    y2: 266.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_210_10376",
    x1: 234.337,
    y1: 272.629,
    x2: 235.308,
    y2: 269.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CD3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#427799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_210_10376",
    x1: 249.412,
    y1: 265.26,
    x2: 249.412,
    y2: 253.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#346876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_210_10376",
    x1: 249.431,
    y1: 258.271,
    x2: 249.431,
    y2: 254.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B5279"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_210_10376",
    x1: 247.296,
    y1: 255.039,
    x2: 247.533,
    y2: 253.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_210_10376",
    x1: 248.309,
    y1: 254.23,
    x2: 248.563,
    y2: 252.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_210_10376",
    x1: 200.204,
    y1: 255.486,
    x2: 199.936,
    y2: 253.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_210_10376",
    x1: 201.8,
    y1: 255.814,
    x2: 201.645,
    y2: 254.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_210_10376",
    x1: 204.997,
    y1: 253.794,
    x2: 224.258,
    y2: 232.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24416D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_210_10376",
    x1: 247.919,
    y1: 270.336,
    x2: 247.919,
    y2: 262.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A8D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E4559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_210_10376",
    x1: 209.986,
    y1: 252.866,
    x2: 209.908,
    y2: 251.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#315383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_210_10376",
    x1: 206.68,
    y1: 253.412,
    x2: 206.68,
    y2: 251.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38668A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C203F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_210_10376",
    x1: 240.486,
    y1: 252.448,
    x2: 240.367,
    y2: 250.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#315383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_210_10376",
    x1: 240.314,
    y1: 253.033,
    x2: 240.314,
    y2: 250.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38668A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C203F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_210_10376",
    x1: 230.545,
    y1: 266.842,
    x2: 231.977,
    y2: 264.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#376687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C7E8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_210_10376",
    x1: 221.159,
    y1: 267.443,
    x2: 230.567,
    y2: 259.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D81A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A8DA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_210_10376",
    x1: 215.371,
    y1: 267.606,
    x2: 235.55,
    y2: 256.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DA8C5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505226,
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EC0D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_210_10376",
    x1: 220.365,
    y1: 272.52,
    x2: 221.407,
    y2: 249.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4982A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112855"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_210_10376",
    x1: 231.045,
    y1: 271.319,
    x2: 231.045,
    y2: 261.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76C6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#206A6A",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_210_10376",
    x1: 223.131,
    y1: 272.693,
    x2: 223.323,
    y2: 270.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_210_10376",
    x1: 249.396,
    y1: 270.072,
    x2: 249.117,
    y2: 269.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_210_10376",
    x1: 250.994,
    y1: 261.819,
    x2: 250.714,
    y2: 261.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_210_10376",
    x1: 203.101,
    y1: 259.298,
    x2: 203.28,
    y2: 257.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_210_10376",
    x1: 217.373,
    y1: 271.865,
    x2: 217.482,
    y2: 270.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#457B9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_210_10376",
    x1: 236.232,
    y1: 258.598,
    x2: 236.232,
    y2: 254.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_210_10376",
    x1: 241.372,
    y1: 255.978,
    x2: 241.372,
    y2: 253.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_210_10376",
    x1: 218.17,
    y1: 260.562,
    x2: 218.17,
    y2: 257.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_210_10376",
    x1: 232.938,
    y1: 262.039,
    x2: 232.938,
    y2: 258.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_210_10376",
    x1: 215.576,
    y1: 253.686,
    x2: 221.378,
    y2: 259.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_210_10376",
    x1: 229.25,
    y1: 254.559,
    x2: 229.25,
    y2: 253.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39688C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927091,
    stopColor: "#284C74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_210_10376",
    x1: 217.173,
    y1: 268.044,
    x2: 217.173,
    y2: 267.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_210_10376",
    x1: 240.728,
    y1: 267.17,
    x2: 240.728,
    y2: 266.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_210_10376",
    x1: 237.985,
    y1: 266.896,
    x2: 237.985,
    y2: 266.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_210_10376",
    x1: 234.337,
    y1: 272.629,
    x2: 235.308,
    y2: 269.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CD3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#427799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_210_10376",
    x1: 249.412,
    y1: 265.26,
    x2: 249.412,
    y2: 253.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#346876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_210_10376",
    x1: 249.431,
    y1: 258.271,
    x2: 249.431,
    y2: 254.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B5279"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_210_10376",
    x1: 247.296,
    y1: 255.039,
    x2: 247.533,
    y2: 253.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_210_10376",
    x1: 248.309,
    y1: 254.23,
    x2: 248.563,
    y2: 252.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_210_10376",
    x1: 200.204,
    y1: 255.486,
    x2: 199.936,
    y2: 253.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_210_10376",
    x1: 201.8,
    y1: 255.814,
    x2: 201.645,
    y2: 254.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457B9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_210_10376",
    x1: 204.997,
    y1: 253.794,
    x2: 224.258,
    y2: 232.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24416D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_210_10376",
    x1: 247.919,
    y1: 270.336,
    x2: 247.919,
    y2: 262.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A8D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E4559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_210_10376",
    x1: 209.986,
    y1: 252.866,
    x2: 209.908,
    y2: 251.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#315383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_210_10376",
    x1: 206.68,
    y1: 253.412,
    x2: 206.68,
    y2: 251.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38668A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C203F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_210_10376",
    x1: 240.486,
    y1: 252.448,
    x2: 240.367,
    y2: 250.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#315383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_210_10376",
    x1: 240.314,
    y1: 253.033,
    x2: 240.314,
    y2: 250.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38668A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C203F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_210_10376",
    x1: 230.545,
    y1: 266.842,
    x2: 231.977,
    y2: 264.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#376687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C7E8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_210_10376",
    x1: 221.159,
    y1: 267.443,
    x2: 230.567,
    y2: 259.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D81A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A8DA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_210_10376",
    x1: 215.371,
    y1: 267.606,
    x2: 235.55,
    y2: 256.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DA8C5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505226,
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EC0D9",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHHero);
export default __webpack_public_path__ + "static/media/h-hero.681601d2f90ad9a6edab4a6ef0b10c8d.svg";
export { ForwardRef as ReactComponent };